import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  NgModule,
} from "@angular/core";
import { Helpers } from "../../helpers";
import { ScriptLoaderService } from "../../_services/script-loader.service";
import { CommonService } from "../../../app/_services/common.service";
import { appService } from "../../../app/_services/app.service";
import { timeout, reduce } from "rxjs/operators";
import { ToastrService } from "ngx-toastr/";
import { environment } from "../../../environments/environment";
import { DatePipe } from "@angular/common";
import { CookieService } from "ngx-cookie-service";
import {
  Http,
  Headers,
  RequestOptions,
  Response,
  JSONPBackend,
} from "@angular/http";
import { FreightconfirmationComponent } from "../../../app/freightconfirmation/freightconfirmation.component";
import { OnflyNetworkComponent } from "../../../app/Network/onfly-network/onfly-network.component";
import { OnflyDriverComponent } from "../../../app/Fleet/onfly-driver/onfly-driver.component";
import { Router } from "@angular/router";

import { NavService } from "../../_services/NavService.service";
//add kevin 23/11/2020
import { WaypointsMapComponent } from "../../../app/map/WaypointsMap/Waypoints.component";
//end
// import { LiveTrackingComponent } from "../../LiveTracking/LiveTracking.component";
import { TranslateConfigService } from "../../theme/home/translateConfig.service";
import { TranslateService } from "@ngx-translate/core";
import { DecryptPipe } from "../../auth/_services/encrypt-decrypt.pipe";
import { any } from "@amcharts/amcharts4/.internal/core/utils/Array";
import { VahanComponent } from "../vahan/vahan.component";
// import { TripExpenseComponent } from "../../trip-expense/trip-expense.component";
const LNG_KEY = "SELECTED_LANGUAGE";

declare var jquery: any;
declare var $: any;
declare var mApp: any;
declare var Dropzone: any;
declare var google: any;
declare var moment: any;

@Component({
  selector: "app-booking",
  templateUrl: "./booking.component.html",
})
export class BookingComponent implements OnInit, AfterViewInit {
  tyreData: any = [];
  BudgetHeader: any = [];
  FromDate: any;
  driverTripAssignedList: any = [];
  showAllUlipValidations: boolean = false;
  enableUlipForVehicle: boolean = false;
  enableUlipForDriver: boolean = false;
  isVehValidList: any = [];
  isDriverValidList: any = [];
  vahanDataList: any = [];
  sarathiDataList: any = [];
  sarathiData: any;
  isDriverValid: boolean = false;
  vahanData: any;
  isVehValid: boolean = false;
  currentRate = null;
  selectedLang: string;
  IsApproved: boolean = false;
  today: number = Date.now();
  showBookingList: boolean = true;
  showBookingDetails: boolean = false;
  IsFromCompletedBooking: boolean = false;
  index: any;
  StatusBtnList: any = [];
  TransporterList: any = [];
  Transporter1List: any = [];
  BookingBasicDetail: any = {};
  VehicleConditionType: any = [];

  BookingSummaryDetail: any = {};
  FreightSpent: any = 0;

  LorryReceipt: any = {};
  PrimaryDeliveryDetails: any = [];
  SecondaryDeliveryDetails: any = [];
  FCDetailList: any = [];

  FreightAudit: any = [];
  FreightAuditPrimary: any = [];
  FreightAuditSecondary: any = [];
  FreightAuditAdditional: any = [];
  AdditionalCharges: any = {};
  BillFreightAuditPrimary: any = [];
  BillFreightAuditSecondary: any = [];
  BillFreightAuditAdditional: any = [];
  TotalRate: any = 0;
  TotalMDC: any = 0;
  TotalPODC: any = 0;
  TotalGHC: any = 0;
  tripData: any = [];
  TripHeader: any = [];
  trackingBooking: any = [];

  PrimaryPOD: any = [];
  SecondaryPOD: any = [];
  BookingPOD: any = [];

  BookingInvoiceList: any = [];

  ExpenseParty: any = [];
  PaymentMode: any = [];
  ChargeType: any = [];
  ActionExpense: any = [];
  BookingExpense: any = {};
  PaymentBillAmount: any = 0;
  BookingExpenseList: any = [];
  BookingPayment: any = [];
  PaymentPaidAmount: any = 0;
  ReceiptPaidAmount: any = 0;

  BookingReceipt: any = [];

  RouteDataPrimary: any = [];
  RouteDataSeconadry: any = [];
  RouteDetailPrimary: any = [];
  RouteDetailSecondary: any = [];
  Pcenter: any = {};
  PmapOptions: any = {};
  Pmarker: any = {};
  PCoordinates: any = {};
  Pinfowindow: any = {};
  Pmap: any = {};
  Scenter: any = {};
  SmapOptions: any = {};
  Smarker: any = {};
  SCoordinates: any = {};
  Sinfowindow: any = {};
  Smap: any = {};
  CompanyId: any;
  TenantId: any;
  PrintFCData: any = [];

  BookingStatus: any = [];
  selectFile: any;
  TransporterType: any;
  TransporterIDForSearch: any;
  static bookingComponent: BookingComponent;
  datatable;

  LoadTracking: any = false;
  LoadInvoice: any = false;
  LoadBill: any = false;
  LoadExpense: any = false;
  LoadRoute: any = false;
  TotalQty: any = 0;
  TotalWeight: any = 0;
  TotalCBM: any = 0;
  TotalAmount: any = 0;
  //----------------
  DriverCreateTag: any = false;
  //add by maaria
  isAdvance: any = false;

  // -----------------
  MarkAsAssignList: any = [];

  OrderListForBooking: any = [];
  ReeferModel: string = "";
  IsActiveReefer: boolean = false;
  //------------------

  //change kevin 08/09/2020
  isTransporter: boolean = false;
  isCustomer: boolean = false;
  userCompanyId: any;
  userComanyName: any;
  eWayBillFlag: boolean = true;
  THCFlag: boolean = true;
  UserId: any;
  //end
  //add kevin 14/06/2021
  isFreightExport: any;
  //end
  flag_FuelPumpWiseBill: any = "0";
  fuelPumpList: any = [];
  ContactPersonNameInTripListPageFlag: any = false;
  hostURL = environment.apiUrl;
  isHotShotshostUrl: any = environment.apiUrl == "http://hotshots.com.mx/" ? true : false;

  // added by vithujan
  SystemSettingIdForLeadTimeFlag: any;
  // end
  //added by vithujan 29-12-2022
  VehicleType: any = [];
  //end
  //added by vithujan 10-01-2023
  contextmenu: any = false;
  contextmenuX: any = 0;
  contextmenuY: any = 0;
  //end

  ChargeObj: any = {};
  indexOFOrderForCharge: any = 0;
  THCChargeList: any = [];
  THCChargeListDefalut: any = {};
  totalChargeAmount: any = 0;
  totalAdvance: any = 0;
  THCChargeRemark: any = '';
  //added by vithujan 04-03-2023
  OrdersDeliveryDate: any;
  //end
  //added by vithujan 07-04-2023
  // @ViewChild(TripExpenseComponent) ChildTripExpenseComponent: TripExpenseComponent;
  //added by vithujan 28-04-2023
  AccountDetail: any = {};
  //end
  //added by vithujan 04-05-2023
  ValidateTHCADvanceAmountFlag: boolean = false;
  //end
  productFulfillmentWiseBookingFlag: any = false;
  FVModelBasicData = { pickupLocation: '', pickupAddress: '', pickupLatitude: '0.0', pickupLongitude: '0.0', NearestKM: 50 };
  FVModelListData = [];
  FVMap: any;
  FVBeachMarker: any = [];
  THCAdvancePercentageApproveRejectFlag: any = false;
  tar_THCApproveRejectData: any = [];
  loading: any = false;
  FindVehicleListViewType: any = 'List';
  FindVehicleDetailData: any = [];
  IsAdvanceChargeCode: any = false;


  MobValidationValue: boolean;
  MobValidationDiscription: any;

  LeadTime: any;

  @ViewChild(VahanComponent) vahanComponent: VahanComponent;
  @ViewChild(WaypointsMapComponent) ChildWaypointsMapComponent: WaypointsMapComponent;
  @ViewChild(FreightconfirmationComponent) childComponent: FreightconfirmationComponent;
  @ViewChild(OnflyNetworkComponent) childNetworkComponent: OnflyNetworkComponent;
  @ViewChild(OnflyDriverComponent) ChilddriverComponent: OnflyDriverComponent;
  constructor(
    private _script: ScriptLoaderService,
    private _appService: appService,
    private commonService: CommonService,
    private toastr: ToastrService,
    public datepipe: DatePipe,
    private cookieservice: CookieService,
    private router: Router,
    private _navService: NavService,
    private service: TranslateConfigService,
    private translate: TranslateService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe
  ) {
    BookingComponent.bookingComponent = this;
    let language = this.translate.getBrowserLang();
    let value = localStorage.getItem(LNG_KEY);
    if (value === "" || value === null || value === undefined) {
      this.translate.setDefaultLang(language);
      this.selectedLang = language;
    } else {
      this.service.setLanguage(value);
      this.selectedLang = value;
    }
    let val = localStorage.getItem(LNG_KEY);
  }

  ngOnInit() {
    this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
    this.isTransporter = JSON.parse(localStorage.getItem("isTransporter"));
    this.isCustomer = JSON.parse(localStorage.getItem("isCustomer"));
    this.userCompanyId = JSON.parse(localStorage.getItem("userComanyId"));
    this.userComanyName = JSON.parse(localStorage.getItem("userComanyName"));
    this.TenantId = JSON.parse(localStorage.getItem("ChnageCompnayId")).TenantId;
    // add kevin 08/09/2020
    this.eWayBillFlag = JSON.parse(localStorage.getItem("eWayBillFlag"));
    this.THCFlag = JSON.parse(localStorage.getItem("THCFlag"));
    this.UserId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    // end
    this.ContactPersonNameInTripListPageFlag = JSON.parse(localStorage.getItem("ContactPersonNameInTripListPageFlag"));
    //add kevin 14/06/2021
    this.isFreightExport = JSON.parse(localStorage.getItem("isFreightExport"));
    //end
    this.productFulfillmentWiseBookingFlag = JSON.parse(localStorage.getItem("productFulfillmentWiseBookingFlag"));
    this.THCAdvancePercentageApproveRejectFlag = JSON.parse(localStorage.getItem("THCAdvancePercentageApproveRejectFlag"));

    this.GetUlipSetting();
    this.GetStatusBtnList();
    this.GetTransporterList();
    this.GetBookingsList();
    this.GetVehicleConditionTypeList();
    this.GetTrackingBooking();
    this.GetTrackingStatus();
    this.GetAdditionalCharges();
    this.GetAllAdditionalCharges();
    this.GetExpenseParty();
    this.GetPaymentMode();
    this.GetCharges();
    this.GetActionAddExpense();

    // added by vithujan
    this.getSystemSettingForLeadTime();
    // end
    this.fpp_getFuelPumpWiseBillSetingVal();
    //added by vithujan 29-12-2022
    this.GetVehicleList();
    //end
    //added by vithujan 04-05-2023
    this.LoadValidateTHCADvanceAmount();
    this.RefreshvalidDateCalendar();
    setTimeout(() => {
      this._navService.navItem$.subscribe((item) => {
        if (
          this.CompanyId !=
          JSON.parse(localStorage.getItem("ChnageCompnayId")).Id
        ) {
          this.CompanyId = JSON.parse(
            localStorage.getItem("ChnageCompnayId")
          ).Id;
          BookingComponent.bookingComponent.GetStatusBtnList();
          BookingComponent.bookingComponent.datatable.destroy();
          this.GetBookingsList();
        }
      });
    }, 500);

    $(function () {
      $('[data-toggle="tooltip"]').tooltip({
        trigger: "hover",
      });
      $('[data-toggle="tooltip"]').on("click", function () {
        $(this).tooltip("hide");
      });
    });

    this.getValidate();
  }

  ngAfterViewInit() {
    $("#ModalAssignVehicle").on("shown.bs.modal", function () {
      BookingComponent.bookingComponent.GetSelectDataOfVehicleDriver();
      BookingComponent.bookingComponent.GetSelectDataOfTransporter();
      BookingComponent.bookingComponent.GetSelectDataOfTransporter1Search();
      BookingComponent.bookingComponent.GetDeliveryDate();
      BookingComponent.bookingComponent.RefreshvalidDateCreatedDate();
      // BookingComponent.bookingComponent.CalcHrs();

      // $("#Step_0").addClass("badge-primary");
      if (BookingComponent.bookingComponent.isTransporter === true) {
        var OptionsTransporter = "";
        OptionsTransporter +=
          '<option value="' +
          BookingComponent.bookingComponent.userCompanyId +
          '">' +
          BookingComponent.bookingComponent.userComanyName +
          "</option>";
        $(".TransporterSearch").html(OptionsTransporter);
        $(".TransporterSearch")
          .val(BookingComponent.bookingComponent.userCompanyId)
          .change();
        $(".Transporter1Search").html(OptionsTransporter);
        $(".Transporter1Search")
          .val(BookingComponent.bookingComponent.userCompanyId)
          .change();

        $(".ClsVehicleAssginByTrasporter1").val(
          BookingComponent.bookingComponent.userCompanyId
        );
        $(".ClsTransporterType").val(
          BookingComponent.bookingComponent.userCompanyId
        );
      }
    });
  }
  RefreshvalidDateCreatedDate() {
    setTimeout(() => {
      $(".datetimepickerCreated").datetimepicker({
        todayHighlight: !0,
        orientation: "auto",
        autoclose: true,
        format: "dd/mm/yyyy hh:ii:ss",
        setDate: new Date(),
        templates: {
          leftArrow: '<i class="la la-angle-left"></i>',
          rightArrow: '<i class="la la-angle-right"></i>',
        },
      });
      // if ($("#CreatedDate").val() == "") {
      //   $(this).datetimepicker("initialDate", new Date());
      // } else {
      //   $(this).datetimepicker("initialDate", $("#CreatedDate").val());
      // }
    }, 200);
    //add by maaria on 27-11-2023
    setTimeout(() => {
      $(".datepickeryear").datepicker({
        todayHighlight: !0,
        orientation: "auto",
        autoclose: true,
        format: "yyyy-mm-dd",
        setDate: new Date(),
        templates: {
          leftArrow: '<i class="la la-angle-left"></i>',
          rightArrow: '<i class="la la-angle-right"></i>',
        },
      });
    }, 200);

  }
  // ---------------------------------------------------------------------------------------------

  // ChangeCompany($event) {
  //     this.CompanyId = JSON.parse(localStorage.getItem('ChnageCompnayId')).Id;
  //     BookingComponent.bookingComponent.GetStatusBtnList();
  //     BookingComponent.bookingComponent.datatable.destroy();
  //     this.GetBookingsList();
  // }

  GetConfiguration() {
    $("#Attach_Invoice").on("click", function (e) {
      e.preventDefault();
      $("#upload:hidden").trigger("click");
    });
    var DropzoneAfter = new Dropzone("#dropzoneAfter", {
      url: "../Documents/Uploads",
    });
    var DropzoneBefore = new Dropzone("#dropzoneBefore", {
      url: "../Documents/Uploads",
    });
  }
  //add by maaria on 25-11-2023 for ulip
  ValidateVehicleViaUlip(event: any, i: any) {
    if (this.enableUlipForVehicle) {
      console.log("vahan event", i);
      this.vahanData = {};
      var vehicleNo = $("#DriverVehicleNo_" + i).val();
      if (vehicleNo != '') {
        //Helpers.setLoading(true);
        this._appService
          .GetByOneParam(
            "VehicleMaster",
            "GetVahanData",
            vehicleNo
          )
          .subscribe(
            (response) => {
              this.vahanData = response.vahanData;
              if (this.vahanData && Object.keys(this.vahanData).length > 0) {
                //this.vahanData.RcInsuranceUpto = "2020-08-01T00:00:00"; //to comment
                //this.vahanData.RcFitUpto = "2020-08-01T00:00:00"; //to comment
                //this.vahanData.RcTaxUpto = "2020-08-01T00:00:00"; //to comment
                //if all greater than current date then show unsuccessful else unsuccessful
                var currentDATE = new Date();
                var formattedDate = currentDATE.toISOString().split('T')[0] + 'T00:00:00';
                if (this.vahanData.RcInsuranceUpto > formattedDate && this.vahanData.RcFitUpto > formattedDate && this.vahanData.RcTaxUpto > formattedDate) {
                  this.isVehValid = true;
                  //Helpers.setLoading(false);
                  $("#ulipValidationModal").modal('show');
                }
                else {
                  this.isVehValid = false;
                  //Helpers.setLoading(false);
                  $("#ulipValidationModal").modal('show');
                }
              }
              else {
                this.isVehValid = false;
                //Helpers.setLoading(false);
                $("#ulipValidationModal").modal('show');
              }
            },
            (err) => {
              //Helpers.setLoading(false);
              this.toastr.error("An error occured !", "error");
            }
          );

      }
      else {
        this.toastr.warning("Please enter vehicle No. to validate via Ulip!", "warning");
      }

    }
  }

  //add by maaria on 30-11-2023
  ValidateBothViaUlip() {
    this.showAllUlipValidations = false;
    this.vahanDataList = [];
    this.sarathiDataList = [];
    this.isVehValidList = [];
    this.isDriverValidList = [];

    this.MarkAsAssignList.forEach((element, index) => {
      if (this.enableUlipForVehicle) {
        this.vahanData = {};
        this.isVehValid = false;
        var vehicleNo = $("#DriverVehicleNo_" + index).val();
        if (vehicleNo != '') {
          this._appService
            .GetByOneParam(
              "VehicleMaster",
              "GetVahanData",
              vehicleNo
            )
            .subscribe(
              (response) => {
                this.vahanData = response.vahanData;
                if (this.vahanData && Object.keys(this.vahanData).length > 0) {
                  //this.vahanData.RcInsuranceUpto = "2020-08-01T00:00:00"; //to comment
                  //this.vahanData.RcFitUpto = "2020-08-01T00:00:00"; //to comment
                  //this.vahanData.RcTaxUpto = "2020-08-01T00:00:00"; //to comment
                  //if all greater than current date then show unsuccessful else unsuccessful
                  var currentDATE = new Date();
                  var formattedDate = currentDATE.toISOString().split('T')[0] + 'T00:00:00';
                  if (this.vahanData.RcInsuranceUpto > formattedDate && this.vahanData.RcFitUpto > formattedDate && this.vahanData.RcTaxUpto > formattedDate) {
                    this.isVehValid = true;
                    this.isVehValidList.splice(index, 0, this.isVehValid);
                    this.vahanDataList.splice(index, 0, this.vahanData);
                    // this.isVehValidList.push(this.isVehValid);
                    // this.vahanDataList.push(this.vahanData);
                  }
                  else {
                    this.isVehValid = false;
                    this.isVehValidList.splice(index, 0, this.isVehValid);
                    this.vahanDataList.splice(index, 0, {});
                    // this.isVehValidList.push(this.isVehValid);
                    // this.vahanDataList.push({});//push empty object
                  }
                }
                else {
                  this.isVehValid = false;
                  this.isVehValidList.splice(index, 0, this.isVehValid);
                  this.vahanDataList.splice(index, 0, {});
                  // this.isVehValidList.push(this.isVehValid);
                  // this.vahanDataList.push({});//push empty object
                }
              },
              (err) => {
                this.showAllUlipValidations = false;
                //this.isVehValid = false; w
                //this.isVehValidList.splice(index, 0, this.isVehValid); w
                //this.vahanDataList.splice(index, 0, {}); w

                // this.isVehValidList.push(this.isVehValid);
                // this.vahanDataList.push({});//push empty object
                this.toastr.error("An error occured !", "error");
              }
            );
        }  //if empty vehicle no
        else {
          this.isVehValid = false;
          this.isVehValidList.splice(index, 0, this.isVehValid);
          this.vahanDataList.splice(index, 0, {});
          // this.isVehValidList.push(this.isVehValid);
          // this.vahanDataList.push({});//push empty object
        }
      }
      if (this.enableUlipForDriver) {
        this.sarathiData = {};
        this.isDriverValid = false;
        var licenseNo = $("#DriverLicense_" + index).val();
        var dob = $("#DateOfBirth_" + index).val();
        if (licenseNo != '' && dob != '') {
          this._appService
            .GetByTwoId(
              "VehicleMaster",
              "GetSarathiData",
              licenseNo,
              dob
            )
            .subscribe(
              (response) => {
                this.sarathiData = response.sarathiData;
                if (this.sarathiData && Object.keys(this.sarathiData).length > 0) {
                  //this.sarathiData.DlValidity = "2020-08-01T00:00:00"; //to comment
                  var currentDATE1 = new Date();
                  var formattedDate1 = currentDATE1.toISOString().split('T')[0] + 'T00:00:00';
                  if (this.sarathiData.DlValidity > formattedDate1) {
                    this.isDriverValid = true;
                    this.isDriverValidList.splice(index, 0, this.isDriverValid);
                    this.sarathiDataList.splice(index, 0, this.sarathiData);
                    // this.isDriverValidList.push(this.isDriverValid);
                    // this.sarathiDataList.push(this.sarathiData);
                  }
                  else {
                    this.isDriverValid = false;
                    this.isDriverValidList.splice(index, 0, this.isDriverValid);
                    this.sarathiDataList.splice(index, 0, {});
                    // this.isDriverValidList.push(this.isDriverValid);
                    // this.sarathiDataList.push({});//push empty object
                  }
                }
                else {
                  this.isDriverValid = false;
                  this.isDriverValidList.splice(index, 0, this.isDriverValid);
                  this.sarathiDataList.splice(index, 0, {});
                  // this.isDriverValidList.push(this.isDriverValid);
                  // this.sarathiDataList.push({});//push empty object
                }
              },
              (err) => {
                this.showAllUlipValidations = false;
                //this.isDriverValid = false; w
                //this.isDriverValidList.splice(index, 0, this.isDriverValid);w
                //this.sarathiDataList.splice(index, 0, {});w

                // this.isDriverValidList.push(this.isDriverValid);
                // this.sarathiDataList.push({});//push empty object
                this.toastr.error("An error occured !", "error");
              }
            );
        } //if empty any one license no or dob empty
        else {
          this.isDriverValid = false;
          this.isDriverValidList.splice(index, 0, this.isDriverValid);
          this.sarathiDataList.splice(index, 0, {});
          // this.isDriverValidList.push(this.isDriverValid);
          // this.sarathiDataList.push({});//push empty object
        }
      }
    });
    this.showAllUlipValidations = true;
    console.log("vahan", this.vahanDataList);
    console.log("sarathi", this.sarathiDataList);

  }
  //end

  //working
  //add by maaria on 30-11-2023
  ValidateDriverViaUlip(i: any) {
    this.isDriverValid = false;
    //if setting on then only
    if (this.enableUlipForDriver) {
      this.sarathiData = {};
      var licenseNo = $("#DriverLicense_" + i).val();
      var dob = $("#DateOfBirth_" + i).val();
      if (licenseNo != '' && dob != '' && licenseNo != null && dob != null) {
        this._appService
          .GetByTwoId(
            "VehicleMaster",
            "GetSarathiData",
            licenseNo,
            dob
          )
          .subscribe(
            (response) => {
              this.sarathiData = response.sarathiData;
              if (this.sarathiData && Object.keys(this.sarathiData).length > 0) {
                //this.sarathiData.DlValidity = "2020-08-01T00:00:00"; //to comment
                var currentDATE1 = new Date();
                var formattedDate1 = currentDATE1.toISOString().split('T')[0] + 'T00:00:00';
                if (this.sarathiData.DlValidity > formattedDate1) {
                  this.isDriverValid = true;
                  $("#ulipValidationModal").modal('show');
                }
                else {
                  this.isDriverValid = false;
                  $("#ulipValidationModal").modal('show');
                }
              }
              else {
                this.isDriverValid = false;
                $("#ulipValidationModal").modal('show');
              }
            },
            (err) => {
              this.toastr.error("An error occured !", "error");
            }
          );
      }
    }
  }
  ValidateBothVehDriver(i: any) {
    if (this.enableUlipForVehicle) {
      var vehNo = $("#DriverVehicleNo_" + i).val();
      if (vehNo == '' || vehNo == null) {
        this.toastr.warning("Please enter vehicle No. to validate via Ulip!", "warning");
      }
    }
    if (this.enableUlipForDriver) {
      if ($("#DriverLicense_" + i).val() == '' || ($("#DriverLicense_" + i).val() == null)) {
        this.toastr.warning("Please enter driver license No.to validate via Ulip!", "warning");
      }
      if ($("#DateOfBirth_" + i).val() == '' || ($("#DateOfBirth_" + i).val() == null)) {
        this.toastr.warning("Please enter driver Date Of Birth to validate via Ulip!", "warning");
      }
    }

    this.isVehValid = false;
    if (this.enableUlipForVehicle) {
      this.vahanData = {};
      var vehicleNo = $("#DriverVehicleNo_" + i).val();
      if (vehicleNo != '' && vehicleNo != null) {
        this._appService
          .GetByOneParam(
            "VehicleMaster",
            "GetVahanData",
            vehicleNo
          )
          .subscribe(
            (response) => {
              this.vahanData = response.vahanData;
              if (this.vahanData && Object.keys(this.vahanData).length > 0) {
                //this.vahanData.RcInsuranceUpto = "2020-08-01T00:00:00"; //to comment
                //this.vahanData.RcFitUpto = "2020-08-01T00:00:00"; //to comment
                //this.vahanData.RcTaxUpto = "2020-08-01T00:00:00"; //to comment
                //if all greater than current date then show unsuccessful else unsuccessful
                var currentDATE = new Date();
                var formattedDate = currentDATE.toISOString().split('T')[0] + 'T00:00:00';
                this.vahanData.orderWeight = 0;
                this.vahanData.orderWeight = this.MarkAsAssignList[i].orderWeight;
                if (this.vahanData.RcInsuranceUpto > formattedDate && this.vahanData.RcFitUpto > formattedDate && this.vahanData.RcTaxUpto > formattedDate) {
                  this.isVehValid = true;
                  this.ValidateDriverViaUlip(i);
                }
                else {
                  this.isVehValid = false;
                  this.ValidateDriverViaUlip(i);
                }
              }
              else {
                this.isVehValid = false;
                this.ValidateDriverViaUlip(i);
              }
            },
            (err) => {
              this.ValidateDriverViaUlip(i);
              this.toastr.error("An error occured !", "error");
            }
          );
      }
    }//if not vehicle enabled then also call driver ulip to check whether driver ulip setting is on
    else {
      this.ValidateDriverViaUlip(i);
    }
  }

  //add by maaria on 29-11-2023
  GetUlipSetting() {
    this.enableUlipForVehicle = false;
    this.enableUlipForDriver = false;
    //first check in system setting then check whether it has rights as per role for ULIP
    this._appService.Get("VehicleMaster", "GetUlipSetting").subscribe(
      (response) => {
        if (response) {
          if (response.Value == "1") {
            localStorage.setItem("ulip-setting-S", "true");
            if (
              BookingComponent.bookingComponent.commonService.CheckHasRight(
                "VIEW",
                "ULIP_FOR_VEHICLE"
              )
            ) {
              this.enableUlipForVehicle = true;
            }
            if (
              BookingComponent.bookingComponent.commonService.CheckHasRight(
                "VIEW",
                "ULIP_FOR_DRIVER"
              )
            ) {
              this.enableUlipForDriver = true;
            }
          }
          else {
            localStorage.setItem("ulip-setting-S", "false");
          }
        }
        else {
          localStorage.setItem("ulip-setting-S", "false");
        }
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }
  //end

  // OnShowVahanData(index: any) {
  //   BookingComponent.bookingComponent.vahanComponent.setVahanData(this.vahanDataList[index], this.sarathiDataList[index]);
  //   $("#vahanDataModal").modal('show');
  // }
  OnShowVahanData() {
    BookingComponent.bookingComponent.vahanComponent.setVahanData(this.vahanData, this.sarathiData);
    $("#vahanDataModal").modal('show');
  }

  //end

  //----------------------------------------Tab Click Fuctionality--------------------
  OnTrackingTabClick() {
    if (this.LoadTracking != true) {
      for (let i = 0; i < this.trackingBooking.length; i++) {
        this.trackingBooking[i].Estimate = this.datepipe.transform(
          this.trackingBooking[i].Estimate,
          "dd/MM/yyyy HH:mm"
        );
        this.trackingBooking[i].Actual = this.datepipe.transform(
          this.trackingBooking[i].Actual,
          "dd/MM/yyyy HH:mm"
        );
      }
      this.LoadTracking = true;
    }
  }

  OnInvoiceTabClick() {
    if (this.LoadInvoice != true) {
      for (let index = 0; index < this.BookingInvoiceList.length; index++) {
        this.BookingInvoiceList[index].InvoiceDate = this.datepipe.transform(
          this.BookingInvoiceList[index].InvoiceDate,
          "dd/MM/yyyy"
        );
      }
      this.LoadInvoice = true;
    }
  }

  OnBillTabClick() {
    if (this.LoadBill != true) {
      Helpers.setLoading(true);
      if (this.BillFreightAuditPrimary.length != 0) {
        for (let i = 0; i < this.BillFreightAuditPrimary.length; i++) {
          $("#PrimaryARate_" + i).val(
            this.BillFreightAuditPrimary[i].ActualAmount
          );
        }
      }
      if (this.BillFreightAuditSecondary.length != 0) {
        for (let i = 0; i < this.BillFreightAuditSecondary.length; i++) {
          $("#SecondaryARate_" + i).val(
            this.BillFreightAuditSecondary[i].ActualAmount
          );
        }
      }
      if (this.BillFreightAuditAdditional.length != 0) {
        this.FreightAuditAdditional = this.BillFreightAuditAdditional;
        for (let i = 1; i < this.FreightAuditAdditional.length; i++) {
          this.AddRow();
        }
        var i = 0;
        $("#tblAdditionalCharges").each(function () {
          $(this)
            .find("tr#templateRow0")
            .each(function () {
              var addOption =
                '<option value="' +
                BookingComponent.bookingComponent.FreightAuditAdditional[i]
                  .ChargeId +
                '">' +
                BookingComponent.bookingComponent.FreightAuditAdditional[i]
                  .ChargeName +
                "-" +
                BookingComponent.bookingComponent.FreightAuditAdditional[i]
                  .ChargeCode +
                "</option>";
              $(this).find(".AdditionalCharges").html(addOption);
              $(this)
                .find(".templatevalue")
                .val(
                  BookingComponent.bookingComponent.FreightAuditAdditional[i]
                    .ActualAmount
                );

              i++;
            });
        });
      }
      setTimeout(() => {
        this.GetPrimaryDifference();
      }, 1500);
      this.LoadBill = true;
      Helpers.setLoading(false);
    }
  }

  OnExpenseTabClick() {
    if (this.LoadExpense != true) {
      this.GetExpenseById(
        BookingComponent.bookingComponent.BookingBasicDetail.Id
      );
      this.LoadExpense = true;
    }
  }

  OnRouteTabClick() {
    if (this.LoadRoute != true) {
      //  if (this.RouteDataPrimary.length > 0 && this.RouteDataPrimary != null && this.RouteDataSeconadry.length > 0 && this.RouteDataSeconadry != null) {
      this.initMapPrimary();
      // }
      this.LoadRoute = true;
    }
  }

  ClearExpenseData() {
    this.BookingExpense = {};
    $("#ExpenseBillDate").val("");
    $("#PaymentRemark").val("");
    this.RefreshDropdown();
  }

  //------------------------------------------------- Get Data  code-------------------------------------------------
  // GetStatusBtnList() {
  //   this._appService
  //     .GetById("Booking", "GetStatusBtnList", this.CompanyId)
  //     .subscribe(
  //       response => {
  //         // this.StatusBtnList = response;
  //         this.StatusBtnList = [];
  //         response.forEach(element => {
  //           if (element.Label.trim() == "New Bookings") {
  //             if (
  //               BookingComponent.bookingComponent.commonService.CheckHasRight(
  //                 "VIEW",
  //                 "NEWBOOKING_DETAILS"
  //               )
  //             ) {
  //               this.StatusBtnList.push(element);
  //             }
  //           } else if (element.Label.trim() == "Assigned Vehicles") {
  //             if (
  //               BookingComponent.bookingComponent.commonService.CheckHasRight(
  //                 "VIEW",
  //                 "ASSIGNEDVEHICLES_DETAILS"
  //               )
  //             ) {
  //               this.StatusBtnList.push(element);
  //             }
  //           } else if (element.Label.trim() == "Gate In") {
  //             if (
  //               BookingComponent.bookingComponent.commonService.CheckHasRight(
  //                 "VIEW",
  //                 "ORIGINGATEIN_DETAILS"
  //               )
  //             ) {
  //               this.StatusBtnList.push(element);
  //             }
  //           } else if (element.Label.trim() == "Ready To Dispatch") {
  //             if (
  //               BookingComponent.bookingComponent.commonService.CheckHasRight(
  //                 "VIEW",
  //                 "READYTODISPATCH_DETAILS"
  //               )
  //             ) {
  //               this.StatusBtnList.push(element);
  //             }
  //           } else if (element.Label.trim() == "Dispatch") {
  //             if (
  //               BookingComponent.bookingComponent.commonService.CheckHasRight(
  //                 "VIEW",
  //                 "DISPATCHED_DETAILS"
  //               )
  //             ) {
  //               this.StatusBtnList.push(element);
  //             }
  //           } else if (element.Label.trim() == "eWay Bill Ready") {
  //             if (
  //               BookingComponent.bookingComponent.commonService.CheckHasRight(
  //                 "VIEW",
  //                 "EVAYBILL_DETAILS"
  //               )
  //             ) {
  //               this.StatusBtnList.push(element);
  //             }
  //           }
  //         });
  //         setTimeout(() => {
  //           $("#Step_0").addClass("badge-primary");
  //         }, 200);
  //       },
  //       err => {
  //         this.toastr.error(err._body.replace(/"/g, ""), "error");
  //       }
  //     );
  // }

  GetStatusBtnList() {
    this._appService
      .GetByFourId(
        "Booking",
        "GetStatusBtnList",
        this.CompanyId,
        this.UserId,
        this.isTransporter,
        this.isCustomer
      )
      .subscribe(
        (response) => {
          // this.StatusBtnList = response;
          this.StatusBtnList = [];
          response.forEach((element) => {
            if (element.Label.trim() == "New Bookings") {
              if (
                BookingComponent.bookingComponent.commonService.CheckHasRight(
                  "VIEW",
                  "NEWBOOKING_DETAILS"
                )
              ) {
                element.Label = "Pending Vehicle Assign";
                this.StatusBtnList.push(element);
              }
            } else if (element.Label.trim() == "EC Pickup") {
              if (
                BookingComponent.bookingComponent.commonService.CheckHasRight(
                  "VIEW",
                  "EC_PICKUP"
                )
              ) {
                element.Label = "EC Pickup";
                this.StatusBtnList.push(element);
              }
            } else if (element.Label.trim() == "Assigned Vehicles") {
              if (
                BookingComponent.bookingComponent.commonService.CheckHasRight(
                  "VIEW",
                  "ASSIGNEDVEHICLES_DETAILS"
                )
              ) {
                element.Label = "Pending Gate In";
                this.StatusBtnList.push(element);
              }
            } else if (element.Label.trim() == "Gate In") {
              if (
                BookingComponent.bookingComponent.commonService.CheckHasRight(
                  "VIEW",
                  "ORIGINGATEIN_DETAILS"
                )
              ) {
                element.Label = "Pending LR";
                this.StatusBtnList.push(element);
              }
            } else if (element.Label.trim() == "Ready To Dispatch") {
              if (
                BookingComponent.bookingComponent.commonService.CheckHasRight(
                  "VIEW",
                  "READYTODISPATCH_DETAILS"
                )
              ) {
                // add kevin 08/09/2020
                if (BookingComponent.bookingComponent.THCFlag) {
                  element.Label = "Pending THC";
                  this.StatusBtnList.push(element);
                }
                // element.Label = "Pending THC";
                // this.StatusBtnList.push(element);
                //end
              }
            } else if (element.Label.trim() == "Dispatch") {
              if (
                BookingComponent.bookingComponent.commonService.CheckHasRight(
                  "VIEW",
                  "DISPATCHED_DETAILS"
                )
              ) {
                // add kevin 14/07/2020
                if (BookingComponent.bookingComponent.eWayBillFlag) {
                  element.Label = "Pending eWayBill";
                  // this.StatusBtnList.push(element);
                }
                // element.Label = "Pending eWayBill";
                // this.StatusBtnList.push(element);
                // end
              }
            } else if (element.Label.trim() == "eWay Bill Ready") {
              if (
                BookingComponent.bookingComponent.commonService.CheckHasRight(
                  "VIEW",
                  "EVAYBILL_DETAILS"
                )
              ) {
                element.Label = "Pending Gate Out";
                this.StatusBtnList.push(element);
              }
            }
          });
          // setTimeout(() => {
          //     //when milestone process get selected change the color
          //     $("#Step_1").addClass("badge-primary");
          // }, 200);
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "error");
        }
      );
  }
  GetTransporterList() {
    this._appService
      .GetById("Booking", "GetTransporterList", this.TenantId)
      .subscribe(
        (response) => {
          this.TransporterList = response;
          (<any>$(".ClsVehicleAssginByTrasporter")).selectpicker("refresh");
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "error");
        }
      );
  }
  GetVehicleConditionTypeList() {
    this._appService.Get("Booking", "GetVehicleConditionTypeList").subscribe(
      (response) => {
        this.VehicleConditionType = response;
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }
  GetTrackingBooking() {
    this._appService.Get("Booking", "GetTrackingBooking").subscribe(
      (response) => {
        this.trackingBooking = response;
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }
  GetTrackingStatus() {
    this._appService.Get("Booking", "GetTrackingStatus").subscribe(
      (response) => {
        this.BookingStatus = response;
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }
  GetBookingInvoiceList() {
    this._appService
      .GetByTwoId(
        "Booking",
        "GetBookingInvoiceList",
        BookingComponent.bookingComponent.BookingBasicDetail.QuoteId,
        BookingComponent.bookingComponent.BookingBasicDetail.VehicleId
      )
      .subscribe(
        (response) => {
          this.BookingInvoiceList = response;
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "error");
        }
      );
  }

  GetAllAdditionalCharges() {
    this._appService
      .GetByTwoId("Booking", "GetAdditionalCharges", null, 1)
      .subscribe(
        (response) => {
          this.AdditionalCharges = response.Results;
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "error");
        }
      );
  }
  OnDownloadClick() {
    var Id = BookingComponent.bookingComponent.BookingBasicDetail.Id;
    var QuoteId = BookingComponent.bookingComponent.BookingBasicDetail.QuoteId;
    var VehicleId =
      BookingComponent.bookingComponent.BookingBasicDetail.VehicleId;
    this._appService
      .GetByThreeId("SalesOrder", "DownloadOrders", Id, QuoteId, VehicleId)
      .subscribe((response) => {
        var path =
          environment.apiUrl +
          "../../Uploads/Download_Csv/" +
          response +
          ".xls";
        window.open(path, "");
      });
  }
  AdditionalValueChange() {
    this.GetPrimaryDifference();
    var i = 0;
    $("#tblAdditionalCharges").each(function () {
      $(this)
        .find("tr#templateRow0")
        .each(function () {
          var id = $(this)
            .find("td#template .m-select2 option")
            .closest("option")
            .val();
          var val = $(this).find("td#templateclass .templatevalue").val();
          for (
            let j = 0;
            j < BookingComponent.bookingComponent.AdditionalCharges.length;
            j++
          ) {
            if (
              BookingComponent.bookingComponent.AdditionalCharges[j].id == id
            ) {
              BookingComponent.bookingComponent.FreightAuditAdditional[i] = {};
              BookingComponent.bookingComponent.FreightAuditAdditional[i].Id =
                id;
              BookingComponent.bookingComponent.FreightAuditAdditional[i].rate =
                val;
              i++;
              BookingComponent.bookingComponent.TotalRate =
                BookingComponent.bookingComponent.TotalRate +
                parseInt(val || 0);
            }
          }
        });
      $("#TotalABillAmt").text(BookingComponent.bookingComponent.TotalRate);
      this.PaymentBillAmount = BookingComponent.bookingComponent.TotalRate;
    });
  }

  GetAdditionalCharges() {
    $(".AdditionalCharges").select2({
      width: "430px",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Booking/GetAdditionalCharges",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            Id: params.term,
            param1: params.page || 1,
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data.Results,
            pagination: {
              more: params.page * 30 < data.Total,
            },
          };
        },
      },
      tokenSeparators: [",", " "],
      placeholder: "Search for Source",
    });
  }

  AddRow() {
    var t = document.getElementById("tblAdditionalCharges");
    var rows = t.getElementsByTagName("tr");
    var r = rows[rows.length - 1];
    var x = document.getElementById("templateRow0").cloneNode(true);
    $("#tblAdditionalCharges tr:last").attr("Id");

    $("#tblAdditionalCharges tr:last").after(
      '<tr id="templateRow0"><td id="template"><select class="form-control m-select2 AdditionalCharges"  name="AdditionalCharges"></select></td><td id="templateclass"><input type="text" class="form-control  text-right templatevalue"   placeholder="Rs."></td><td><span class="btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill btnMinus" data-toggle="dropdown"><i class="fa fa-minus"></i></span></td><td></td>'
    );
    $(".btnMinus:last").click(function () {
      $(this).closest("tr").remove();
      BookingComponent.bookingComponent.AdditionalValueChange();
    });
    $(".templatevalue:last").change(function () {
      BookingComponent.bookingComponent.AdditionalValueChange();
    });
    this.GetAdditionalCharges();
  }

  AddPaymentRow() {
    var t = document.getElementById("tblPayment");
    var rows = t.getElementsByTagName("tr");
    var r = rows[rows.length - 1];
    var x = document.getElementById("PaymentRow0").cloneNode(true);
    var option =
      '<tr id="PaymentRow0"><td id="templateAmount"><input type="number" class="form-control text-right ClstemplateAmount"  placeholder="Rs."></td><td id="templateDate"><input type="text" class="form-control  datepicker ClstemplateDate" style="width:100px;" placeholder="Date"></td><td id="templateBankAccount"><input type="text" class="form-control ClstemplateBankAccount" placeholder="Bank Account" /></td><td id="templatePaymentMode"><select class="form-control ClstemplatePaymentMode" name="ModeOfPayment">';
    for (var i = 0; i < this.PaymentMode.length; i++) {
      option =
        option +
        '<option value="' +
        this.PaymentMode[i].Id +
        '">' +
        this.PaymentMode[i].Label +
        "</option>";
    }
    option =
      option +
      '</select></td><td id="templateRefNo"> <input type="text" class="form-control ClstemplateRefNo" placeholder="No" /></td><td><span class="btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill btnPaymentMinus" data-toggle="dropdown" ><i class="fa fa-minus"></i></span></td><td id="templeteAction"> <input type="text" class="PaymentHidden" style="display: none;"><input type="file" class="ClsPaymentUpload" style="display: none;" /><span style="overflow: visible; width: 110px;"><div class="dropdown "><a href="#" class="btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill" data-toggle="dropdown"><i class="la la-ellipsis-h"></i></a><div class="dropdown-menu dropdown-menu-left"><a class="dropdown-item ClsOnPaymentUploadClick">Upload</a><a class="dropdown-item" href="#">Download</a></div><i class="fa fa-paperclip PaymentPaperClip" aria-hidden="true" style="display: none;"></i></div></span></td></tr>';

    $("#tblPayment tr:last").after(option);

    $(".btnPaymentMinus:last").click(function () {
      $(this).closest("tr").remove();
    });

    var that = this;
    $(".ClstemplateAmount").change(function () {
      that.CalculatePaidAmount("FromPayment");
    });

    $(".ClsOnPaymentUploadClick")
      .unbind("click")
      .click(function (event) {
        that.OnPaymentUploadClick(event);
      });

    $(".ClsPaymentUpload")
      .unbind("change")
      .change(function (event) {
        that.PaymentUploadClick(event);
      });

    this.RefreshvalidDate();
  }

  AddReceiptRow() {
    var t = document.getElementById("tblReceipt");
    var rows = t.getElementsByTagName("tr");
    var r = rows[rows.length - 1];
    var x = document.getElementById("ReceiptRow0").cloneNode(true);
    var option =
      '<tr id="ReceiptRow0"><td id="ReceiptAmount"><input type="number" class="form-control text-right ClsReceiptAmount"  placeholder="Rs."></td><td id="ReceiptDate"><input type="text" class="form-control  datepicker ClsReceiptDate" style="width:100px;" placeholder="Date"></td><td id="ReceiptAccount"><input type="text" class="form-control ClsReceiptAccount" placeholder="Bank Account" /></td><td id="ReceiptMode"><select class="form-control ClsReceiptMode" name="ModeOfPayment">';
    for (var i = 0; i < this.PaymentMode.length; i++) {
      option =
        option +
        '<option value="' +
        this.PaymentMode[i].Id +
        '">' +
        this.PaymentMode[i].Label +
        "</option>";
    }
    option =
      option +
      '</select></td><td id="ReceiptNo"> <input type="text" class="form-control ClsReceiptNo" placeholder="No" /></td><td><span class="btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill btnReceiptMinus" data-toggle="dropdown" ><i class="fa fa-minus"></i></span></td><td><span style="overflow: visible; width: 110px;">	<div class="dropdown "><a href="#" class="btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill" data-toggle="dropdown"><i class="la la-ellipsis-h"></i></a><div class="dropdown-menu dropdown-menu-left"><a class="dropdown-item" href="#">Upload</a><a class="dropdown-item" href="#">Download</a></div></div></span></td></tr>';
    $("#tblReceipt tr:last").after(option);

    $(".btnReceiptMinus:last").click(function () {
      $(this).closest("tr").remove();
    });
    var that = this;
    $(".ClsReceiptAmount").change(function () {
      that.CalculatePaidAmount("FromReceipt");
    });
    this.RefreshvalidDate();
  }

  GetExpenseParty() {
    this._appService.Get("Booking", "GetExpenseParty").subscribe(
      (response) => {
        this.ExpenseParty = response;
        this.RefreshDropdown();
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }

  GetPaymentMode() {
    this._appService.Get("Booking", "GetPaymentMode").subscribe(
      (response) => {
        this.PaymentMode = response;
        this.RefreshDropdown();
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }

  GetCharges() {
    this._appService.Get("Booking", "GetCharges").subscribe(
      (response) => {
        this.ChargeType = response;
        this.RefreshDropdown();
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }

  GetActionAddExpense() {
    this._appService.Get("Booking", "GetActionAddExpense").subscribe(
      (response) => {
        this.ActionExpense = response;
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }

  CalculatePayment() {
    $("#PaymentAmount").val(
      parseInt($("#PaymentRate").val() || 0) *
      parseInt($("#PaymentQuantity").val() || 0)
    );
    var GSTAmount =
      (parseInt($("#PaymentAmount").val() || 0) *
        parseInt($("#PaymentGST").val() || 0)) /
      100;
    $("#PaymentTotal").text(
      parseInt($("#PaymentAmount").val() || 0) + GSTAmount
    );
  }
  //---------------------Tracking Upload / Download---------------------------------
  OnTrackingUploadClick(d) {
    $("#TrackingUpload_" + d).trigger("click");
  }

  TrackingUploadClick(event) {
    this.selectFile = event.target.files[0];
    if (
      this.selectFile == undefined ||
      this.selectFile == "" ||
      this.selectFile == null
    ) {
      this.toastr.error("Please select file to upload", "error");
      return false;
    }
    var fd = new FormData();
    if (fd.has("file")) {
      fd.set("file", this.selectFile);
    } else {
      fd.append("file", this.selectFile);
    }
    var headers = new Headers();
    let user_access_token = this.decryptpipe.transform(
      JSON.parse(this.cookieService.get("user_access_token"))
    );
    const token: string = "Bearer " + user_access_token;
    headers.append("Authorization", token);
    let options = new RequestOptions({ headers: headers });
    this._appService.File("Booking", "TrackingUpload", fd, options).subscribe(
      (response) => {
        this.toastr.success("Uploaded Successfully !", "success");
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
        this.datatable.reload();
        this.toastr.error("Error occured while Uploading...", "error");
      }
    );
  }

  DownloadTracking(d) {
    var path =
      environment.apiUrl +
      "../../Document/BookingTracking/" +
      this.trackingBooking[d].FileName +
      "." +
      this.trackingBooking[d].FileExtension;
    window.open(path, "");
  }

  //---------------------Invoice Upload / Download---------------------------------

  OnInvoiceUploadClick(d) {
    $("#InvoiceUpload_" + d).trigger("click");
  }
  InvoiceUploadClick(event) {
    this.selectFile = event.target.files[0];
    if (
      this.selectFile == undefined ||
      this.selectFile == "" ||
      this.selectFile == null
    ) {
      this.toastr.error("Please select file to upload", "error");
      return false;
    }
    var fd = new FormData();
    if (fd.has("file")) {
      fd.set("file", this.selectFile);
    } else {
      fd.append("file", this.selectFile);
    }
    var headers = new Headers();
    let user_access_token = this.decryptpipe.transform(
      JSON.parse(this.cookieService.get("user_access_token"))
    );
    const token: string = "Bearer " + user_access_token;
    headers.append("Authorization", token);
    let options = new RequestOptions({ headers: headers });
    this._appService.File("Booking", "InvoiceUpload", fd, options).subscribe(
      (response) => {
        this.toastr.success("Uploaded Successfully !", "success");
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
        this.datatable.reload();
        this.toastr.error("Error occured while Uploading...", "error");
      }
    );
  }
  GetOrderListForBooking(BookingID) {
    this.OrderListForBooking = [];
    this._appService
      .GetById("Booking", "GetOrderListForBooking", BookingID)
      .subscribe(
        (response) => {
          this.OrderListForBooking = response;
          this.CalculateData();
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "error");
        }
      );
  }
  CalculateData() {
    this.TotalQty = 0;
    this.TotalWeight = 0;
    this.TotalCBM = 0;
    this.TotalAmount = 0;
    if (this.OrderListForBooking.length > 0) {
      for (let i = 0; i < this.OrderListForBooking.length; i++) {
        this.TotalQty += this.OrderListForBooking[i].Qty;
        this.TotalWeight += this.OrderListForBooking[i].Weight;
        this.TotalCBM += this.OrderListForBooking[i].CBM;
        this.TotalAmount += this.OrderListForBooking[i].InvoiceAmount;
      }
    }
  }
  DownloadInvoice(d) {
    var path =
      environment.apiUrl +
      "../../Document/BookingInvoice/" +
      this.BookingInvoiceList[d].FileName +
      "." +
      this.BookingInvoiceList[d].FileExtension;
    window.open(path, "");
  }
  //------------------------POD Upload / Download---------------------------------
  OnPODUploadClick(d, type) {
    if (type == "P") {
      $("#PODPrimaryUpload_" + d).trigger("click");
    } else {
      $("#PODSecondaryUpload_" + d).trigger("click");
    }
  }

  PODUploadClick(event) {
    this.selectFile = event.target.files[0];
    if (
      this.selectFile == undefined ||
      this.selectFile == "" ||
      this.selectFile == null
    ) {
      this.toastr.error("Please select file to upload", "error");
      return false;
    }
    var fd = new FormData();
    if (fd.has("file")) {
      fd.set("file", this.selectFile);
    } else {
      fd.append("file", this.selectFile);
    }
    var headers = new Headers();
    let user_access_token = this.decryptpipe.transform(
      JSON.parse(this.cookieService.get("user_access_token"))
    );
    const token: string = "Bearer " + user_access_token;
    headers.append("Authorization", token);
    let options = new RequestOptions({ headers: headers });
    this._appService.File("Booking", "PODUpload", fd, options).subscribe(
      (response) => {
        this.toastr.success("Uploaded Successfully !", "success");
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
        this.datatable.reload();
        this.toastr.error("Error occured while Uploading...", "error");
      }
    );
  }

  DownloadPOD(d, type) {
    if (type == "P") {
      var path =
        environment.apiUrl +
        "../../Document/BookingPOD/" +
        this.PrimaryDeliveryDetails[d].FileName +
        "." +
        this.PrimaryDeliveryDetails[d].FileExtension;
    } else {
      var path =
        environment.apiUrl +
        "../../Document/BookingPOD/" +
        this.SecondaryDeliveryDetails[d].FileName +
        "." +
        this.SecondaryDeliveryDetails[d].FileExtension;
    }

    window.open(path, "");
  }

  //------------------------Payment Upload / Download---------------------------------

  OnPaymentUploadClick(event) {
    var a = $(event.target).closest("tr");
    a.find("td#templeteAction .ClsPaymentUpload").trigger("click");
  }

  PaymentUploadClick(event) {
    var a = $(event.target).closest("tr");
    var b = a.find("td#templeteAction .ClsPaymentUpload").val();
    a.find("td#templeteAction .PaymentHidden").val(b);
    this.selectFile = event.target.files[0];
    if (
      this.selectFile == undefined ||
      this.selectFile == "" ||
      this.selectFile == null
    ) {
      this.toastr.error("Please select file to upload", "error");
      return false;
    }
    var fd = new FormData();
    if (fd.has("file")) {
      fd.set("file", this.selectFile);
    } else {
      fd.append("file", this.selectFile);
    }
    var headers = new Headers();
    let user_access_token = this.decryptpipe.transform(
      JSON.parse(this.cookieService.get("user_access_token"))
    );
    const token: string = "Bearer " + user_access_token;
    headers.append("Authorization", token);
    let options = new RequestOptions({ headers: headers });
    this._appService.File("Booking", "PaymentUpload", fd, options).subscribe(
      (response) => {
        this.toastr.success("Uploaded Successfully !", "success");
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
        this.datatable.reload();
        this.toastr.error("Error occured while Uploading...", "error");
      }
    );
  }

  DownloadPayment(d) {
    var path =
      environment.apiUrl +
      "../../Document/BookingInvoice/" +
      this.BookingInvoiceList[d].FileName +
      "." +
      this.BookingInvoiceList[d].FileExtension;
    window.open(path, "");
  }

  // ------------------------------------------------- DataTable Code-------------------------------------------------
  GetBookingsList() {
    this.datatable = (<any>$(".m_datatable_Booking")).mDatatable({
      data: {
        type: "remote",
        source: {
          read: {
            method: "POST",
            url: environment.apiUrl + "api/Booking/GetBookingList",
            params: {
              // custom parameters
              CompanyId: BookingComponent.bookingComponent.CompanyId,
              //add kevin 10/10/2020
              TranshporterUserId: BookingComponent.bookingComponent.UserId,
              isTransporter: BookingComponent.bookingComponent.isTransporter,
              isCustomer: BookingComponent.bookingComponent.isCustomer,
              //end
            },
          },
        },
        pageSize: 10,
        serverPaging: !0,
        serverFiltering: !0,
      },
      layout: {
        class: "m--margin-top-5",
        scroll: false,
        footer: !1,
        smoothScroll: {
          scrollbarShown: true,
        },
      },
      sortable: !0,
      pagination: !0,
      toolbar: {
        items: {
          pagination: {
            pageSizeSelect: [10, 20, 30, 50, 100, 500, 1000],
          },
        },
      },
      search: {
        onChange: true,
        input: $("#SearchValue"),
        delay: 400,
      },
      rows: {
        afterTemplate: function (row, data, index) {
          $(row)
            .find(".btnEdit")
            .click(function () {
              var Id = $(this).attr("Id");
              BookingComponent.bookingComponent.LoadTracking = false;
              BookingComponent.bookingComponent.LoadInvoice = false;
              BookingComponent.bookingComponent.LoadBill = false;
              BookingComponent.bookingComponent.LoadExpense = false;
              BookingComponent.bookingComponent.LoadRoute = false;
              BookingComponent.bookingComponent.BookingBasicDetail = data;
              BookingComponent.bookingComponent.IsApproved =
                BookingComponent.bookingComponent.BookingBasicDetail.IsApprovedBooking;
              BookingComponent.bookingComponent.RefreshvalidDate();
              BookingComponent.bookingComponent.OnEditBookingClick(
                Id,
                data.QuoteId,
                data.TransporterId,
                data.VehicleCapacity,
                data.VehicleId
              );
            });
          $(row)
            .find(".btnDelete")
            .click(function () {
              var Id = $(this).attr("Id");
              swal({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                type: "warning",
                showCancelButton: !0,
                confirmButtonText: "Yes, delete it!",
              }).then(function (e) {
                if (e.value == true) {
                  BookingComponent.bookingComponent._appService
                    .Delete("Booking", "DeleteBookingData", Id)
                    .subscribe(
                      (response) => {
                        BookingComponent.bookingComponent.datatable.reload();
                        BookingComponent.bookingComponent.GetStatusBtnList();
                        //added by vithujan 19-10-2023 - Siddarth
                        BookingComponent.bookingComponent.SaveDeletedTransactionHistory(Id);
                      },
                      (err) => {
                        BookingComponent.bookingComponent.toastr.error(
                          "An error occured while deleting data !",
                          "error"
                        );
                      }
                    );
                }
              });
            });
          $(row)
            .find(".btnCancel")
            .click(function () {
              var Id = $(this).attr("Id");
              BookingComponent.bookingComponent.index = Id;
              BookingComponent.bookingComponent.commonService.ClearMessage(
                $("#txtCancellationReason")
              );
              $("#txtCancellationReason").val("");
              BookingComponent.bookingComponent.GetReasonSelectData();
              $("#ModalCancelBooking").modal("show");
            });
          $(row)
            .find(".btnDownloadOrders")
            .click(function () {
              BookingComponent.bookingComponent.DownloadOrder(
                data.Id,
                data.QuoteId,
                data.VehicleId
              );
            });
          $(row)
            .find(".btnViewOrders")
            .click(function () {
              $("#ModalForOrderDetail").modal("show");
              BookingComponent.bookingComponent.GetOrderListForBooking(data.Id);
            });
          //add kevin 25/11/2020
          $(row)
            .find(".btnRouteLoadPlan")
            .click(function () {
              BookingComponent.bookingComponent.GetOrderRouteAndLoadPlan(
                data.Id
              );
            });
          //end
          // $(row)
          //   .find(".btnShowLiveTrack")
          //   .click(function () {
          //     $("#ModalForLiveTrack").modal("show");
          //     BookingComponent.bookingComponent.GetLiveTrackListForBooking(
          //       data.Id,
          //       null
          //     );
          //   });

          //add vithujan 25-06-2022
          $(row)
            .find(".btnCongNote")
            .click(function () {
              BookingComponent.bookingComponent.GetConsigmentNoteDetails();
            });
          $(row)
            .find(".THCApproveStatusClick")
            .click(function () {
              BookingComponent.bookingComponent.getThcApproveRejectData(data.Id);
            });
        },
      },
      columns: [
        {
          field: "Id",
          title: "#",
          sortable: !1,
          width: 20,
          selector: {
            class:
              "m-checkbox m-datatable--on-check m-checkbox--solid m-checkbox--brand BookingIdCheckbox",
          },
          template: function (t) {
            let value = t;
            return value;
          },
        },
        {
          field: "FCNumber",
          title: this.selectedLang == "sp" ? "Número" : "No#",
          sortable: true,
          width: 150,
          textAlign: "center",
          template: function (t) {
            var btn = `<span >${t.FCNumber}</span><br/>
                        
                        <span class="badge badge-primary" style="font-size: smaller ; cursor:pointer;" data-toggle="tooltip"
                        title="Total Duration" > ${t.TotalDuration} </span>
                        <br/>
                        <span class="badge badge-secondary" style="font-size: smaller; cursor:pointer;" data-toggle="tooltip"
                        title="Pending Since"> ${t.TotalDaysInStage} </span><br/>
                        `;
            if (BookingComponent.bookingComponent.THCAdvancePercentageApproveRejectFlag == true && t.THCApproveStatus != '') {
              var btn = btn + `<span class="badge badge-secondary THCApproveStatusClick" style="font-size: smaller; cursor:pointer; background-color: red !important;" data-toggle="tooltip"
                        title = "THC Approve Status" > ${t.THCApproveStatus} </span><br/ > `;
            }
            // else {
            //     var btn = '<span>' + t.FCNumber + '</span>'
            // }
            return btn;
          },
        },
        {
          field: "OrderNo",
          title: this.selectedLang == "sp" ? "Número de pedido" : "Order No",
          sortable: false,
          width: 150,
          textAlign: "center",
          template: function (t) {
            var btn = `<span>${t.OrderNo}</span><br/>
                        <span data-toggle="tooltip" title="Refrence No"> ${t.OrderReferenceNo == null ? "" : t.OrderReferenceNo
              } </span>`;
            return btn;
          },
        },
        {
          field: "Date",
          title: this.selectedLang == "sp" ? "Fecha" : "Date",
          filterable: !1,
          width: 100,
          responsive: {
            visible: this.hostURL != 'https://isa.ifreightbox.net/' ? "lg" : "hidden"
          }
        },
        {
          field: "OrderOrderDate",
          title: this.selectedLang == "sp" ? "Fecha" : "Date",
          filterable: !1,
          width: 100,
          responsive: {
            visible: this.hostURL == 'https://isa.ifreightbox.net/' ? "lg" : "hidden"
          }
        },
        {
          field: "Customer",
          title: this.selectedLang == "sp" ? "Cliente" : "Customer",
          filterable: !1,
          width: 180,
        },
        {
          field: "OrderPickUpContactPerson",
          title: this.selectedLang == "sp" ? "Expedidor" : "Shipper",
          filterable: !1,
          width: 100,
          responsive: {
            visible: this.hostURL == 'https://pittie.ifreightbox.net/' ? "lg" : "hidden"
          }
        },
        {
          field: "OrderDeliveryContactPerson",
          title: this.selectedLang == "sp" ? "Consignatario" : "Consignee",
          filterable: !1,
          width: 100,
          responsive: {
            visible: this.hostURL == 'https://pittie.ifreightbox.net/' ? "lg" : "hidden"
          }
        },

        {
          field: "ServiceProvider",
          title: this.selectedLang == "sp" ? "Servicio" : "Service",
          filterable: !1,
          width: 180,
        },
        {
          field: "VehicleMT",
          title:
            this.selectedLang == "sp" ? "Tipo de vehículo" : "Vehicle Type",
          filterable: !1,
          width: 100,
        },
        {
          field: "FromCity",
          title: this.selectedLang == "sp" ? "Origen" : "Origin",
          filterable: !1,
          width: 100,
          template: function (t) {
            if (
              BookingComponent.bookingComponent
                .ContactPersonNameInTripListPageFlag
            ) {
              return `<span> ${t.FromCity} </span><br/><span>( ${t.OrderPickUpContactPerson} )</span>`;
            } else {
              return `<span> ${t.FromCity} </span>`;
            }
          },
        },
        {
          field: "ToCity",
          title: this.selectedLang == "sp" ? "Destino" : "Destination",
          filterable: !1,
          width: 100,
          template: function (t) {
            if (
              BookingComponent.bookingComponent
                .ContactPersonNameInTripListPageFlag
            ) {
              return `<span> ${t.ToCity} </span><br/><span>( ${t.OrderDeliveryContactPerson} )</span>`;
            } else {
              return `<span> ${t.ToCity} </span>`;
            }
          },
        },
        {
          field: "LocationCity",
          title:
            this.selectedLang == "sp" ? "Ubicación Ciudad" : "Location City",
          filterable: !1,
          width: 200,
          responsive: {
            visible: this.isHotShotshostUrl != true ? "lg" : "hidden",
          },
        },
        {
          field: "ProjectCode",
          title: this.selectedLang !== "sp" ? "Project Code" : "Código de proyecto",
          filterable: !1,
          width: 200,
          responsive: {
            visible: this.hostURL === "https://srs.ifreightbox.net/" ? "lg" : "hidden"
          }
        },
        {
          field: "Actions",
          width: 110,
          textAlign: "center",
          title: this.selectedLang == "sp" ? "Acciones" : "Actions",
          sortable: !1,
          overflow: "visible",
          template: function (t) {
            const bookLiveTrack =
              BookingComponent.bookingComponent.translate.instant(
                "BYCUSTOMER.bookLiveTrack"
              );
            const tripDownloadOrder =
              BookingComponent.bookingComponent.translate.instant(
                "BYCUSTOMER.tripDownloadOrder"
              );
            const tripViewOrderDetail =
              BookingComponent.bookingComponent.translate.instant(
                "BYCUSTOMER.tripViewOrderDetail"
              );
            const tripViewRouteAndLoadPlan =
              BookingComponent.bookingComponent.translate.instant(
                "BYCUSTOMER.tripViewRouteAndLoadPlan"
              );
            const tripViewCongNote =
              BookingComponent.bookingComponent.translate.instant(
                "BYCUSTOMER.ViewCongNote"
              );
            const tripViewInsLetter =
              BookingComponent.bookingComponent.translate.instant(
                "BYCUSTOMER.ViewInsLetter"
              );
            var btn = "";
            var btn = "";
            // added by vithujan 24 - 09 - 2022(rel = "noopener noreferrer")
            btn += `<span style="overflow: visible; width: 110px;">
                        <a href="#" class="btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill" data-toggle="dropdown">
                        <i class="la la-ellipsis-h"></i>
                        </a>
                        <div class="dropdown-menu dropdown-menu-left">
                        <a id="${t.id}" target="_blank" rel="noopener noreferrer" href="/LiveTracking?bookingId=${t.Id}&consignmentDetailId=null" style="cursor:pointer" class="btnShowLiveTrack dropdown-item" title="Live Track">
                        <i class="la la-map-marker"></i> ${bookLiveTrack}
                        </a>`;
            if (BookingComponent.bookingComponent.isHotShotshostUrl != true) {
              btn += `<a  style="cursor:pointer" class="btnDownloadOrders dropdown-item" title="Download Order">
                        <i class="la la-download"></i> ${tripDownloadOrder}
                        </a>`;
            }
            btn += `<a  style="cursor:pointer" class="btnViewOrders dropdown-item" title="View Order">
                        <i class="la flaticon-folder"></i> ${tripViewOrderDetail}
                        </a>
                        <a  style="cursor:pointer" class="btnRouteLoadPlan dropdown-item" title="View Route And Load Plan"> 
                        <i class="la flaticon-folder"></i> ${tripViewRouteAndLoadPlan}
                        </a>
                        <a  style="cursor:pointer" class="btnCongNote dropdown-item" title="View Consignment Note">
                        <i class="la flaticon-folder"></i> ${tripViewCongNote}
                        </a>
                        <a  style="cursor:pointer" class="btnInsLetter dropdown-item" title="View Instruction Letter">
                        <i class="la flaticon-folder"></i> ${tripViewInsLetter}
                        </a>
                        </div>
                        </span>`;
            // if (BookingComponent.bookingComponent.commonService.CheckHasRight("VIEW", "BOOKINGS_DETAILS")) {
            //     btn += `<a id="${t.Id}" class="btnEdit m-portlet__nav-link btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill" title="Edit details">
            //         <i class="la la-edit"></i>
            //         </a>`;
            // }
            if (
              BookingComponent.bookingComponent.commonService.CheckHasRight(
                "DELETE",
                "NEWBOOKING_DETAILS"
              )
            ) {
              btn += `<a id="${t.Id}" class="btnDelete m-portlet__nav-link btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill" title="Delete">
                                <i class="la la-trash"></i>
                                </a>`;
            }
            if (
              BookingComponent.bookingComponent.commonService.CheckHasRight(
                "EDIT",
                "NEWBOOKING_DETAILS"
              )
            ) {
              btn += `<a id="${t.Id}" class="btnCancel m-portlet__nav-link btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill" title="Cancel">
                        <i class="flaticon-cancel"></i>
                        </a>`;
            }
            return btn;
          },
        },
      ],
    });
  }

  CancelBooking() {
    if (this.ValidateFieldsOnCancelBooking() == true) {
      this._appService
        .GetByTwoId(
          "Booking",
          "CancelVehicleBooking",
          this.index,
          $("#txtCancellationReason").val()
        )
        .subscribe(
          (response) => {
            //added by vithujan 19-10-2023 - Siddarth
            this.SaveDeletedTransactionHistory(this.index);

            $(".m_datatable_Booking").mDatatable().reload();
            this.index = "";
            $("#ModalCancelBooking").modal("hide");
            this.toastr.success("Booking Cancelled Successfully ", "Success");
          },
          (err) => {
            $("#ModalCancelBooking").modal("hide");
            this.toastr.error(err._body.replace(/"/g, ""), "error");
          }
        );
    }
  }
  ValidateFieldsOnCancelBooking() {
    var flag = true;
    if (
      !this.commonService.ValidateRequiredField2(
        $("#txtCancellationReason"),
        $("#FieldsetCancellationReason"),
        "Please Select Cancellation Reason",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    return flag;
  }
  GetReasonSelectData() {
    $("#txtCancellationReason").select2({
      tags: true,
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/ReasonMaster/GetSelect2ReasonList",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            query: params.term,
            page: params.page || 1,
            ReasonFor: "Booking",
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data.Results,
            pagination: {
              more: params.page * 30 < data.Total,
            },
          };
        },
      },
      tokenSeparators: [",", " "],
      createTag: function (params) {
        $(".select2-search__field").keydown(function (e) {
          if (e.keyCode != 32) {
            var term = $.trim(params.term);
            // Don't offset to create a tag if there is no valid email
            return {
              id: term,
              text: term,
              newTag: true, // add additional parameters
            };
          }
        });
      },
      insertTag: function (data, tag) {
        data.push(tag);
      },
      placeholder: "Search For Reason",
    });
  }
  DownloadOrder(Id, QuoteId, VehicleId) {
    this._appService
      .GetById("Booking", "OBV_DownloadOrderListForBooking", Id)
      .subscribe(
        (response) => {
          this.DownloadFile(response);
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "error");
        }
      );
  }

  GetOrderList() {
    var _that = (this.datatable = (<any>(
      $(".m_datatable_OrderBooking")
    )).mDatatable({
      data: {
        type: "remote",
        source: {
          read: {
            method: "POST",
            url: environment.apiUrl + "api/Booking/GetBookingOrder",
            params: {
              UniqueId:
                BookingComponent.bookingComponent.BookingBasicDetail.SerialNo,
              Id: BookingComponent.bookingComponent.BookingBasicDetail.Id,
              QuoteId:
                BookingComponent.bookingComponent.BookingBasicDetail.QuoteId,
              VehicleId:
                BookingComponent.bookingComponent.BookingBasicDetail.VehicleId,
            },
            map: function (raw) {
              var dataSet = raw;
              if (typeof raw.data !== "undefined") {
                dataSet = raw.data;
              }
              return dataSet;
            },
          },
        },
        pageSize: 10,
        serverPaging: !0,
        serverFiltering: !0,
      },
      layout: {
        class: "m--margin-top-5",
        scroll: false,
        footer: !1,
        smoothScroll: {
          scrollbarShown: true,
        },
      },
      sortable: !0,
      pagination: !0,
      toolbar: {
        items: {
          pagination: {
            pageSizeSelect: [10, 20, 30, 50, 100],
          },
        },
      },
      detail: {
        title: "Load sub table",
        content: subTableInit,
      },
      search: {
        onChange: true,
        input: $("#SearchValue"),
        delay: 400,
      },
      rows: {},
      columns: [
        {
          field: "SoNo",
          title: "",
          sortable: false,
          width: 20,
          textAlign: "center",
        },
        {
          field: "SerialNo",
          title: "Order#",
          width: 100,
          template: function (t) {
            t.SerialNo = t.SerialNo == null ? "" : t.SerialNo;
            t.SoDate = t.SoDate == null ? "Sales Order Date" : t.SoDate;
            t.ReferenceNo =
              t.ReferenceNo == "" ? "Reference No" : t.ReferenceNo;
            t.SalesPerson =
              t.SalesPerson == "" ? "Sales Person" : t.SalesPerson;
            return (
              '\
                    <span class="m--font-bold text-info" title="SalesOrder Number">' +
              t.SoNo +
              '</span>\
                    <br/> <span class="m--font-bold" title="Sales Order Date">' +
              t.SoDate +
              '</span>\
                    <br/> <span class="m--font-bold" title="ReferenceNo" style="font-size: 10px">' +
              t.ReferenceNo +
              '</span>\
                    <br/> <span class="m--font-bold" title="SalesPerson" style="font-size: 10px">' +
              t.SalesPerson +
              "</span>\
                    "
            );
          },
        },
        {
          field: "CustomerAccount",
          title: "Details",
          filterable: !1,
          width: 100,
          template: function (t) {
            return (
              '\
                        <span class="m--font-bold" title = "Customer Account">' +
              t.Customer +
              ' </span>\
                        <br/> <span class="m--font-bold" title = "Customer" style="font-size: 12px">' +
              t.City +
              '</span>\
                        <br/> <span class="m--font-bold" title="Delivery Address" style="font-size: 10px">' +
              t.CustomerAccount +
              " </span>\
                     "
            );
          },
        },

        {
          field: "DACC",
          title: "DACC",
          filterable: !1,
          width: 80,
          template: function (row, index, datatable) {
            var checkedVal = "";
            if (row.DACC) {
              checkedVal = "checked";
            }
            return (
              '\
                    <span class="m-switch--sm m-switch m-switch--outline m-switch--info"> \
                        <label for="DACC_' +
              index +
              '">\
                            <input id="DACC_' +
              index +
              '" disabled ' +
              checkedVal +
              ' class="form-control m-input" type="checkbox" (change)="' +
              row.DACC +
              " = !" +
              row.DACC +
              '">\
                            <span></span>\
                        </label>\
                    </span> \
                    '
            );
          },
        },
        {
          field: "OriginalPOD",
          title: "OriginalPOD",
          filterable: !1,
          width: 100,
          template: function (row, index, datatable) {
            var checkedVal = "";
            if (row.OriginalPOD) {
              checkedVal = "checked";
            }
            return (
              '\
                    <span class="m-switch--sm m-switch m-switch--outline m-switch--info"> \
                        <label for="OriginalPOD_' +
              index +
              '">\
                            <input id="OriginalPOD_' +
              index +
              '" disabled ' +
              checkedVal +
              ' class="form-control m-input" type="checkbox" (change)="' +
              row.OriginalPOD +
              " = !" +
              row.OriginalPOD +
              '">\
                            <span></span>\
                        </label>\
                    </span> \
                    '
            );
          },
        },
        {
          field: "SpecialPOD",
          title: "SpecialPOD",
          filterable: !1,
          width: 100,
          template: function (row, index, datatable) {
            var checkedVal = "";
            if (row.SpecialPOD) {
              checkedVal = "checked";
            }
            return (
              '\
                    <span class="m-switch--sm m-switch m-switch--outline m-switch--info"> \
                        <label for="SpecialPOD_' +
              index +
              '">\
                            <input id="SpecialPOD_' +
              index +
              '" disabled ' +
              checkedVal +
              ' class="form-control m-input" type="checkbox" (change)="' +
              row.SpecialPOD +
              " = !" +
              row.SpecialPOD +
              '">\
                            <span></span>\
                        </label>\
                    </span> \
                    '
            );
          },
        },
        {
          field: "NoOfFloor",
          title: "No.of Floor",
          filterable: !1,
          width: 50,
          tooltip: "No Of Floor",
        },
      ],
    }));
    function subTableInit(e) {
      this.childDatatable = $("<div/>")
        .attr("id", "m_datatable_ChildOrderBooking_" + e.data.SoNo)
        .appendTo(e.detailCell)
        .mDatatable({
          data: {
            type: "remote",
            source: {
              read: {
                url: environment.apiUrl + "api/Booking/GetBookingItemList",
                params: {
                  query: {
                    generalSearch: $("#SearchValue").val(),
                    SoNo: e.data.SoNo,
                    VehicleId: e.data.VehicleId,
                    VehicalSrNo: e.data.VehicalSrNo,
                    QuoteId: e.data.QuoteId,
                  },
                },
              },
            },
            pageSize: 10,
            serverPaging: true,
            serverFiltering: false,
            serverSorting: !0,
          },

          // layout definition
          layout: {
            theme: "default",
            scroll: true,
            // height: 100,
            footer: false,

            // enable/disable datatable spinner.
            spinner: {
              type: 1,
              theme: "default",
            },
          },

          sortable: true,

          // columns definition
          columns: [
            {
              field: "ProductCode",
              title: "Item",
              sortable: true,
              width: 90,
            },
            {
              field: "ProductName",
              title: "Description",
              sortable: true,
              width: 90,
            },
            {
              field: "LotId",
              title: "LotId",
              sortable: true,
              width: 90,
            },
            {
              field: "ETA",
              title: "ETA",
              width: 80,
            },
            {
              field: "Weight",
              title: "Weight",
              type: "number",
              width: 50,
            },
            {
              field: "Quantity",
              title: "Qty",
              type: "number",
              width: 50,
            },
          ],
        });
    }
  }

  // -------------------------------------------------Insert Code-----------------------------------------------------

  SaveLorryReceipt() {
    var flag = this.ValidateFields();
    if (flag != false) {
      this.LorryReceipt.CompanyId = JSON.parse(
        localStorage.getItem("ChnageCompnayId")
      ).Id;

      this.LorryReceipt.BookingId =
        BookingComponent.bookingComponent.BookingBasicDetail.Id;
      this.LorryReceipt.InDateTime = moment(
        $("#InDateTime").datetimepicker("getDate")
      ).format("YYYY-MM-DD HH:mm");
      this.LorryReceipt.OutDateTime = moment(
        $("#OutDateTime").datetimepicker("getDate")
      ).format("YYYY-MM-DD HH:mm");
      //this.LorryReceipt.DriverMobileNo = parseInt(this.LorryReceipt.DriverMobileNo);
      let len = this.PrimaryDeliveryDetails.length;
      for (let i = 0; i < this.PrimaryDeliveryDetails.length; i++) {
        this.FCDetailList[i] = {};
        this.FCDetailList[i] = this.PrimaryDeliveryDetails[i];

        if ($("#ExpiryDatePrimary_" + i).val() != "") {
          this.FCDetailList[i].ExpiryDate = moment(
            $("#ExpiryDatePrimary_" + i).datepicker("getDate")
          ).format("YYYY-MM-DD");
        }
        if ($("#PGateIn_" + i).val() != "") {
          this.FCDetailList[i].GateIn = moment(
            $("#PGateIn_" + i).datetimepicker("getDate")
          ).format("YYYY-MM-DD HH:mm");
        } else {
          this.FCDetailList[i].GateIn = null;
        }
        if ($("#PGateOut_" + i).val() != "") {
          this.FCDetailList[i].GateOut = moment(
            $("#PGateOut_" + i).datetimepicker("getDate")
          ).format("YYYY-MM-DD HH:mm");
        } else {
          this.FCDetailList[i].GateOut = null;
        }

        var x = $("#PODPrimaryUpload_" + i).val();
        if (x != null && x != "" && x != undefined) {
          var res = x.split("\\");
          var fullName = res[2];
          var file = fullName.split(".");
          if (file.length > 2) {
            this.FCDetailList[i].FileName =
              file[0] + "." + file[file.length - 2];
            this.FCDetailList[i].FileExtension = file[file.length - 1];
          } else {
            this.FCDetailList[i].FileName = file[0];
            this.FCDetailList[i].FileExtension = file[1];
          }
        }
      }
      for (let i = 0; i < this.SecondaryDeliveryDetails.length; i++) {
        this.FCDetailList[len + i] = {};
        this.FCDetailList[len + i] = this.SecondaryDeliveryDetails[i];
        if ($("#ExpiryDateSecondary_" + i).val() != "") {
          this.FCDetailList[len + i].ExpiryDate = moment(
            $("#ExpiryDateSecondary_" + i).datepicker("getDate")
          ).format("YYYY-MM-DD");
          // this.SecondaryDeliveryDetails[i].ExpiryDate = this.datepipe.transform(moment($('#ExpiryDateSecondary_' + i).datepicker("getDate")), "dd/MM/yyyy");
        }

        if ($("#SGateIn_" + i).val() != "") {
          this.FCDetailList[len + i].GateIn = moment(
            $("#SGateIn_" + i).datetimepicker("getDate")
          ).format("YYYY-MM-DD HH:mm");
        } else {
          this.FCDetailList[len + i].GateIn = null;
        }
        if ($("#SGateOut_" + i).val() != "") {
          this.FCDetailList[len + i].GateOut = moment(
            $("#SGateOut_" + i).datetimepicker("getDate")
          ).format("YYYY-MM-DD HH:mm");
        } else {
          this.FCDetailList[len + i].GateOut = null;
        }

        var x = $("#PODSecondaryUpload_" + i).val();
        if (x != null && x != "" && x != undefined) {
          var res = x.split("\\");
          var fullName = res[2];
          var file = fullName.split(".");
          if (file.length > 2) {
            this.FCDetailList[len + i].FileName =
              file[0] + "." + file[file.length - 2];
            this.FCDetailList[len + i].FileExtension = file[file.length - 1];
          } else {
            this.FCDetailList[len + i].FileName = file[0];
            this.FCDetailList[len + i].FileExtension = file[1];
          }
        }
      }

      this._appService
        .Post("Booking", "SaveLorryReceipt", this.LorryReceipt)
        .subscribe(
          (response) => {
            if (response > 0) {
              this._appService
                .Post("Booking", "SaveLRDistribution", this.FCDetailList)
                .subscribe(
                  (response) => {
                    this.toastr.success(
                      "Details saved Successfully !",
                      "Success"
                    );
                  },
                  (err) => {
                    this.toastr.error(
                      "Error occurred while saving Distribution data !",
                      "error"
                    );
                  }
                );
            }
          },
          (err) => {
            this.toastr.error("Error occurred while saving data !", "error");
          }
        );
    } else {
      this.toastr.error("Please Enter Required Field !", "error");
    }
  }
  SaveTracking() {
    this.trackingBooking.CompanyId = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).Id;
    for (let index = 0; index < this.trackingBooking.length; index++) {
      this.trackingBooking[index].BookingId =
        BookingComponent.bookingComponent.BookingBasicDetail.Id;
      if ($("#Estimate_" + index).val() != "") {
        this.trackingBooking[index].Estimate = moment(
          $("#Estimate_" + index).datetimepicker("getDate")
        ).format("YYYY-MM-DD HH:mm"); //$("#Estimate_" + index).val();
      } else {
        this.trackingBooking[index].Estimate = null;
      }
      if ($("#Estimate_" + index).val() != "") {
        this.trackingBooking[index].Actual = moment(
          $("#Actual_" + index).datetimepicker("getDate")
        ).format("YYYY-MM-DD HH:mm"); // $("#Actual_" + index).val();
      } else {
        this.trackingBooking[index].Actual = null;
      }
      if (this.trackingBooking[index].Estimate == "Invalid date") {
        this.trackingBooking[index].Estimate = "";
      }
      if (this.trackingBooking[index].Actual == "Invalid date") {
        this.trackingBooking[index].Actual = "";
      }
      var x = $("#TrackingUpload_" + index).val();
      if (x != null && x != "" && x != undefined) {
        var res = x.split("\\");
        var fullName = res[2];
        var file = fullName.split(".");
        if (file.length > 2) {
          this.trackingBooking[index].FileName =
            file[0] + "." + file[file.length - 2];
          this.trackingBooking[index].FileExtension = file[file.length - 1];
        } else {
          this.trackingBooking[index].FileName = file[0];
          this.trackingBooking[index].FileExtension = file[1];
        }
      }
    }
    this._appService
      .Post("Booking", "TrackingData", this.trackingBooking)
      .subscribe(
        (response) => {
          this.toastr.success("Tracking data saved Successfully !", "Success");
        },
        (err) => {
          this.toastr.error("Error occurred while saving data !", "error");
        }
      );
  }
  SaveInvoiceDate() {
    for (let index = 0; index < this.BookingInvoiceList.length; index++) {
      this.BookingInvoiceList[index].BookingId =
        BookingComponent.bookingComponent.BookingBasicDetail.Id;
      this.BookingInvoiceList[index].InvoiceDate = moment(
        $("#InvoiceDate_" + index).datepicker("getDate")
      ).format("YYYY-MM-DD");
      this.BookingInvoiceList.CompanyId = JSON.parse(
        localStorage.getItem("ChnageCompnayId")
      ).Id;
      if (this.BookingInvoiceList[index].InvoiceDate == "Invalid date") {
        this.BookingInvoiceList[index].InvoiceDate = "";
      }

      var x = $("#InvoiceUpload_" + index).val();
      if (x != null && x != "" && x != undefined) {
        var res = x.split("\\");
        var fullName = res[2];
        var file = fullName.split(".");
        if (file.length > 2) {
          this.BookingInvoiceList[index].FileName =
            file[0] + "." + file[file.length - 2];
          this.BookingInvoiceList[index].FileExtension = file[file.length - 1];
        } else {
          this.BookingInvoiceList[index].FileName = file[0];
          this.BookingInvoiceList[index].FileExtension = file[1];
        }
      }
    }
    this._appService
      .Post("Booking", "SaveInvoice", this.BookingInvoiceList)
      .subscribe(
        (response) => {
          this.toastr.success("Invoice data saved Successfully !", "Success");
        },
        (err) => {
          this.toastr.error("Error occurred while saving data !", "error");
        }
      );
  }
  SaveFreightAudit() {
    let pl = this.FreightAuditPrimary.length;
    let sl = this.FreightAuditSecondary.length + pl;
    for (let i = 0; i < this.FreightAuditPrimary.length; i++) {
      this.FreightAudit.CompanyId = JSON.parse(
        localStorage.getItem("ChnageCompnayId")
      ).Id;
      this.FreightAudit[i] = {};
      this.FreightAudit[i].ChargeId = this.FreightAuditPrimary[i].Id;
      this.FreightAudit[i].BookingId =
        BookingComponent.bookingComponent.BookingBasicDetail.Id;
      this.FreightAudit[i].EstimatedAmount = $("#PrimaryERate_" + i).val();
      this.FreightAudit[i].ActualAmount = $("#PrimaryARate_" + i).val();
      this.FreightAudit[i].ChargeType = "P";
    }
    for (let i = 0; i < this.FreightAuditSecondary.length; i++) {
      this.FreightAudit.CompanyId = JSON.parse(
        localStorage.getItem("ChnageCompnayId")
      ).Id;
      this.FreightAudit[pl + i] = {};
      this.FreightAudit[pl + i].ChargeId = this.FreightAuditSecondary[i].Id;
      this.FreightAudit[pl + i].BookingId =
        BookingComponent.bookingComponent.BookingBasicDetail.Id;
      this.FreightAudit[pl + i].EstimatedAmount = $(
        "#SecondaryERate_" + i
      ).val();
      this.FreightAudit[pl + i].ActualAmount = $("#SecondaryARate_" + i).val();
      this.FreightAudit[pl + i].ChargeType = "S";
    }
    for (
      let i = 0;
      i < BookingComponent.bookingComponent.FreightAuditAdditional.length;
      i++
    ) {
      this.FreightAudit.CompanyId = JSON.parse(
        localStorage.getItem("ChnageCompnayId")
      ).Id;
      this.FreightAudit[sl + i] = {};
      this.FreightAudit[sl + i].ChargeId =
        BookingComponent.bookingComponent.FreightAuditAdditional[i].Id;
      this.FreightAudit[sl + i].BookingId =
        BookingComponent.bookingComponent.BookingBasicDetail.Id;
      this.FreightAudit[sl + i].EstimatedAmount = 0;
      this.FreightAudit[sl + i].ActualAmount =
        BookingComponent.bookingComponent.FreightAuditAdditional[i].rate;
      this.FreightAudit[sl + i].ChargeType = "A";
    }

    this._appService
      .Post("Booking", "SaveFreightAudit", this.FreightAudit)
      .subscribe(
        (response) => {
          this.toastr.success(
            "Freight Audit data saved Successfully !",
            "Success"
          );
        },
        (err) => {
          this.toastr.error("Error occurred while saving data !", "error");
        }
      );
  }
  SaveExpense() {
    this.BookingExpense.BookingId =
      BookingComponent.bookingComponent.BookingBasicDetail.Id;
    this.BookingExpense.CompanyId = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).Id;
    $("#ExpenseBillDate").val(
      this.datepipe.transform(this.BookingExpense.BillDate, "dd/MM/yyyy")
    );

    var d = moment($("#ExpenseBillDate").datepicker("getDate")).format(
      "YYYY-MM-DD"
    );
    if (
      moment($("#ExpenseBillDate").datepicker("getDate")).format(
        "YYYY-MM-DD"
      ) != "Invalid date"
    ) {
      this.BookingExpense.BillDate = moment(
        $("#ExpenseBillDate").datepicker("getDate")
      ).format("YYYY-MM-DD");
    } else {
      var date = new Date(this.BookingExpense.BillDate);
      this.BookingExpense.BillDate =
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
    }
    this.BookingExpense.Amount = parseInt($("#PaymentAmount").val() || 0);
    this.BookingExpense.Total = parseInt($("#PaymentTotal").text() || 0);
    this.BookingExpense.Remark = $("#PaymentRemark").val();

    this._appService
      .Post("Booking", "SaveExpense", this.BookingExpense)
      .subscribe(
        (response) => {
          this.GetExpenseById(
            BookingComponent.bookingComponent.BookingBasicDetail.Id
          );
          $("#ExpenseBillDate").val("");
          this.toastr.success("Expense data saved Successfully !", "Success");
          $("#ModalNewExpense").modal("hide");
        },
        (err) => {
          $("#ModalNewExpense").modal("hide");
          this.toastr.error("Error occurred while saving data !", "error");
        }
      );
  }
  SavePayment() {
    let i = 0;
    BookingComponent.bookingComponent.BookingPayment = [];

    $("#tblPayment").each(function () {
      $(this)
        .find("tr#PaymentRow0")
        .each(function () {
          BookingComponent.bookingComponent.BookingPayment.CompanyId =
            JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
          BookingComponent.bookingComponent.BookingPayment[i] = {};
          BookingComponent.bookingComponent.BookingPayment[i].BookingId =
            BookingComponent.bookingComponent.BookingBasicDetail.Id;
          BookingComponent.bookingComponent.BookingPayment[i].PaymentAmount = $(
            this
          )
            .find("td#templateAmount .ClstemplateAmount")
            .val();
          BookingComponent.bookingComponent.BookingPayment[i].PaymentDate =
            moment(
              $(this)
                .find("td#templateDate .ClstemplateDate")
                .datepicker("getDate")
            ).format("YYYY-MM-DD");
          BookingComponent.bookingComponent.BookingPayment[i].Account = $(this)
            .find("td#templateBankAccount .ClstemplateBankAccount")
            .val();
          BookingComponent.bookingComponent.BookingPayment[i].PaymentMode = $(
            this
          )
            .find("td#templatePaymentMode .ClstemplatePaymentMode")
            .val();
          BookingComponent.bookingComponent.BookingPayment[i].ReferenceNo = $(
            this
          )
            .find("td#templateRefNo .ClstemplateRefNo")
            .val();

          var x = $(this).find("td#templeteAction .PaymentHidden").val();
          if (x != null && x != "" && x != undefined) {
            var res = x.split("\\");
            var fullName = res[2];
            var file = fullName.split(".");
            if (file.length > 2) {
              BookingComponent.bookingComponent.BookingPayment[i].FileName =
                file[0] + "." + file[file.length - 2];
              BookingComponent.bookingComponent.BookingPayment[
                i
              ].FileExtension = file[file.length - 1];
            } else {
              BookingComponent.bookingComponent.BookingPayment[i].FileName =
                file[0];
              BookingComponent.bookingComponent.BookingPayment[
                i
              ].FileExtension = file[1];
            }
          }

          i++;
        });
      return false;
    });
    this._appService
      .Post(
        "Booking",
        "SavePayment",
        BookingComponent.bookingComponent.BookingPayment
      )
      .subscribe(
        (response) => {
          this.toastr.success("Payment data saved Successfully !", "Success");
        },
        (err) => {
          this.toastr.error("Error occurred while saving data !", "error");
        }
      );
  }

  SaveReceipt() {
    let i = 0;
    BookingComponent.bookingComponent.BookingReceipt = [];
    $("#tblReceipt").each(function () {
      $(this)
        .find("tr#ReceiptRow0")
        .each(function () {
          BookingComponent.bookingComponent.BookingReceipt[i].CompanyId =
            JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
          BookingComponent.bookingComponent.BookingReceipt[i] = {};
          BookingComponent.bookingComponent.BookingReceipt[i].BookingId =
            BookingComponent.bookingComponent.BookingBasicDetail.Id;
          BookingComponent.bookingComponent.BookingReceipt[i].ReceiptAmount = $(
            this
          )
            .find("td#ReceiptAmount .ClsReceiptAmount")
            .val();
          BookingComponent.bookingComponent.BookingReceipt[i].ReceiptDate =
            moment(
              $(this)
                .find("td#ReceiptDate .ClsReceiptDate")
                .datepicker("getDate")
            ).format("YYYY-MM-DD");
          BookingComponent.bookingComponent.BookingReceipt[i].Account = $(this)
            .find("td#ReceiptAccount .ClsReceiptAccount")
            .val();
          BookingComponent.bookingComponent.BookingReceipt[i].PaymentMode = $(
            this
          )
            .find("td#ReceiptMode .ClsReceiptMode")
            .val();
          BookingComponent.bookingComponent.BookingReceipt[i].ReferenceNo = $(
            this
          )
            .find("td#ReceiptNo .ClsReceiptNo")
            .val();
          i++;
        });
    });
    this._appService
      .Post(
        "Booking",
        "SaveReceipt",
        BookingComponent.bookingComponent.BookingReceipt
      )
      .subscribe(
        (response) => {
          this.toastr.success("Receipt data saved Successfully !", "Success");
        },
        (err) => {
          this.toastr.error("Error occurred while saving data !", "error");
        }
      );
  }

  // --------------------------Edit Code---------------------------------

  OnEditBookingClick(Id, QuoteId, TransporterId, VehicleCapacity, VehicleId) {
    Helpers.setLoading(true);
    this._appService
      .GetListByFiveParameters(
        "Booking",
        "GetLorryReceiptDistribution",
        Id,
        QuoteId,
        VehicleCapacity,
        TransporterId,
        VehicleId
      )
      .subscribe((response) => {
        // -------------Lorry Receipt Distribution---------------

        this.PrintFCData = response.LorryReceiptRoute;

        // -------------Freight Audit data-----------------------

        this.FreightAuditPrimary =
          response.LorryReceiptRoute.FCPrintData.PrimaryDistData;
        this.FreightAuditSecondary =
          response.LorryReceiptRoute.FCPrintData.SecondaryDistData;

        for (let i = 0; i < this.FreightAuditPrimary.length; i++) {
          if (this.FreightAuditPrimary[i].ChargeCode == "PDFR") {
            this.FreightAuditPrimary[i].Rate =
              this.PrintFCData.FCDetailList[0].PDFR;
          }
          if (this.FreightAuditPrimary[i].ChargeCode == "MDC") {
            this.FreightAuditPrimary[i].Rate =
              this.PrintFCData.FCDetailList[0].MDC;
          }
          if (this.FreightAuditPrimary[i].ChargeCode == "PODC") {
            this.FreightAuditPrimary[i].Rate =
              this.PrintFCData.FCDetailList[0].ODC;
          }
        }
        for (let i = 0; i < this.FreightAuditSecondary.length; i++) {
          if (this.FreightAuditSecondary[i].ChargeCode == "SDC") {
            this.FreightAuditSecondary[i].Rate =
              this.PrintFCData.FCDetailList[0].GHC;
          }
          if (this.FreightAuditSecondary[i].ChargeCode == "SDFR") {
            this.FreightAuditSecondary[i].Rate =
              this.PrintFCData.FCDetailList[0].SDFR;
          }
          if (this.FreightAuditSecondary[i].ChargeCode == "SODC") {
            this.FreightAuditSecondary[i].Rate =
              this.PrintFCData.FCDetailList[0].SODC;
          }
        }
        this.PrimaryDeliveryDetails =
          response.LorryReceiptRoute.PrimaryDeliveryDetails;
        this.SecondaryDeliveryDetails =
          response.LorryReceiptRoute.SecondaryDeliveryDetails;

        for (let i = 0; i < this.PrimaryDeliveryDetails.length; i++) {
          this.PrimaryDeliveryDetails[i].ExpiryDate = this.datepipe.transform(
            this.PrimaryDeliveryDetails[i].ExpiryDate,
            "dd/MM/yyyy"
          );
          this.PrimaryDeliveryDetails[i].GateIn = this.datepipe.transform(
            this.PrimaryDeliveryDetails[i].GateIn,
            "dd/MM/yyyy HH:mm"
          );
          this.PrimaryDeliveryDetails[i].GateOut = this.datepipe.transform(
            this.PrimaryDeliveryDetails[i].GateOut,
            "dd/MM/yyyy HH:mm"
          );

          //Route Details Primary
          this.RouteDetailPrimary[i] = {};
          this.RouteDetailPrimary[i].Weight =
            this.PrimaryDeliveryDetails[i].Weight;
          this.RouteDetailPrimary[i].Distance =
            this.PrimaryDeliveryDetails[i].KMS;
          this.RouteDetailPrimary[i].FromLocation =
            this.PrimaryDeliveryDetails[i].FromAddress;
          this.RouteDetailPrimary[i].ToLocation =
            this.PrimaryDeliveryDetails[i].ToAddress;
        }
        for (let i = 0; i < this.SecondaryDeliveryDetails.length; i++) {
          this.SecondaryDeliveryDetails[i].ExpiryDate = this.datepipe.transform(
            this.SecondaryDeliveryDetails[i].ExpiryDate,
            "dd/MM/yyyy"
          );
          this.SecondaryDeliveryDetails[i].GateIn = this.datepipe.transform(
            this.SecondaryDeliveryDetails[i].GateIn,
            "dd/MM/yyyy HH:mm"
          );
          this.SecondaryDeliveryDetails[i].GateOut = this.datepipe.transform(
            this.SecondaryDeliveryDetails[i].GateOut,
            "dd/MM/yyyy HH:mm"
          );

          //Route Details Secondary
          this.RouteDetailSecondary[i] = {};
          this.RouteDetailSecondary[i].Weight =
            this.SecondaryDeliveryDetails[i].Weight;
          this.RouteDetailSecondary[i].Distance =
            this.SecondaryDeliveryDetails[i].KMS;
          this.RouteDetailSecondary[i].FromLocation =
            this.SecondaryDeliveryDetails[i].FromAddress;
          this.RouteDetailSecondary[i].ToLocation =
            this.SecondaryDeliveryDetails[i].ToAddress;
        }

        // --------------- Route ---------------
        this.RouteDataPrimary = response.LorryReceiptRoute.PrimaryRoute;
        this.RouteDataSeconadry = response.LorryReceiptRoute.SecondaryRoute;

        // this.GetPrimaryDifference();

        //-------Lorry Receipt--------

        if (response.GetAllBooking.BookingLorryReceipt != null) {
          this.LorryReceipt = response.GetAllBooking.BookingLorryReceipt;
          $("#InDateTime").val(
            this.datepipe.transform(
              this.LorryReceipt.InDateTime,
              "dd/MM/yyyy HH:mm"
            )
          );
          $("#OutDateTime").val(
            this.datepipe.transform(
              this.LorryReceipt.OutDateTime,
              "dd/MM/yyyy HH:mm"
            )
          );
        }
        //------------Summary---------
        if (response.GetAllBooking.AdditionalFCDetail != null) {
          this.BookingSummaryDetail = response.GetAllBooking.AdditionalFCDetail;
          this.BookingSummaryDetail.ProductWeight =
            this.BookingSummaryDetail.ProductWeight.toFixed(2);
          this.BookingSummaryDetail.TruckMT = (
            this.BookingSummaryDetail.VehicleCapacity / 1000
          ).toFixed(1);
          this.BookingSummaryDetail.ProductMT = (
            this.BookingSummaryDetail.ProductWeight / 1000
          ).toFixed(1);

          this.TotalRate = this.BookingSummaryDetail.BillTotalAmount;
          this.FreightSpent = this.BookingSummaryDetail.BillTotalAmount;
          this.PaymentBillAmount = this.BookingSummaryDetail.BillTotalAmount;
          // -----------Weight---------------
          if (this.BookingSummaryDetail.VehicleCapacity == 0) {
            this.BookingSummaryDetail.GrossWeightInPer = 100;
          } else {
            this.BookingSummaryDetail.GrossWeightInPer = (
              (this.BookingSummaryDetail.ProductWeight * 100) /
              parseInt(this.BookingSummaryDetail.VehicleCapacity || 1)
            ).toFixed(2);
          }
          document.getElementById("progressWeight").style.width =
            this.BookingSummaryDetail.GrossWeightInPer + "%";
          // -----------Volume---------------
          if (
            this.BookingSummaryDetail.TruckVolume == null ||
            this.BookingSummaryDetail.TruckVolume == 0
          ) {
            //this.BookingSummaryDetail.VolumePer = 100;
            this.BookingSummaryDetail.VolumePer = 0;
          } else {
            this.BookingSummaryDetail.VolumePer = (
              (parseFloat(this.BookingSummaryDetail.ProductVolume) * 100) /
              this.BookingSummaryDetail.TruckVolume
            ).toFixed(2);
            if (this.BookingSummaryDetail.VolumePer > 100) {
              this.BookingSummaryDetail.VolumePer = 100;
            }
          }
          document.getElementById("progressVolume").style.width =
            this.BookingSummaryDetail.VolumePer + "%";
        }

        if (response.GetAllBooking.BookingSecondaryDetail != null) {
          this.BookingSummaryDetail.SecondaryProductWeightMT = (
            response.GetAllBooking.BookingSecondaryDetail.ProductWeight / 1000
          ).toFixed(1);
          this.BookingSummaryDetail.SecondaryProductWeight = parseInt(
            response.GetAllBooking.BookingSecondaryDetail.ProductWeight
          );
          this.BookingSummaryDetail.SecondaryVehicleMT =
            response.GetAllBooking.BookingSecondaryDetail.VehicleWeight;
          this.BookingSummaryDetail.SecondaryVehicleWeight =
            response.GetAllBooking.BookingSecondaryDetail.VehicleCapacity;
          this.BookingSummaryDetail.SecondaryFreightCost =
            response.GetAllBooking.BookingSecondaryDetail.FreightCost;
          this.BookingSummaryDetail.SecondaryOrderCount =
            response.GetAllBooking.BookingSecondaryDetail.OrderCount;
          this.BookingSummaryDetail.SecondaryQuantity =
            response.GetAllBooking.BookingSecondaryDetail.Quantity;
        }
        this.BookingSummaryDetail.PSTotalVehicleWt =
          parseInt(this.BookingSummaryDetail.VehicleCapacity || 0) +
          parseInt(this.BookingSummaryDetail.SecondaryVehicleWeight || 0);
        this.BookingSummaryDetail.PSTotalFreightCost =
          parseInt(this.BookingSummaryDetail.FreightCost || 0) +
          parseInt(this.BookingSummaryDetail.SecondaryFreightCost || 0);
        this.BookingSummaryDetail.PSTotalOrder =
          parseInt(this.BookingSummaryDetail.OrderCount || 0) +
          parseInt(this.BookingSummaryDetail.SecondaryOrderCount || 0);
        this.BookingSummaryDetail.PSTotalQuantity =
          parseInt(this.BookingSummaryDetail.Quantity || 0) +
          parseInt(this.BookingSummaryDetail.SecondaryQuantity || 0);
        this.BookingSummaryDetail.PSTotalProductWt =
          parseInt(this.BookingSummaryDetail.ProductWeight || 0) +
          parseInt(this.BookingSummaryDetail.SecondaryProductWeight || 0);
        // -----------Freight---------------

        if (this.BookingSummaryDetail.PSTotalFreightCost != 0) {
          this.BookingSummaryDetail.FreightSpentPer = (
            (this.TotalRate * 100) /
            this.BookingSummaryDetail.FreightCost
          ).toFixed(2);
        } else {
          this.BookingSummaryDetail.FreightSpentPer = 0;
        }
        if (this.BookingSummaryDetail.FreightSpentPer > 100) {
          this.BookingSummaryDetail.FreightSpentPer = 100;
        }
        document.getElementById("progressFreight").style.width =
          this.BookingSummaryDetail.FreightSpentPer + "%";
        //-----------Invoice----------

        if (response.GetAllBooking.BookingInvoice.length != 0) {
          this.BookingInvoiceList = response.GetAllBooking.BookingInvoice;
        } else {
          this.GetBookingInvoiceList();
        }
        //---------Freight Audit------

        if (response.GetAllBooking.FreightAuditPrimary.length != 0) {
          this.BillFreightAuditPrimary =
            response.GetAllBooking.FreightAuditPrimary;
        }
        if (response.GetAllBooking.FreightAuditSecondary.length != 0) {
          this.BillFreightAuditSecondary =
            response.GetAllBooking.FreightAuditSecondary;
        }
        if (response.GetAllBooking.FreightAuditAdditional.length != 0) {
          this.BillFreightAuditAdditional =
            response.GetAllBooking.FreightAuditAdditional;
        }

        //------------Tracking---------
        if (response.GetAllBooking.BookingTracking.length != 0) {
          this.trackingBooking = response.GetAllBooking.BookingTracking;
        }
        //--------------Payment----------

        if (response.GetAllBooking.BookingPayment.length != 0) {
          this.BookingPayment = response.GetAllBooking.BookingPayment;
          for (let i = 1; i < this.BookingPayment.length; i++) {
            this.AddPaymentRow();
          }
          var i = 0;
          $("#tblPayment").each(function () {
            $(this)
              .find("tr#PaymentRow0")
              .each(function () {
                $(this)
                  .find("td#templateAmount .ClstemplateAmount")
                  .val(
                    BookingComponent.bookingComponent.BookingPayment[i]
                      .PaymentAmount
                  );
                $(this)
                  .find("td#templateDate .ClstemplateDate")
                  .val(
                    BookingComponent.bookingComponent.datepipe.transform(
                      BookingComponent.bookingComponent.BookingPayment[i]
                        .PaymentDate,
                      "dd/MM/yyyy"
                    )
                  );
                $(this)
                  .find("td#templateBankAccount .ClstemplateBankAccount")
                  .val(
                    BookingComponent.bookingComponent.BookingPayment[i].Account
                  );
                $(this)
                  .find("td#templatePaymentMode .ClstemplatePaymentMode")
                  .val(
                    BookingComponent.bookingComponent.BookingPayment[i]
                      .PaymentMode
                  );
                $(this)
                  .find("td#templateRefNo .ClstemplateRefNo")
                  .val(
                    BookingComponent.bookingComponent.BookingPayment[i]
                      .ReferenceNo
                  );

                if (
                  BookingComponent.bookingComponent.BookingPayment[i]
                    .FileName != null &&
                  BookingComponent.bookingComponent.BookingPayment[i]
                    .FileExtension != null
                ) {
                  $(this)
                    .find("td#templeteAction .PaymentHidden")
                    .val(
                      "C:\\fakepath\\" +
                      BookingComponent.bookingComponent.BookingPayment[i]
                        .FileName +
                      "." +
                      BookingComponent.bookingComponent.BookingPayment[i]
                        .FileExtension
                    );
                  $(this)
                    .find("td#templeteAction .PaymentPaperClip")
                    .prop(
                      "title",
                      BookingComponent.bookingComponent.BookingPayment[i]
                        .FileName +
                      "." +
                      BookingComponent.bookingComponent.BookingPayment[i]
                        .FileExtension
                    );
                  $(this).find("td#templeteAction .PaymentPaperClip").show();
                } else {
                  $(this).find("td#templeteAction .PaymentPaperClip").hide();
                }

                i++;
              });
          });
          this.CalculatePaidAmount("FromPayment");
        }
        //--------------Receipt----------
        if (response.GetAllBooking.BookingReceipt.length != 0) {
          this.BookingReceipt = response.GetAllBooking.BookingReceipt;
          for (let i = 1; i < this.BookingReceipt.length; i++) {
            this.AddReceiptRow();
          }
          var i = 0;
          $("#tblReceipt").each(function () {
            $(this)
              .find("tr#ReceiptRow0")
              .each(function () {
                $(this)
                  .find("td#ReceiptAmount .ClsReceiptAmount")
                  .val(
                    BookingComponent.bookingComponent.BookingReceipt[i]
                      .ReceiptAmount
                  );
                $(this)
                  .find("td#ReceiptDate .ClsReceiptDate")
                  .val(
                    BookingComponent.bookingComponent.datepipe.transform(
                      BookingComponent.bookingComponent.BookingReceipt[i]
                        .ReceiptDate,
                      "dd/MM/yyyy"
                    )
                  );
                $(this)
                  .find("td#ReceiptAccount .ClsReceiptAccount")
                  .val(
                    BookingComponent.bookingComponent.BookingReceipt[i].Account
                  );
                $(this)
                  .find("td#ReceiptMode .ClsReceiptMode")
                  .val(
                    BookingComponent.bookingComponent.BookingReceipt[i]
                      .PaymentMode
                  );
                $(this)
                  .find("td#ReceiptNo .ClsReceiptNo")
                  .val(
                    BookingComponent.bookingComponent.BookingReceipt[i]
                      .ReferenceNo
                  );
                i++;
              });
          });
          this.CalculatePaidAmount("FromReceipt");
        }
      });
    this.showBookingList = false;
    this.showBookingDetails = true;

    this.RefreshvalidDate();
    setTimeout(() => {
      Helpers.setLoading(false);
    }, 300);
  }

  GetExpenseById(Id) {
    this._appService.GetById("Booking", "GetExpenseById", Id).subscribe(
      (response) => {
        this.BookingExpenseList = response;
        for (let i = 0; i < this.BookingExpenseList.length; i++) {
          this.BookingExpenseList[i].BillDate = this.datepipe.transform(
            this.BookingExpenseList[i].BillDate,
            "dd/MM/yyyy"
          );
        }
      },
      (err) => {
        this.toastr.error("Error occurred while fetching data !", "error");
      }
    );
  }

  OnAddExpense() {
    this.BookingExpense = {};
    $("#PaymentTotal").text(0);
    $("#PaymentRemark").val("");
  }

  EditExpenseById(Id) {
    this._appService.GetById("Booking", "EditExpenseById", Id).subscribe(
      (response) => {
        this.BookingExpense = response;
        $("#ExpenseBillDate").val(
          this.datepipe.transform(this.BookingExpense.BillDate, "dd/MM/yyyy")
        );
        $("#ExpenseBillDate").datepicker(
          "setDate",
          this.datepipe.transform(this.BookingExpense.BillDate, "dd/MM/yyyy")
        );

        $("#PaymentTotal").text(this.BookingExpense.Total);
        $("#PaymentRemark").val(this.BookingExpense.Remark);

        this.RefreshDropdown();
        $("#ModalNewExpense").modal("show");
      },
      (err) => {
        this.toastr.error("Error occurred while fetching data !", "error");
      }
    );
  }

  GetPrimaryDifference() {
    let ETotal = 0;
    let ATotal = 0;
    let EPtotal = 0;
    let APtotal = 0;
    let EStotal = 0;
    let AStotal = 0;
    for (let i = 0; i < this.FreightAuditPrimary.length; i++) {
      let a = $("#PrimaryERate_" + i).val() - $("#PrimaryARate_" + i).val();
      $("#PrimaryDiff_" + i).text(a);

      EPtotal = EPtotal + parseInt($("#PrimaryERate_" + i).val() || 0);
      APtotal = APtotal + parseInt($("#PrimaryARate_" + i).val() || 0);

      $("#EstimatedPTotal").val(EPtotal);
      $("#ActualPTotal").val(APtotal);
    }
    for (let i = 0; i < this.FreightAuditSecondary.length; i++) {
      let b = $("#SecondaryERate_" + i).val() - $("#SecondaryARate_" + i).val();
      $("#SecondaryDiff_" + i).text(b);

      EStotal = EStotal + parseInt($("#SecondaryERate_" + i).val() || 0);
      AStotal = AStotal + parseInt($("#SecondaryARate_" + i).val() || 0);

      $("#EstimatedSTotal").val(EStotal);
      $("#ActualSTotal").val(AStotal);
    }
    ETotal = EPtotal + EStotal;
    $("#TotalEBillAmt").text(ETotal);

    ATotal = APtotal + AStotal;
    $("#TotalABillAmt").text(ATotal);

    if (
      ATotal != 0 &&
      ATotal != null &&
      ATotal != null &&
      ATotal != undefined
    ) {
      this.TotalRate = ATotal;
      this.FreightSpent = ATotal;
      this.PaymentBillAmount = ATotal;
    } else {
      this.TotalRate = ETotal;
      this.FreightSpent = ETotal;
      this.PaymentBillAmount = ETotal;
    }

    if (this.BookingSummaryDetail.PSTotalFreightCost != 0) {
      this.BookingSummaryDetail.FreightSpentPer = (
        (this.TotalRate * 100) /
        this.BookingSummaryDetail.FreightCost
      ).toFixed(2);
    } else {
      this.BookingSummaryDetail.FreightSpentPer = 0;
    }
    if (this.BookingSummaryDetail.FreightSpentPer > 100) {
      this.BookingSummaryDetail.FreightSpentPer = 100;
    }
    document.getElementById("progressFreight").style.width =
      this.BookingSummaryDetail.FreightSpentPer + "%";
  }

  CalculatePaidAmount(type) {
    let i = 0;
    if (type == "FromPayment") {
      let PaymentPaidAmt = 0;
      $("#tblPayment").each(function () {
        $(this)
          .find("tr#PaymentRow0")
          .each(function () {
            var PaymentAmount = $(this)
              .find("td#templateAmount .ClstemplateAmount")
              .val();
            PaymentPaidAmt = PaymentPaidAmt + parseInt(PaymentAmount || 0);
            i++;
          });
      });
      this.PaymentPaidAmount = PaymentPaidAmt;
    } else {
      let ReceiptPaidAmt = 0;
      $("#tblReceipt").each(function () {
        $(this)
          .find("tr#ReceiptRow0")
          .each(function () {
            var ReceiptAmount = $(this)
              .find("td#ReceiptAmount .ClsReceiptAmount")
              .val();
            ReceiptPaidAmt = ReceiptPaidAmt + parseInt(ReceiptAmount || 0);
            i++;
          });
      });
      this.ReceiptPaidAmount = ReceiptPaidAmt;
    }
  }

  //-------------------------------------------------Refresh Code-------------------------------------------------

  RefreshvalidDate() {
    // setTimeout(() => {
    //   $(".datetimepicker")
    //     .each(function () {
    //       if ($(this).data("datetimepicker")) {
    //         $(this).datetimepicker("remove");
    //       }
    //       $(this).datetimepicker({
    //         todayHighlight: 1,
    //         orientation: "auto",
    //         autoclose: true,
    //         defaultViewDate: new Date(),
    //         format: "dd/mm/yyyy hh:ii:ss",
    //       });
    //       // if ($(this).val() == "") {
    //       //   $(this).datetimepicker("initialDate", new Date());
    //       // } else {
    //       //   $(this).datetimepicker("initialDate", $(this).val());
    //       // }
    //     })
    //     .on("click", function () {
    //       $(this).addClass("OpenDateTimePicker");
    //       $(".OpenDateTimePicker").not(this).datetimepicker("hide");
    //       $(".OpenDateTimePicker").not(this).removeClass("OpenDateTimePicker");
    //     });
    // }, 500);
    setTimeout(() => {
      $(".datetimepicker")
        .each(function () {
          if ($(this).data("datetimepicker")) {
            $(this).datetimepicker("remove");
          }
          $(this).datetimepicker({
            todayHighlight: 1,
            orientation: "auto",
            autoclose: true,
            defaultViewDate: new Date(),
            format: "dd/mm/yyyy hh:ii:ss",
          });
          if ($(this).val() == "") {
            $(this).datetimepicker("initialDate", new Date());
          } else {
            $(this).datetimepicker("initialDate", $(this).val());
          }
        })
        .on("click", function () {
          $(this).addClass("OpenDateTimePicker");
          $(".OpenDateTimePicker").not(this).datetimepicker("hide");
          $(".OpenDateTimePicker").not(this).removeClass("OpenDateTimePicker");
        });
    }, 500);
  }

  RefreshDropdown() {
    setTimeout(function () {
      // (<any>$(".StatusNameBooking")).selectpicker("refresh");
      (<any>$("#ExpenseCharge")).selectpicker("refresh");
      (<any>$("#ExpensePaymentMode")).selectpicker("refresh");
      (<any>$("#ExpenseParty")).selectpicker("refresh");
      (<any>$("#LRTransporterNames")).selectpicker("refresh");
      (<any>$("#LRVehicleCondition")).selectpicker("refresh");
      (<any>$(".ClsVehicleAssginByTrasporter")).selectpicker("refresh");
    }, 300);
  }

  ValidateFields() {
    var flag = true;

    if (
      !this.commonService.ValidateRequiredField(
        $("#LRVelicleNo"),
        "Please Enter Vehicle No.",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#InDateTime"),
        "Please Enter In Date Time",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#OutDateTime"),
        "Please Enter Out Date Time",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#LRDriverName"),
        "Please Enter Driver's Name",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#LRDriverMobileNo"),
        "Please Enter Driver's Mobile No.",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    return flag;
  }

  // ----------------------------------------------------Map-Route--------------------------------
  initMapPrimary1() {
    // -----------------Primary---------------
    if (this.RouteDataPrimary.length > 1) {
      this.Pcenter = new google.maps.LatLng(
        this.RouteDataPrimary[this.RouteDataPrimary.length - 1].Latitude,
        this.RouteDataPrimary[this.RouteDataPrimary.length - 1].Longitude
      );
    } else {
      this.Pcenter = new google.maps.LatLng(
        this.RouteDataPrimary[0].Latitude,
        this.RouteDataPrimary[0].Longitude
      );
    }

    if (this.RouteDataSeconadry.length > 1) {
      this.Scenter = new google.maps.LatLng(
        this.RouteDataSeconadry[this.RouteDataSeconadry.length - 1].Latitude,
        this.RouteDataSeconadry[this.RouteDataSeconadry.length - 1].Longitude
      );
    } else {
      this.Scenter = new google.maps.LatLng(
        this.RouteDataSeconadry[0].Latitude,
        this.RouteDataSeconadry[0].Longitude
      );
    }

    var that = this;
    mapLocation();
    function mapLocation() {
      var PdirectionsDisplay;
      var SdirectionsDisplay;
      var directionsService = new google.maps.DirectionsService();
      var Pmap;
      var Smap;
      initialize();
      function initialize() {
        PdirectionsDisplay = new google.maps.DirectionsRenderer();

        var PmapOptions = {
          zoom: 7,
          center: that.Pcenter,
        };
        Pmap = new google.maps.Map(
          document.getElementById("googleMapForPrimary1"),
          PmapOptions
        );
        PdirectionsDisplay.setMap(Pmap);
        CalculatePrimary();

        SdirectionsDisplay = new google.maps.DirectionsRenderer();

        var SmapOptions = {
          zoom: 7,
          center: that.Scenter,
        };
        Smap = new google.maps.Map(
          document.getElementById("googleMapForSecondary1"),
          SmapOptions
        );
        SdirectionsDisplay.setMap(Smap);

        CalculateSecondary();
      }

      function CalculatePrimary() {
        for (var i = 0; i < that.RouteDataPrimary.length - 1; i++) {
          var start = new google.maps.LatLng(
            that.RouteDataPrimary[i].Latitude,
            that.RouteDataPrimary[i].Longitude
          );
          var end = new google.maps.LatLng(
            that.RouteDataPrimary[i + 1].Latitude,
            that.RouteDataPrimary[i + 1].Longitude
          );

          var request = {
            origin: start,
            destination: end,
            travelMode: google.maps.TravelMode.DRIVING,
          };
          directionsService.route(request, function (response, status) {
            if (status == google.maps.DirectionsStatus.OK) {
              PdirectionsDisplay.setDirections(response);
              PdirectionsDisplay.setMap(Pmap);
            } else {
              alert(
                "Directions Request from " +
                start.toUrlValue(6) +
                " to " +
                end.toUrlValue(6) +
                " failed: " +
                status
              );
            }
          });
        }
      }

      function CalculateSecondary() {
        var waypts = [];
        var start = new google.maps.LatLng(
          that.RouteDataSeconadry[0].Latitude,
          that.RouteDataSeconadry[0].Longitude
        );
        var end = new google.maps.LatLng(
          that.RouteDataSeconadry[that.RouteDataSeconadry.length - 1].Latitude,
          that.RouteDataSeconadry[that.RouteDataSeconadry.length - 1].Longitude
        );

        for (var i = 1; i < that.RouteDataSeconadry.length - 1; i++) {
          var wp = new google.maps.LatLng(
            that.RouteDataPrimary[i].Latitude,
            that.RouteDataPrimary[i].Longitude
          );

          waypts.push({
            location: wp,
            stopover: true,
          });
        }

        directionsService.route(
          {
            origin: start,
            destination: end,
            waypoints: waypts,
            optimizeWaypoints: true,
            travelMode: "DRIVING",
          },
          function (response, status) {
            if (status === "OK") {
              SdirectionsDisplay.setDirections(response);
              SdirectionsDisplay.setMap(Smap);
              // For each route, display summary information.
            } else {
              window.alert("Directions request failed due to " + status);
            }
          }
        );
      }
    }
  }

  initMapPrimary() {
    // -----------------Primary---------------
    if (this.RouteDataPrimary.length > 1) {
      this.Pcenter = new google.maps.LatLng(
        this.RouteDataPrimary[this.RouteDataPrimary.length - 1].Latitude,
        this.RouteDataPrimary[this.RouteDataPrimary.length - 1].Longitude
      );
    } else {
      if (this.RouteDataPrimary.length > 0) {
        this.Pcenter = new google.maps.LatLng(
          this.RouteDataPrimary[0].Latitude,
          this.RouteDataPrimary[0].Longitude
        );
      }
    }

    if (this.RouteDataSeconadry.length > 1) {
      this.Scenter = new google.maps.LatLng(
        this.RouteDataSeconadry[this.RouteDataSeconadry.length - 1].Latitude,
        this.RouteDataSeconadry[this.RouteDataSeconadry.length - 1].Longitude
      );
    } else {
      if (this.RouteDataSeconadry.length > 0) {
        this.Scenter = new google.maps.LatLng(
          this.RouteDataSeconadry[0].Latitude,
          this.RouteDataSeconadry[0].Longitude
        );
      }
    }

    var that = this;
    mapLocation();
    function mapLocation() {
      var PdirectionsDisplay;
      var SdirectionsDisplay;
      var directionsService = new google.maps.DirectionsService();
      var Pmap;
      var Smap;
      initialize();
      function initialize() {
        if (that.RouteDataPrimary.length > 0) {
          PdirectionsDisplay = new google.maps.DirectionsRenderer();

          var PmapOptions = {
            zoom: 7,
            center: that.Pcenter,
          };
          Pmap = new google.maps.Map(
            document.getElementById("googleMapForPrimary"),
            PmapOptions
          );
          PdirectionsDisplay.setMap(Pmap);
          CalculatePrimary();
        }
        if (that.RouteDataSeconadry.length > 0) {
          SdirectionsDisplay = new google.maps.DirectionsRenderer();

          var SmapOptions = {
            zoom: 7,
            center: that.Scenter,
          };
          Smap = new google.maps.Map(
            document.getElementById("googleMapForSecondary"),
            SmapOptions
          );
          SdirectionsDisplay.setMap(Smap);

          CalculateSecondary();
        }
      }

      function CalculatePrimary() {
        var waypts = [];
        var start = new google.maps.LatLng(
          that.RouteDataPrimary[0].Latitude,
          that.RouteDataPrimary[0].Longitude
        );
        var end = new google.maps.LatLng(
          that.RouteDataPrimary[that.RouteDataPrimary.length - 1].Latitude,
          that.RouteDataPrimary[that.RouteDataPrimary.length - 1].Longitude
        );

        if (that.RouteDataPrimary.length > 2) {
          for (var i = 1; i < that.RouteDataPrimary.length - 1; i++) {
            waypts.push({
              location: new google.maps.LatLng(
                that.RouteDataPrimary[i].Latitude,
                that.RouteDataPrimary[i].Longitude
              ),
              stopover: true,
            });
          }
        }

        directionsService.route(
          {
            origin: start,
            destination: end,
            waypoints: waypts,
            optimizeWaypoints: true,
            travelMode: "DRIVING",
          },
          function (response, status) {
            if (status === "OK") {
              PdirectionsDisplay.setDirections(response);
              PdirectionsDisplay.setMap(Pmap);
            } else {
              window.alert("Directions request failed due to " + status);
            }
          }
        );
      }

      function CalculateSecondary() {
        var waypts = [];
        var start = new google.maps.LatLng(
          that.RouteDataSeconadry[0].Latitude,
          that.RouteDataSeconadry[0].Longitude
        );
        var end = new google.maps.LatLng(
          that.RouteDataSeconadry[that.RouteDataSeconadry.length - 1].Latitude,
          that.RouteDataSeconadry[that.RouteDataSeconadry.length - 1].Longitude
        );

        if (that.RouteDataSeconadry.length > 2) {
          for (var i = 1; i < that.RouteDataSeconadry.length - 1; i++) {
            waypts.push({
              location: new google.maps.LatLng(
                that.RouteDataSeconadry[i].Latitude,
                that.RouteDataSeconadry[i].Longitude
              ),
              stopover: true,
            });
          }
        }

        directionsService.route(
          {
            origin: start,
            destination: end,
            waypoints: waypts,
            optimizeWaypoints: true,
            travelMode: "DRIVING",
          },
          function (response, status) {
            if (status === "OK") {
              SdirectionsDisplay.setDirections(response);
              SdirectionsDisplay.setMap(Smap);
              // For each route, display summary information.
            } else {
              window.alert("Directions request failed due to " + status);
            }
          }
        );
      }
    }
  }

  onRoute() {
    // var FullHTML = document.getElementById('PrintRoute');
    // document.getElementById('modelbody').innerHTML = FullHTML.innerHTML;

    this.initMapPrimary1();
  }
  onPrintRoute() {
    const $body = $("body");
    const $mapContainer = $("#modelbody");
    const $mapContainerParent = $mapContainer.parent();
    const $printContainer = $('<div style="position:relative;">');

    $printContainer
      .height($mapContainer.height())
      .append($mapContainer)
      .prependTo($body);

    const $content = $body
      .children()
      .not($printContainer)
      .not("script")
      .detach();

    /**
     * Needed for those who use Bootstrap 3.x, because some of
     * its `@media print` styles ain't play nicely when printing.
     */
    const $patchedStyle = $('<style media="print">')
      .text(
        `
            img { max-width: none !important; }
            a[href]:after { content: ""; }
          `
      )
      .appendTo("head");

    window.print();

    $body.prepend($content);
    $mapContainerParent.prepend($mapContainer);

    $printContainer.remove();
    $patchedStyle.remove();
  }

  LoadOrders() {
    BookingComponent.bookingComponent.GetOrderList();
  }

  //--------------------------Print FC---------------------------------------------

  onPrintClick() {
    if (this.IsApproved == false) {
      if (this.BookingBasicDetail.ServiceProvider == "Courier") {
        console.log(this.PrintFCData);
        BookingComponent.bookingComponent.childComponent.GetFCBasicDetails(
          this.PrintFCData,
          "Approved",
          "Booking",
          "Courier"
        );
      } else {
        BookingComponent.bookingComponent.childComponent.GetFCBasicDetails(
          this.PrintFCData,
          "Approved",
          "Booking",
          "FTL"
        );
      }
    }
  }

  ClearFCPRintData() {
    BookingComponent.bookingComponent.childComponent.ClearFCPRintData();
  }

  OnModelPrint() {
    var divElements = document.getElementById("PrintFCmodelbody");
    //var $iframehead = $('<iframe>').appendTo("head");
    var $iframe = $("<iframe>").appendTo("body");
    var printDiv =
      "<html><head><title> Freight Confirmation </title></head><body>" +
      divElements.innerHTML +
      "</body></html>";
    $iframe.contents().find("body").html(printDiv);
    var win = $iframe[0].contentWindow || $iframe[0];
    win.window.print();
    $iframe.remove();

    // const $body = $('body');
    // const $mapContainer = $('#PrintFCmodelbody');
    // const $mapContainerParent = $mapContainer.parent();
    // const $printContainer = $('<div style="position:relative;">');

    // $printContainer
    //     .height($mapContainer.height())
    //     .append($mapContainer)
    //     .prependTo($body);

    // const $content = $body
    //     .children()
    //     .not($printContai ner)
    //     .not('script')
    //     .detach();

    // /**
    //  * Needed for those who use Bootstrap 3.x, because some of
    //  * its `@media print` styles ain't play nicely when printing.
    //  */
    // const $patchedStyle = $('<style media="print">')
    //     .text(`
    //     img { max-width: none !important; }
    //     a[href]:after { content: ""; }
    //   `)
    //     .appendTo('head');

    // window.print();

    // $body.prepend($content);
    // $mapContainerParent.prepend($mapContainer);

    // $printContainer.remove();
    // $patchedStyle.remove();
  }

  //-------------------------------Mark as assign Vehicle-----------------------

  async OnMarkAsAssignVehicle() {
    this.showAllUlipValidations = false;
    this.MarkAsAssignList.forEach((element, index) => {
      if ($("#Transporter_" + index).select2()) {
        $("#Transporter_" + index).val("");
        $("#Transporter_" + index).select2("destroy");
      }
      if ($("#Transporter1_" + index).select2()) {
        $("#Transporter1_" + index).val("");
        $("#Transporter1_" + index).select2("destroy");
      }
      if ($("#DriverVehicleNo_" + index).select2()) {
        $("#DriverVehicleNo_" + index).val("");
        $("#DriverVehicleNo_" + index).select2("destroy");
      }
      if ($("#AssginDriver_" + index).select2()) {
        $("#AssginDriver_" + index).val("");
        $("#AssginDriver_" + index).select2("destroy");
      }
      //add by maaria on 30-11-2023
      $("#DateOfBirth" + index).val("");
      $("#DriverLicense_" + index).val("");
      //end
    });
    this.MarkAsAssignList = [];
    var rows = this.datatable;
    rows.rows(".m-datatable__row--active");
    if (rows.nodes().length > 0) {
      $.each(rows.nodes(), function (i) {
        var keys = Object.keys(rows.nodes()[i]);
        var MarkAsAssignDetail: any = {};
        MarkAsAssignDetail = rows.nodes()[i][keys[0]].obj;
        MarkAsAssignDetail.TotalTruckHireCharge = 0.0;
        MarkAsAssignDetail.Advance = 0.0;

        MarkAsAssignDetail.fuelPumpName = null;
        MarkAsAssignDetail.FuelPumpId = null;
        MarkAsAssignDetail.vendorName = null;
        MarkAsAssignDetail.vendorId = null;
        MarkAsAssignDetail.LastFuelPumpId = null;
        MarkAsAssignDetail.isFuelPrice = true;
        MarkAsAssignDetail.todayFuelPrice = null;
        MarkAsAssignDetail.fuelChargeList = [];
        MarkAsAssignDetail.TransporterType = "";
        MarkAsAssignDetail.THCChargeRemark = "";

        BookingComponent.bookingComponent.MarkAsAssignList.push(MarkAsAssignDetail);
        BookingComponent.bookingComponent.MarkAsAssignList.DriverPhoto = "";
        BookingComponent.bookingComponent.MarkAsAssignList.LicensePhoto = "";
        // console.log(JSON.stringify(BookingComponent.bookingComponent.MarkAsAssignList));
      });

      if (this.productFulfillmentWiseBookingFlag) {
        for await (const element of this.MarkAsAssignList) {
          Helpers.setLoading(true);
          element.BookingOrderProduct = [];
          await new Promise(async (resolve1, reject1) => {
            this._appService.GetById("Booking", "av_getBookingOrderPoroductList", element.Id).subscribe(
              (response) => {
                element.BookingOrderProduct = response;
                Helpers.setLoading(false);
                resolve1('OK');
              },
              (err) => {
                this.toastr.error("Error occured while downaloading folder !", "error");
                Helpers.setLoading(false);
                reject1('Error occured while downaloading folder !');
              }
            );
          });
        }
      }
      //add by maaria on 27-11-2023
      this.vahanData = {};
      this.sarathiData = {};
      this.isDriverValid = false;
      this.isVehValid = false;
      //end
      $("#ModalAssignVehicle").modal("show");
      $("#SaveAssginVehicleData").prop("disabled", false);

      setTimeout(() => {
        (<any>$(".ClsVehicleAssginByTrasporter")).selectpicker("refresh");
        //Added by Pawan to add Assigned Vehicle Dateon 21-Feb-2020
        // this.RefreshvalidDate();
        //Pawan
      }, 300);

      if (BookingComponent.bookingComponent.flag_FuelPumpWiseBill == "1") {
        setTimeout(() => {
          (<any>$(".se_fuelPump")).selectpicker("refresh");
          if (BookingComponent.bookingComponent.hostURL != "https://jnp.ifreightbox.net/") {
            var isSelect: any = false;
            BookingComponent.bookingComponent.fuelPumpList.forEach(
              (element, index) => {
                if (isSelect == false && element.IsDefault == true) {
                  BookingComponent.bookingComponent.MarkAsAssignList.forEach(
                    (ele) => {
                      ele.fuelPumpName = element.fuelPumpName;
                      ele.FuelPumpId = element.fuelPumpId;
                      ele.LastFuelPumpId = element.fuelPumpId;
                      ele.todayFuelPrice = element.ToadyPrice;
                      if (element.ToadyPrice == 0) {
                        ele.isFuelPrice = false;
                      }
                    }
                  );
                  isSelect = true;
                }
              }
            );
            setTimeout(() => {
              (<any>$(".se_fuelPump")).selectpicker("refresh");
            }, 100);
          }
        }, 100);
      }

      //added by vithujan 04-02-2023
      setTimeout(() => {
        for (let i = 0; i < this.MarkAsAssignList.length; i++) {
          let LeadTime = $("#LeadTime_" + i).val();
          if (LeadTime == "" || LeadTime == undefined) {
            BookingComponent.bookingComponent.GetOderDeliveryDate(this.MarkAsAssignList[i].OrderNo, i);
          }
          $("#CreatedDate_" + i).val(moment(new Date(this.MarkAsAssignList[i].OrderPickupDate)).format("DD/MM/YYYY HH:mm:ss"));

          //added by vithujan 25-11-2023 - Siddarth
          if (this.MarkAsAssignList[i].DeliveryPartnerId != null && this.MarkAsAssignList[i].DeliveryPartnerId != undefined && this.MarkAsAssignList[i].DeliveryPartnerId != "") {
            var OptionsTrans = "";
            OptionsTrans += '<option value="' + this.MarkAsAssignList[i].DeliveryPartnerId + '">' + this.MarkAsAssignList[i].DeliveryPartnerName + "</option>";
            $("#Transporter_" + i).html(OptionsTrans);

            BookingComponent.bookingComponent.getVehicleChargesData(i,
              this.MarkAsAssignList[i].DeliveryPartnerId, this.MarkAsAssignList[i].DeliveryPartnerName, this.MarkAsAssignList[i].TransporterTypeName);
          }
        }
      }, 500);
      //end
    } else {
      const Selectbooking = this.translate.instant("ALERTMESSAGES.Selectbooking");
      this.toastr.error(Selectbooking, "Alert");
    }
  }

  GetSelectDataOfVehicleDriver() {
    $(".DriverVehicleNo").each(function () {
      var driveobj = this;
      setTimeout(function () {
        $(driveobj).select2({
          tags:
            $(driveobj).closest("tr").find(".ClsTransporterType").val() ==
            "Hired",
          width: "100%",
          escapeMarkup: function (markup) {
            return markup;
          },
          minimumInputLength: 2,
          ajax: {
            global: false,
            url: environment.apiUrl + "api/Booking/GetVehicleDriverList",
            delay: 300,
            dataType: "json",
            allowClear: true,
            data: function (params) {
              return {
                query: params.term,
                page: params.page || 1,
                TransporterId: $(driveobj)
                  .closest("tr")
                  .find(".ClsVehicleAssginByTrasporter1")
                  .val(),
                VehicleId: $(driveobj)
                  .closest("tr")
                  .find(".ClsVehicleAssginByVehicleType")
                  .val(),
              };
            },
            processResults: function (data, params) {
              params.page = params.page || 1;
              return {
                results: data.Results,
                pagination: {
                  more: params.page * 30 < data.Total,
                },
              };
            },
          },
          tokenSeparators: [",", " "],
          createTag: function (params) {
            var term = $.trim(params.term);
            if (validateVehicle(term)) {
              return {
                id: term,
                text: term.toUpperCase(),
                newTag: true,
              };
            }
            BookingComponent.bookingComponent.toastr.error(
              "Special Characters are not allowed !",
              "Error"
            );
            return null;
            function validateVehicle(no) {
              var re = /^[a-zA-Z0-9 ]*$/;
              return re.test(no);
            }
          },
          insertTag: function (data, tag) {
            data.push(tag);
          },
          placeholder: "Enter Vehicle No",
        });
      }, 500);
    });

    $(".DriverVehicleNo").on("select2:select", function (e) {
      var data = e.params.data;
      let index = e.target.id.split("_")[1];
      var VehicleNo = data.text;

      BookingComponent.bookingComponent.GetByReeferUnit(VehicleNo, index);

      if (
        data.DriverCode != null &&
        data.DriverCode != undefined &&
        data.DriverCode != ""
      ) {
        let Options = '<option value="' + data.DriverCode + '">' + data.DriverName + "</option>";
        $("#AssginDriver_" + index).html(Options);
        $("#AssginDriver_" + index).val(data.DriverCode).change();
        $("#DriverMobile_" + index).val(data.MobileNo);
        // BookingComponent.bookingComponent.GetPhotoforassign(data.MobileNo);
        BookingComponent.bookingComponent._appService
          .GetById("DriverPhotofortrip", "GetDriverPhoto", data.MobileNo)
          .subscribe(
            (response) => {
              if (response == null) {
                BookingComponent.bookingComponent.MarkAsAssignList[index].DriverPhoto = null;
                BookingComponent.bookingComponent.MarkAsAssignList[index].LicensePhoto = null;
              } else {
                BookingComponent.bookingComponent.MarkAsAssignList[index].DriverPhoto = response[0].DriverPhoto;
                BookingComponent.bookingComponent.MarkAsAssignList[index].LicensePhoto = response[0].LicensePhoto;
              }
            },
            (err) => {
              BookingComponent.bookingComponent.toastr.error(
                err._body.replace(/"/g, ""),
                "error"
              );
            }
          );
      }

      $("#DriverLicense_" + index).val(data.LicenseNo);
      $("#VehicleRCBook_" + index).val(data.RCBookNo);
      $("#EngineNo_" + index).val(data.EngineNo);
      $("#ChassisNo_" + index).val(data.ChassisNo);

      //BookingComponent.bookingComponent.ValidateVehicleViaUlip(e, index);

    });

    $(".AssignDriverNo").each(function () {
      var Noobj = this;
      setTimeout(function () {
        $(Noobj).select2({
          tags:
            $(Noobj).closest("tr").find(".ClsTransporterType").val() == "Hired",
          width: "100%",
          escapeMarkup: function (markup) {
            return markup;
          },
          minimumInputLength: 2,
          ajax: {
            global: false,
            url: environment.apiUrl + "api/Booking/GetDriverList",
            delay: 300,
            dataType: "json",
            allowClear: true,
            data: function (params) {
              return {
                query: params.term,
                page: params.page || 1,
                TransporterId: $(Noobj)
                  .closest("tr")
                  .find(".ClsVehicleAssginByTrasporter1")
                  .val(),
              };
            },
            processResults: function (data, params) {
              params.page = params.page || 1;
              return {
                results: data.Results,
                pagination: {
                  more: params.page * 30 < data.Total,
                },
              };
            },
          },
          tokenSeparators: [","],
          createTag: function (params) {
            var term = $.trim(params.term);
            return {
              id: term,
              text: term,
              newTag: true,
            };
          },
          insertTag: function (data, tag) {
            data.push(tag);
          },

          placeholder: "Enter Driver Name",
        });
      }, 500);
    });

    $(".AssignDriverNo").off('select2:select').on("select2:select", function (e) {
      var data = e.params.data;
      let index = e.target.id.split("_")[1];
      $("#DriverMobile_" + index).val(data.MobileNo);
      $("#DriverLicense_" + index).val(data.LicenseNo);
      // BookingComponent.bookingComponent.GetPhotoforassign(data.MobileNo);
      BookingComponent.bookingComponent._appService
        .GetById("DriverPhotofortrip", "GetDriverPhoto", data.MobileNo)
        .subscribe(
          (response) => {
            if (response == null) {
              BookingComponent.bookingComponent.MarkAsAssignList[
                index
              ].DriverPhoto = null;
              BookingComponent.bookingComponent.MarkAsAssignList[
                index
              ].LicensePhoto = null;
            } else {
              BookingComponent.bookingComponent.MarkAsAssignList[
                index
              ].DriverPhoto = response[0].DriverPhoto;
              BookingComponent.bookingComponent.MarkAsAssignList[
                index
              ].LicensePhoto = response[0].LicensePhoto;
            }
            console.log(
              "BookingComponent.bookingComponent.MarkAsAssignList[index]",
              BookingComponent.bookingComponent.MarkAsAssignList[index]
            );
          },
          (err) => {
            BookingComponent.bookingComponent.toastr.error(
              err._body.replace(/"/g, ""),
              "error"
            );
          }
        );
      if (data.newTag == true) {
        $("#DriverMobile_" + index).prop("disabled", false);
      } else {
        $("#DriverMobile_" + index).prop("disabled", true);
      }

      // //added by vithujan 20-11-2023 - Siddarth
      // BookingComponent.bookingComponent._appService
      //   .GetById("Booking", "CheckDriverPendingTrips", data.MobileNo)
      //   .subscribe(
      //     (response) => {
      //       console.log("driver status list", response);
      //       if (response.length > 0) {
      //         BookingComponent.bookingComponent.MarkAsAssignList[
      //           index
      //         ].DriverMobile = null;
      //         BookingComponent.bookingComponent.MarkAsAssignList[
      //           index
      //         ].DriverLicense = null;
      //         $("#DriverMobile_" + index).val("");
      //         $("#DriverLicense_" + index).val("");
      //         $("#AssginDriver_" + index).val("");
      //         $("#AssginDriver_" + index).text("");

      //         BookingComponent.bookingComponent.toastr.error(
      //           BookingComponent.bookingComponent.translate.instant('BYVEHICLE.DriverMsg1')
      //         );
      //       }
      //     },
      //     (err) => {
      //       BookingComponent.bookingComponent.toastr.error(
      //         err._body.replace(/"/g, ""),
      //         "error"
      //       );
      //     }
      //   );
    });


  }

  // onSelectBlur(event: any) {
  //   // Handle the onBlur event logic here
  //   
  //   console.log('Select blurred data!', event.target.value);
  //   // Add your custom logic here
  // }
  GetByReeferUnit(VehicleNo, index) {
    this._appService
      .GetByTwoId(
        "VehicleMaster",
        "GetVehicleReeferUnit",
        this.CompanyId,
        VehicleNo
      )
      .subscribe(
        (response) => {
          let objreeferUnit = response;
          this.ReeferModel = objreeferUnit[0];

          if (objreeferUnit.length > 0) {
            $("#ReeferUnit_" + index).val(objreeferUnit[1]);
            $("#ReeferUnit_" + index)
              .parent("td")
              .removeClass("display");

            $("#ReeferUnit_" + index)
              .parent("td")
              .next("td")
              .removeClass("display");
            this.IsActiveReefer = true;
            // $("tr.warning").each(function () {
            //   $(this).find("td").eq(3).removeClass("display");
            //   $(this).find("td").eq(4).removeClass("display");
            // });
          } else {
            $("#ReeferUnit_" + index)
              .parent("td")
              .css("display", "none");

            $("#ReeferUnit_" + index)
              .parent("td")
              .next("td")
              .css("display", "none");
            this.IsActiveReefer = false;
            // $("tr.warning").each(function () {
            //   $(this).find("td").eq(3).css("display", "none");
            //   $(this).find("td").eq(4).css("display", "none");
            // });
          }
        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching Vehicle ReeferUnit data !" + err,
            "error"
          );
        }
      );
  }
  SaveAssginVehicleData() {
    //added by maaria 10-01-2024 - Siddarth
    this.driverTripAssignedList = [];
    this.MarkAsAssignList.forEach((ele: any, index: any) => {
      //added by vithujan 20-11-2023 - Siddarth
      if ($("#DriverMobile_" + index).val() == "") {
        this.toastr.error("Please Enter Mobile No!", 'Error');
        $("#DriverMobile_" + index).focus();
        $("#SaveAssginVehicleData").prop('disabled', false);
        return false;
      }
      BookingComponent.bookingComponent._appService
        .GetById("Booking", "CheckDriverPendingTrips", $("#DriverMobile_" + index).val())
        .subscribe(
          (response) => {
            if (response.length > 0) {
              BookingComponent.bookingComponent.MarkAsAssignList[
                index
              ].DriverMobile = null;
              BookingComponent.bookingComponent.MarkAsAssignList[
                index
              ].DriverLicense = null;

              this.driverTripAssignedList.push($("#AssginDriver_" + index).val());

              $("#DriverMobile_" + index).val("");
              $("#DriverLicense_" + index).val("");
              $("#AssginDriver_" + index).val("");
              $("#AssginDriver_" + index).text("");
            }

            //if last element
            if (index == (this.MarkAsAssignList.length - 1)) {
              //driver is assigned some trip
              console.log("inside for", this.driverTripAssignedList);
              if (this.driverTripAssignedList.length > 0) {
                this.driverTripAssignedList.forEach((ele) => {
                  BookingComponent.bookingComponent.toastr.error(
                    ele + " " + BookingComponent.bookingComponent.translate.instant('BYVEHICLE.DriverMsg1')
                  );
                });
              } //if all drivers is assigned no trip before working
              else {
                for (let i = 0; i < this.MarkAsAssignList.length; i++) {
                  this.MarkAsAssignList[i].BookingId = BookingComponent.bookingComponent.MarkAsAssignList[i].Id;
                  this.MarkAsAssignList[i].VehicleNo = $("#DriverVehicleNo_" + i).val();
                  this.MarkAsAssignList[i].RCBookNo = $("#VehicleRCBook_" + i).val();
                  this.MarkAsAssignList[i].ChassisNo = $("#ChassisNo_" + i).val();
                  this.MarkAsAssignList[i].EngineNo = $("#EngineNo_" + i).val();
                  this.MarkAsAssignList[i].DriverCode = $("#AssginDriver_" + i).val();
                  this.MarkAsAssignList[i].DriverMobileNo = $("#DriverMobile_" + i).val();
                  this.MarkAsAssignList[i].LicenseNo = $("#DriverLicense_" + i).val();
                  this.MarkAsAssignList[i].ReeferUnit = $("#ReeferUnit_" + i).val();
                  //added by vithujan 21-12-2023 - Siddarth
                  this.MarkAsAssignList[i].Captain = $("#Captain_" + i).val();

                  // this.MarkAsAssignList[i].DriverMobileNo =
                  //   Array.from(this.MarkAsAssignList[i].DriverMobileNo)[0] == "0"
                  //     ? this.MarkAsAssignList[i].DriverMobileNo.slice(1)
                  //     : this.MarkAsAssignList[i].DriverMobileNo;

                  //Added by pawan on 21 feb 2020
                  //this.MarkAsAssignList[i].CreatedDateAssign = $("#CreatedDateAssign_" + i).val();
                  this.MarkAsAssignList[i].CreatedDate = moment($("#CreatedDate_" + i).datetimepicker("getDate")).format("YYYY/MM/DD HH:mm:ss");
                  //pawan

                  if (this.hostURL != "https://fm.ifreightbox.net/") {
                    let LeadTime = $("#LeadTime_" + i).val();
                    if (LeadTime == "" || LeadTime == undefined) {
                      const LeadTime = this.translate.instant("ALERTMESSAGES.LeadTime");
                      this.toastr.error(LeadTime, "Alert");
                      $("#LeadTime_" + i).focus();
                      $("#SaveAssginVehicleData").prop("disabled", false);
                      return false;
                    }
                    else {
                      this.LeadTime = LeadTime;
                    }
                  }

                  // this.MarkAsAssignList[i].EstimatedDeliveryDate = moment(
                  //   $("#EstimatedDeliveryDate_" + i).datepicker("getDate"),
                  //   "YYYY/MM/DD"
                  // );

                  //added by vithujan 04-03-2023
                  var EstDeliveryDate = moment($("#EstimatedDeliveryDate_" + i).datetimepicker("getDate")).format("YYYY/MM/DD HH:mm:ss");
                  var DepartureDate = moment($("#CreatedDate_" + i).datetimepicker("getDate")).format("YYYY/MM/DD HH:mm:ss");
                  if (EstDeliveryDate <= DepartureDate && EstDeliveryDate != DepartureDate) {
                    this.toastr.error(
                      this.translate.instant("PENDINGARRIVAL.DeliveryDateValidation"),
                      "Alert"
                    );
                    return;
                  }
                  //end

                  //added by vithujan 20-10-2023 - Logesh
                  if (this.MarkAsAssignList[i].DriverMobileNo.length > 15) {
                    const mobilenumvalidation = this.translate.instant(
                      "ALERTMESSAGES.MobileNoValidation"
                    );
                    this.toastr.error(mobilenumvalidation, "Alert");
                    return false;
                  }

                  var DueDate = moment($("#CreatedDate_" + i).val(), "DD-MM-YYYY").add($("#LeadTime_" + i).val(), "days");
                  var momentVariable = moment(DueDate, "DD-MM-YYYY");
                  this.MarkAsAssignList[i].EstimatedDeliveryDate = EstDeliveryDate;

                  this.MarkAsAssignList[i].TransporterId = $("#Transporter_" + i).val();
                  this.MarkAsAssignList[i].TransporterId1 = $("#Transporter1_" + i).val();

                  // this.MarkAsAssignList[i].TransporterName1 = $("#VehicleAssginByTrasporter1_" + i + " option:selected").text().trim();
                  this.MarkAsAssignList[i].THCNumber = this.MarkAsAssignList[i].FCNumber;

                  this.MarkAsAssignList[i].LeadTime = this.LeadTime;

                  this.MarkAsAssignList[i].TransporterName = $("#Transporter_" + i).text().trim().split(" (")[0];
                  if (
                    this.MarkAsAssignList[i].TransporterId == "" ||
                    this.MarkAsAssignList[i].TransporterId == undefined
                  ) {
                    const transporterbroker = this.translate.instant(
                      "ALERTMESSAGES.transporterbroker"
                    );
                    this.toastr.error(transporterbroker, "Alert");
                    $("#Transporter_" + i).focus();
                    $("#SaveAssginVehicleData").prop("disabled", false);
                    return false;
                  }
                  if (
                    this.MarkAsAssignList[i].TransporterId1 == "" ||
                    this.MarkAsAssignList[i].TransporterId1 == undefined
                  ) {
                    this.toastr.error("Select Transporter !", "Alert");
                    $("#Transporter1_" + i).focus();
                    $("#SaveAssginVehicleData").prop("disabled", false);
                    return false;
                  }
                  if (
                    this.MarkAsAssignList[i].TransporterName == "" ||
                    this.MarkAsAssignList[i].TransporterName == undefined
                  ) {
                    this.toastr.error("Select Transporter / Broker !", "Alert");
                    $("#VehicleAssginByTrasporter_" + i).focus();
                    $("#SaveAssginVehicleData").prop("disabled", false);
                    return false;
                  }
                  // if (
                  //   this.MarkAsAssignList[i].TransporterName1 == "" ||
                  //   this.MarkAsAssignList[i].TransporterName1 == undefined
                  // ) {
                  //   this.toastr.error("Select Transporter !", "Alert");
                  //   $("#VehicleAssginByTrasporter1_" + i).focus();
                  //   $("#SaveAssginVehicleData").prop("disabled", false);
                  //   return false;
                  // }
                  if (
                    this.MarkAsAssignList[i].VehicleNo == "" ||
                    this.MarkAsAssignList[i].VehicleNo == undefined
                  ) {
                    const SelectVehicle = this.translate.instant(
                      "ALERTMESSAGES.SelectVehicle"
                    );
                    this.toastr.error(SelectVehicle, "Alert");
                    $("#DriverVehicleNo_" + i).focus();
                    $("#SaveAssginVehicleData").prop("disabled", false);
                    return false;
                  }
                  if (this.MarkAsAssignList[i].DriverCode == "" || this.MarkAsAssignList[i].DriverCode == undefined) {
                    this.toastr.error("Please Select Driver !", 'Alert');
                    $("#AssginDriver_" + i).focus();
                    $("#SaveAssginVehicleData").prop('disabled', false);
                    return false;
                  }
                  if ($("#DriverMobile_" + i).val() == "") {
                    this.toastr.error("Please Enter Mobile !", 'Alert');
                    $("#DriverMobile_" + i).focus();
                    $("#SaveAssginVehicleData").prop('disabled', false);
                    return false;
                  }
                  if ($("#DriverMobile_" + i).val() != "") {
                    // if ($("#DriverMobile_" + i).val().length < 10) {
                    //   this.toastr.error("Mobile Number must be 10 Digits !", "Alert");
                    //   $("#DriverMobile_" + i).focus();
                    //   $("#SaveAssginVehicleData").prop("disabled", false);
                    //   return false;
                    // }
                    // if ($("#DriverMobile_" + i).val() != "") {
                    //   var phone = $("#DriverMobile_" + i).val(),
                    //     intRegex = /^[0-9]+$/;
                    //   if (!intRegex.test(phone)) {
                    //     this.toastr.error("Please enter a valid Mobile Number!", "Alert");
                    //     $("#DriverMobile_" + i).focus();
                    //     $("#SaveAssginVehicleData").prop("disabled", false);
                    //     return false;
                    //   }
                    // }
                  }
                  var isFuel: any = false;
                  if (
                    BookingComponent.bookingComponent.flag_FuelPumpWiseBill == "1" &&
                    (this.MarkAsAssignList[i].TransporterType == "Self" ||
                      this.hostURL == "https://jnp.ifreightbox.net/")
                  ) {
                    if (
                      this.MarkAsAssignList[i].FuelPumpId == null ||
                      this.MarkAsAssignList[i].todayFuelPrice == 0
                    ) {
                      if (this.hostURL != "https://jnp.ifreightbox.net/") {
                        const Pleaseselectfuelpump = this.translate.instant(
                          "ALERTMESSAGES.Pleaseselectfuelpump"
                        );
                        this.toastr.error(Pleaseselectfuelpump, "Alert");
                        $("#se_fuelPump_" + i).focus();
                        $("#SaveAssginVehicleData").prop("disabled", false);
                        return false;
                      }
                    } else {
                      isFuel = true;
                    }
                  } else {
                    this.MarkAsAssignList[i].FuelPumpId = null;
                  }
                  this.MarkAsAssignList[i].VehicleDispatchedCharges_ViewModal = [];
                  this.MarkAsAssignList[i].fuelChargeList.forEach((eleFu) => {
                    var obj: any = {};
                    obj.VendorId = eleFu.VendorId;
                    // obj.Charge = eleFu.chrgerCode;
                    obj.Charge = eleFu.ChargeCode;
                    obj.Unit = eleFu.Unit;
                    obj.Qty = eleFu.Qty;
                    // if (eleFu.Unit == 'FuelPrice') {
                    //   obj.Rate = this.MarkAsAssignList[i].todayFuelPrice;
                    //   obj.Qty = eleFu.Amount;
                    // } else {
                    obj.Rate = eleFu.Rate;
                    //added by maaria
                    obj.Advance = eleFu.Advance;
                    // }
                    //added by vithujan 08-04-2023
                    // obj.DeductFromAdvance = eleFu.DeductFromAdvance;
                    //end
                    if (eleFu.Unit == "FuelPrice" && isFuel == true) {
                      this.MarkAsAssignList[i].VehicleDispatchedCharges_ViewModal.push(obj);
                    }
                    if (eleFu.Unit != "FuelPrice") {
                      this.MarkAsAssignList[i].VehicleDispatchedCharges_ViewModal.push(obj);
                    }
                  });
                  this.MarkAsAssignList[i].UserId = this.UserId;

                  //added by vithujan 04-05-2023
                  $("#TotalTruckHireCharge_" + i).css("border-color", "#ebedf2");
                  $("#Advance_" + i).css("border-color", "#ebedf2");

                  if (this.ValidateTHCADvanceAmountFlag == true) {
                    if (
                      this.MarkAsAssignList[i].TotalTruckHireCharge == 0 ||
                      this.MarkAsAssignList[i].TotalTruckHireCharge == undefined ||
                      this.MarkAsAssignList[i].TotalTruckHireCharge == null ||
                      this.MarkAsAssignList[i].TotalTruckHireCharge == ""
                    ) {
                      var message = this.translate.instant(
                        "ALERTMESSAGES.THCAmountShoubeGraterThanZero"
                      );
                      this.toastr.error(message, "Alert");
                      $("#TotalTruckHireCharge_" + i).css("border-color", "red");
                      return;
                    }

                    if (
                      this.MarkAsAssignList[i].Advance == 0 ||
                      this.MarkAsAssignList[i].Advance == undefined ||
                      this.MarkAsAssignList[i].Advance == null ||
                      this.MarkAsAssignList[i].Advance == ""
                    ) {
                      var message = this.translate.instant(
                        "ALERTMESSAGES.AdvanceAmountShoubeGraterThanZero"
                      );
                      this.toastr.error(message, "Alert");
                      $("#Advance_" + i).css("border-color", "red");
                      return;
                    }
                  }

                  if (this.productFulfillmentWiseBookingFlag == true) {
                    for (let boc_i = 0; boc_i < this.MarkAsAssignList[i].BookingOrderProduct.length; boc_i++) {
                      if (this.MarkAsAssignList[i].BookingOrderProduct[boc_i].PendingQty < 0 || this.MarkAsAssignList[i].BookingOrderProduct[boc_i].AllocateQty <= 0) {
                        this.toastr.error("Please enter a number greater than zero", "Alert");
                        $("#in_bocAllocateQty_" + i + "_" + boc_i).css("border-color", "red");
                        return;
                      }
                    }
                  }
                }
                //Check Is Same Vehicle used in more than one trip
                var DuplicateVehicle = this.ValidateDuplicateVehicle();
                if (DuplicateVehicle) return false;
                //Check Is Same Driver used in more than one trip
                var DuplicateDriver = this.ValidateDuplicateDriver();
                if (DuplicateDriver) return false;
                const verifyagain = this.translate.instant("ALERTMESSAGES.Verify");
                const checkspellingMistake = this.translate.instant(
                  "ALERTMESSAGES.checkspellingMistake"
                );
                const yesverified = this.translate.instant("ALERTMESSAGES.yesverified");

                swal({
                  title: verifyagain,
                  text: checkspellingMistake,
                  type: "warning",
                  showCancelButton: !0,
                  confirmButtonText: yesverified,
                }).then(function (e) {
                  if (e.value == true) {
                    $("#SaveAssginVehicleData").prop("disabled", true);
                    BookingComponent.bookingComponent._appService
                      .Post(
                        "Booking",
                        "SaveAssginVehicleData",
                        BookingComponent.bookingComponent.MarkAsAssignList
                      )
                      .subscribe(
                        async (response) => {
                          var arrLength = BookingComponent.bookingComponent.MarkAsAssignList.length;
                          var arrCount = 0;
                          for await (const element of BookingComponent.bookingComponent.MarkAsAssignList) {
                            arrCount = arrCount + 1;
                            await new Promise(async (resolve1, reject1) => {
                              if (element.isSIMTracking == "YES" && BookingComponent.bookingComponent.THCAdvancePercentageApproveRejectFlag == true) {
                                // add for check driver consents
                                var settingsCheckDriverConsents = {
                                  async: true,
                                  crossDomain: true,
                                  url: "https://sct.intutrack.com/api/test/consents?tel=" + element.DriverMobileNo,
                                  method: "GET",
                                  headers: {
                                    authorization:
                                      "Basic c0dGMHBqMnRvcG01SzdUa05KUUhIZWxCRXQyOHROVGEzbktNVU40ajNTSUk3VVowM0hGS21ReHlXUWtiOWhQMjo1eVA4UEFhSXROUDRsNFIwNkJNRDBQQ1FpbFdlNkM2bmhlRmNjbDhGWlRIeURqWGRZRllncEQybU54OHBVTzlx",
                                    "content-type": "application/x-www-form-urlencoded",
                                    "cache-control": "no-cache",
                                    username: "sGF0pj2topm5K7TkNJQHHelBEt28tNTa3nKMUN4j3SII7UZ03HFKmQxyWQkb9hP2",
                                    password: "5yP8PAaItNP4l4R06BMD0PCQilWe6C6nheFccl8FZTHyDjXdYFYgpD2mNx8pUO9q",
                                  },
                                };
                                $.ajax(settingsCheckDriverConsents).done(function (response) {
                                  if (response != null) {
                                    swal(
                                      '<div style="text-align: left; font-weight: normal; font-size: smaller;"><span style="font-weight: bold;">consent:  </span>' +
                                      response[0].result.consent +
                                      '<br> <span style="font-weight: bold;">consent_suggestion:  </span>' +
                                      response[0].result.consent_suggestion +
                                      '<br> <span style="font-weight: bold;">current_consent: </span>' +
                                      response[0].result.current_consent +
                                      '<br> <span style="font-weight: bold;">jioUpdate: </span>' +
                                      response[0].result.jioUpdate +
                                      '<br> <span style="font-weight: bold;">message: </span>' +
                                      response[0].result.message +
                                      '<br> <span style="font-weight: bold;">number:  </span>' +
                                      response[0].result.number +
                                      '<br> <span style="font-weight: bold;">operator:  </span>' +
                                      response[0].result.operator +
                                      "</div>"
                                    );
                                  }
                                  resolve1('OK');
                                })
                                  .fail(function (jqXHR) {
                                    console.log('errorThrown', jqXHR.responseText);
                                    resolve1('OK');
                                  });

                                if (arrLength == arrCount) {
                                  $("#ModalAssignVehicle").modal("hide");
                                  BookingComponent.bookingComponent.GetStatusBtnList();
                                  //added by vithujan 29-12-2022
                                  if (BookingComponent.bookingComponent.hostURL == "http://tms.theptpl.com/") {
                                    BookingComponent.bookingComponent.UpdateVehicleList();
                                  }
                                  //end

                                  //change kevin 14/08/2020
                                  // BookingComponent.bookingComponent.datatable.reload();
                                  var rows = BookingComponent.bookingComponent.datatable;
                                  rows.rows(".m-datatable__row--active");
                                  if (rows.nodes().length > 0) {
                                    $.each(rows.nodes(), function (i) {
                                      var keys = Object.keys(rows.nodes()[i]);
                                      rows.remove()[i][keys[0]].obj;
                                    });
                                  }
                                  //end
                                  const Assignsaved = BookingComponent.bookingComponent.translate.instant("ALERTMESSAGES.Assignsaved");
                                  BookingComponent.bookingComponent.toastr.success(Assignsaved, "Success");
                                }
                              } else {
                                if (arrLength == arrCount) {
                                  $("#ModalAssignVehicle").modal("hide");
                                  BookingComponent.bookingComponent.GetStatusBtnList();
                                  //added by vithujan 29-12-2022
                                  if (BookingComponent.bookingComponent.hostURL == "http://tms.theptpl.com/") {
                                    BookingComponent.bookingComponent.UpdateVehicleList();
                                  }
                                  //end

                                  //change kevin 14/08/2020
                                  // BookingComponent.bookingComponent.datatable.reload();
                                  var rows = BookingComponent.bookingComponent.datatable;
                                  rows.rows(".m-datatable__row--active");
                                  if (rows.nodes().length > 0) {
                                    $.each(rows.nodes(), function (i) {
                                      var keys = Object.keys(rows.nodes()[i]);
                                      rows.remove()[i][keys[0]].obj;
                                    });
                                  }
                                  //end
                                  const Assignsaved = BookingComponent.bookingComponent.translate.instant("ALERTMESSAGES.Assignsaved");
                                  BookingComponent.bookingComponent.toastr.success(Assignsaved, "Success");
                                }
                                resolve1('OK');
                              }
                            });
                          }
                        },
                        (err) => {
                          $("#SaveAssginVehicleData").prop("disabled", false);
                          BookingComponent.bookingComponent.toastr.error(err._body.replace(/"/g, ""), "Error");
                        }
                      );
                  }
                });

              }

            }
          },
          (err) => {
            BookingComponent.bookingComponent.toastr.error(
              err._body.replace(/"/g, ""),
              "error"
            );
          }
        );

    });

  }

  ValidateDuplicateVehicle() {
    var flag = false;
    var valueArr = this.MarkAsAssignList.map(function (item) {
      return item.VehicleNo;
    });
    var VehileNo = "";
    var BookingNos = "";
    valueArr.some(function (item, idx) {
      if (valueArr.indexOf(item) != idx) {
        var DuplicateBooking: any =
          BookingComponent.bookingComponent.MarkAsAssignList.filter(
            (x) => x.VehicleNo === item
          );
        var data = DuplicateBooking.map(function (a) {
          return a.FCNumber;
        });
        BookingNos = data.join(",");
        VehileNo = item;
        flag = true;
        swal(
          "You can not assign same vehicle to different Trips !<br/><br/> Same vehicle <b>" +
          VehileNo +
          "</b> used in this trips : <b>" +
          BookingNos +
          "</b>",
          "",
          "error"
        );
      }
    });
    return flag;
  }
  ValidateDuplicateDriver() {
    var flag = false;
    var valueArr = this.MarkAsAssignList.map(function (item) {
      return item.DriverMobileNo;
    });
    var DriverMobileNo = "";
    var BookingNos = "";
    valueArr.some(function (item, idx) {
      if (valueArr.indexOf(item) != idx) {
        var DuplicateBooking: any =
          BookingComponent.bookingComponent.MarkAsAssignList.filter(
            (x) => x.DriverMobileNo === item
          );
        var data = DuplicateBooking.map(function (a) {
          return a.FCNumber;
        });
        BookingNos = data.join(",");
        DriverMobileNo = item;
        flag = true;
        swal(
          "You can not assign same driver to different Trips !<br/><br/> Same Driver Code <b>" +
          DriverMobileNo +
          "</b> used in this trips : <b>" +
          BookingNos +
          "</b>",
          "",
          "error"
        );
      }
    });
    return flag;
  }

  AssignVehicleTransporterType: any;
  ClearAssignedVehicle(index) {
    var TransporterId = $("#VehicleAssginByTrasporter_" + index).val();
    this.AssignVehicleTransporterType = $(
      "#TransporterType_" + TransporterId + "_" + index
    ).text();
    $("#TransporterType_" + index).val(this.AssignVehicleTransporterType);
    // if (this.AssignVehicleTransporterType != '(Hired)')
    //     $("#TransporterType_" + index).val(this.AssignVehicleTransporterType);
    // else
    //     $("#TransporterType_" + index).val(this.AssignVehicleTransporterType);

    $("#DriverVehicleNo_" + index).val(" ");
    $("#AssginDriver_" + index).val(" ");

    this.GetSelectDataOfVehicleDriver();
    $("#DriverMobile_" + index).val("");
    $("#DriverLicense_" + index).val("");
    $("#VehicleRCBook_" + index).val("");
    $("#EngineNo_" + index).val("");
    $("#ChassisNo_" + index).val("");
  }

  tableclick() {
    $(".ClsVehicleAssginByTrasporter").on("show.bs.dropdown", function (e) {
      $(".table-responsive").css("overflow", "inherit");
      $(".MainDiv").css("width", "100%");
    });
    $(".ClsVehicleAssginByTrasporter").on("hide.bs.dropdown", function () {
      $(".table-responsive").css("overflow", "auto");
      $(".MainDiv").css("width", "1500px");
    });
  }

  CreateNewTransporter() {
    $("#ModalOnflytransporter").modal("show");
    $("#SaveOnflyTransporter").prop("disabled", false);
    this.childNetworkComponent.ClearData();
  }
  CreateNewDriver(i) {
    $("#ModalOnflyDriver").modal("show");
    $("#SaveOnflyDriver").prop("disabled", false);
    //select transporter and driver type by default on new driver
    this.ChilddriverComponent.ClearData();
    var TransporterId = this.MarkAsAssignList[i].TransporterId;
    this.ChilddriverComponent.DriverDetail.TrasporterId = TransporterId;
    this.ChilddriverComponent.GetDriverTypeBasedOnTransporter(TransporterId);
  }
  SaveOnflyDriver() {
    Helpers.setLoading(true);
    $("#SaveOnflyDriver").prop("disabled", true);
    this.ChilddriverComponent.SaveDetails()
      .then((res) => {
        $("#ModalOnflyDriver").modal("hide");
        this.GetSelectDataOfVehicleDriver();
        this.RefreshDropdown();
        Helpers.setLoading(false);
      })
      .catch((res) => {
        Helpers.setLoading(false);
        $("#SaveOnflyDriver").prop("disabled", false);
        this.toastr.error(res, "Error");
      });
  }

  SaveOnflyTransporter() {
    $("#SaveOnflyTransporter").prop("disabled", true);
    this.childNetworkComponent
      .SaveData()
      .then((res) => {
        console.log("booking");
        // $("#ModalOnflytransporter").modal("hide");
        this.TransporterList = [];
        this.Transporter1List = [];
        this.GetTransporterList();
        this.RefreshDropdown();
        //After adding Onfly transporter , Need to refresh Transporter list in OnFly Add Driver
        this.ChilddriverComponent.TransportList = [];
        this.ChilddriverComponent.GetTransportList();
        this.ChilddriverComponent.RefreshDropdown();
      })
      .catch((res) => {
        $("#SaveOnflyTransporter").prop("disabled", false);
        // $("#ModalOnflytransporter").modal('hide');
        this.toastr.error(res, "error");
      });
  }

  GetSelectDataOfTransporter() {
    $(".TransporterSearch").each(function () {
      $(this).select2({
        tags: false,
        width: "100%",
        escapeMarkup: function (markup) {
          return markup;
        },
        minimumInputLength: 2,
        ajax: {
          global: false,
          url: environment.apiUrl + "api/Booking/GetTransporterSelectList",
          delay: 300,
          dataType: "json",
          allowClear: true,
          data: function (params) {
            return {
              query: params.term,
              page: params.page || 1,
              TenantId: BookingComponent.bookingComponent.TenantId,
            };
          },
          processResults: function (data, params) {
            params.page = params.page || 1;
            return {
              results: data.Results,
              pagination: {
                more: params.page * 30 < data.Total,
              },
            };
          },
        },
        tokenSeparators: [",", " "],
        createTag: function (params) {
          var term = $.trim(params.term);
          if (validateVehicle(term)) {
            return {
              id: term,
              text: term.toUpperCase(),
              newTag: true,
            };
          }
          BookingComponent.bookingComponent.toastr.error(
            "Special Characters are not allowed !",
            "Error"
          );
          return null;
          function validateVehicle(no) {
            var re = /^[a-zA-Z0-9 ]*$/;
            return re.test(no);
          }
        },
        insertTag: function (data, tag) {
          data.push(tag);
        },
        placeholder: "Enter Transporter Name",
      });
    });
    $(".TransporterSearch").on("select2:select", function (e) {
      var data = e.params.data;
      let index = e.target.id;

      BookingComponent.bookingComponent.getVehicleChargesData(e.target.id.split("_")[1], data.id, data.text, data.TransporterType);
      // BookingComponent.bookingComponent._appService.GetByTwoId("Booking", "GetVehicleCharges", BookingComponent.bookingComponent.MarkAsAssignList[e.target.id.split("_")[1]].Id, data.id).subscribe((response) => {
      //   var responceObl: any = {};
      //   responceObl = response;

      //   var TruckHireCharge_All: any = 0.0;
      //   BookingComponent.bookingComponent.MarkAsAssignList[e.target.id.split("_")[1]].fuelChargeList = responceObl;
      //   responceObl.forEach((element) => {
      //     if (element.Unit != "FuelPrice") {
      //       TruckHireCharge_All = parseFloat(
      //         (
      //           parseFloat(TruckHireCharge_All) + parseFloat(element.Amount)
      //         ).toFixed(2)
      //       );
      //     }
      //   });

      //   if (
      //     BookingComponent.bookingComponent.flag_FuelPumpWiseBill == 1 &&
      //     (data.TransporterType == "Self" ||
      //       BookingComponent.bookingComponent.hostURL ==
      //       "https://jnp.ifreightbox.net/")
      //   ) {
      //     BookingComponent.bookingComponent.MarkAsAssignList[e.target.id.split("_")[1]].vendorId = BookingComponent.bookingComponent.MarkAsAssignList[e.target.id.split("_")[1]].FuelPumpId;
      //     BookingComponent.bookingComponent.MarkAsAssignList[e.target.id.split("_")[1]].vendorName = BookingComponent.bookingComponent.MarkAsAssignList[e.target.id.split("_")[1]].fuelPumpName;
      //   } else {
      //     BookingComponent.bookingComponent.MarkAsAssignList[e.target.id.split("_")[1]].vendorId = data.id;
      //     BookingComponent.bookingComponent.MarkAsAssignList[e.target.id.split("_")[1]].vendorName = data.text;
      //   }

      //   var thcCharge: any = 0;
      //   thcCharge = TruckHireCharge_All;
      //   BookingComponent.bookingComponent.MarkAsAssignList[e.target.id.split("_")[1]].fuelChargeList.forEach((element) => {
      //     if (
      //       BookingComponent.bookingComponent.flag_FuelPumpWiseBill == 1 &&
      //       (data.TransporterType == "Self" ||
      //         BookingComponent.bookingComponent.hostURL ==
      //         "https://jnp.ifreightbox.net/")
      //     ) {
      //       element.VendorName = BookingComponent.bookingComponent.MarkAsAssignList[e.target.id.split("_")[1]].fuelPumpName;
      //       element.VendorId = BookingComponent.bookingComponent.MarkAsAssignList[e.target.id.split("_")[1]].FuelPumpId;
      //       element.VendorName = BookingComponent.bookingComponent.MarkAsAssignList[e.target.id.split("_")[1]].fuelPumpName;
      //     } else {
      //       element.VendorName = data.text;
      //       element.VendorId = data.id;
      //     }
      //     if (element.Unit == "FuelPrice") {
      //       element.Qty = element.Amount;
      //       element.Rate =
      //         BookingComponent.bookingComponent.MarkAsAssignList[
      //           e.target.id.split("_")[1]
      //         ].todayFuelPrice;
      //       element.Amount = parseFloat(
      //         (element.Qty * element.Rate).toFixed(2)
      //       );
      //       thcCharge = thcCharge + parseFloat(element.Amount.toFixed(2));
      //       // thcCharge = thcCharge + parseFloat((BookingComponent.bookingComponent.MarkAsAssignList[e.target.id.split("_")[1]].todayFuelPrice * element.Amount).toFixed(2));
      //     }
      //   });
      //   BookingComponent.bookingComponent.THCChargeList =
      //     BookingComponent.bookingComponent.MarkAsAssignList[
      //       e.target.id.split("_")[1]
      //     ].fuelChargeList;

      //   BookingComponent.bookingComponent.MarkAsAssignList[
      //     e.target.id.split("_")[1]
      //   ].TruckHireCharge = TruckHireCharge_All;
      //   BookingComponent.bookingComponent.MarkAsAssignList[
      //     e.target.id.split("_")[1]
      //   ].TransporterType = data.TransporterType;
      //   if (
      //     BookingComponent.bookingComponent.flag_FuelPumpWiseBill == "1" &&
      //     (data.TransporterType == "Self" ||
      //       BookingComponent.bookingComponent.hostURL ==
      //       "https://jnp.ifreightbox.net/")
      //   ) {
      //     BookingComponent.bookingComponent.MarkAsAssignList[e.target.id.split("_")[1]].TotalTruckHireCharge = thcCharge;
      //     BookingComponent.bookingComponent.MarkAsAssignList[e.target.id.split("_")[1]].Advance = thcCharge;
      //   } else {
      //     BookingComponent.bookingComponent.MarkAsAssignList[e.target.id.split("_")[1]].TotalTruckHireCharge = TruckHireCharge_All;
      //   }
      // },
      //   (err) => {
      //     BookingComponent.bookingComponent.toastr.error(
      //       "Error occurred while fetching data !",
      //       "error"
      //     );
      //   }
      // );
    });
  }

  getVehicleChargesData(index, id, text, TransporterType) {
    BookingComponent.bookingComponent.MarkAsAssignList[index].TransporterId = id;
    $("#TransportersType_" + index).val(TransporterType);
    $("#TransporterIDForSearch_" + index).val(id);
    var OptionsTrans = "";
    OptionsTrans += '<option value="' + id + '">' + text + "</option>";
    $("#Transporter1_" + index).html(OptionsTrans);
    BookingComponent.bookingComponent.ClearAssignedVehicle(index);
    BookingComponent.bookingComponent._appService.GetByTwoId("Booking", "GetVehicleCharges", BookingComponent.bookingComponent.MarkAsAssignList[index].Id, id).subscribe((response) => {
      var responceObl: any = {};
      responceObl = response;

      var TruckHireCharge_All: any = 0.0;
      BookingComponent.bookingComponent.MarkAsAssignList[index].fuelChargeList = responceObl;
      responceObl.forEach((element) => {
        if (element.Unit != "FuelPrice") {
          TruckHireCharge_All = parseFloat((parseFloat(TruckHireCharge_All) + parseFloat(element.Amount)).toFixed(2));
        }
      });

      if (BookingComponent.bookingComponent.flag_FuelPumpWiseBill == 1 && (TransporterType == "Self" || BookingComponent.bookingComponent.hostURL == "https://jnp.ifreightbox.net/")
      ) {
        BookingComponent.bookingComponent.MarkAsAssignList[index].vendorId = BookingComponent.bookingComponent.MarkAsAssignList[index].FuelPumpId;
        BookingComponent.bookingComponent.MarkAsAssignList[index].vendorName = BookingComponent.bookingComponent.MarkAsAssignList[index].fuelPumpName;
      } else {
        BookingComponent.bookingComponent.MarkAsAssignList[index].vendorId = id;
        BookingComponent.bookingComponent.MarkAsAssignList[index].vendorName = text;
      }

      var thcCharge: any = 0;
      thcCharge = TruckHireCharge_All;
      BookingComponent.bookingComponent.MarkAsAssignList[index].fuelChargeList.forEach((element) => {
        if (BookingComponent.bookingComponent.flag_FuelPumpWiseBill == 1 && (TransporterType == "Self" || BookingComponent.bookingComponent.hostURL == "https://jnp.ifreightbox.net/")
        ) {
          element.VendorName = BookingComponent.bookingComponent.MarkAsAssignList[index].fuelPumpName;
          element.VendorId = BookingComponent.bookingComponent.MarkAsAssignList[index].FuelPumpId;
          element.VendorName = BookingComponent.bookingComponent.MarkAsAssignList[index].fuelPumpName;
        } else {
          element.VendorName = text;
          element.VendorId = id;
        }
        if (element.ServiceProviderId != null) {
          element.VendorName = element.ServiceProviderName;
          element.VendorId = element.ServiceProviderId;
        }
        if (element.Unit == "FuelPrice") {
          element.Qty = element.Amount;
          element.Rate = BookingComponent.bookingComponent.MarkAsAssignList[index].todayFuelPrice;
          element.Amount = parseFloat((element.Qty * element.Rate).toFixed(2));
          thcCharge = thcCharge + parseFloat(element.Amount.toFixed(2));
          // thcCharge = thcCharge + parseFloat((BookingComponent.bookingComponent.MarkAsAssignList[e.target.id.split("_")[1]].todayFuelPrice * element.Amount).toFixed(2));
        }
      });
      BookingComponent.bookingComponent.THCChargeList = BookingComponent.bookingComponent.MarkAsAssignList[index].fuelChargeList;

      BookingComponent.bookingComponent.MarkAsAssignList[index].TruckHireCharge = TruckHireCharge_All;
      BookingComponent.bookingComponent.MarkAsAssignList[index].TransporterType = TransporterType;
      if (BookingComponent.bookingComponent.flag_FuelPumpWiseBill == "1" && (TransporterType == "Self" || BookingComponent.bookingComponent.hostURL == "https://jnp.ifreightbox.net/")
      ) {
        BookingComponent.bookingComponent.MarkAsAssignList[index].TotalTruckHireCharge = thcCharge;
        BookingComponent.bookingComponent.MarkAsAssignList[index].Advance = thcCharge;
      } else {
        BookingComponent.bookingComponent.MarkAsAssignList[index].TotalTruckHireCharge = TruckHireCharge_All;
      }

      //added by vithujan 28-09-2023 - Pragyan
      if (BookingComponent.bookingComponent.hostURL == "https://nol.ifreightbox.net/") {
        BookingComponent.bookingComponent.MarkAsAssignList[index].TotalTruckHireCharge = thcCharge;
        BookingComponent.bookingComponent.MarkAsAssignList[index].Advance = thcCharge;
      }
    },
      (err) => {
        BookingComponent.bookingComponent.toastr.error(
          "Error occurred while fetching data !",
          "error"
        );
      }
    );
  }

  GetSelectDataOfTransporter1Search() {
    $(".Transporter1Search").each(function () {
      $(this).select2({
        tags: false,
        width: "100%",
        escapeMarkup: function (markup) {
          return markup;
        },
        minimumInputLength: 2,
        ajax: {
          global: false,
          url: environment.apiUrl + "api/Booking/GetTransporterSelectList",
          delay: 300,
          dataType: "json",
          allowClear: true,
          data: function (params) {
            return {
              query: params.term,
              page: params.page || 1,
              TenantId: BookingComponent.bookingComponent.TenantId,
            };
          },
          processResults: function (data, params) {
            params.page = params.page || 1;
            return {
              results: data.Results,
              pagination: {
                more: params.page * 30 < data.Total,
              },
            };
          },
        },
        tokenSeparators: [",", " "],
        createTag: function (params) {
          var term = $.trim(params.term);
          if (validateVehicle(term)) {
            return {
              id: term,
              text: term.toUpperCase(),
              newTag: true,
            };
          }
          BookingComponent.bookingComponent.toastr.error(
            "Special Characters are not allowed !",
            "Error"
          );
          return null;
          function validateVehicle(no) {
            var re = /^[a-zA-Z0-9 ]*$/;
            return re.test(no);
          }
        },
        insertTag: function (data, tag) {
          data.push(tag);
        },
        placeholder: "Enter Transporter Name",
      });
    });
  }

  // GetDeliveryDate() {
  //   for (let i = 0; i < this.MarkAsAssignList.length; i++) {
  //     $("#CreatedDate_" + i + ",#LeadTime_" + i).change(function () {
  //       var DueDate = moment($("#CreatedDate_" + i).val(), "DD-MM-YYYY").add(
  //         $("#LeadTime_" + i).val(),
  //         "days"
  //       );
  //       var momentVariable = moment(DueDate, "DD-MM-YYYY");
  //       $("#EstimatedDeliveryDate_" + i).val(
  //         moment(momentVariable).format("DD/MM/YYYY")
  //       );
  //     });
  //   }
  // }

  // added  by vithujan
  getSystemSettingForLeadTime() {
    this._appService
      .GetById("Common", "GetSystemSettingByName", "leadTimeHours")
      .subscribe(
        (response) => {
          this.SystemSettingIdForLeadTimeFlag = response;
        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching Status data !",
            "error"
          );
        }
      );
  }
  // end

  GetDeliveryDate() {
    for (let i = 0; i < this.MarkAsAssignList.length; i++) {
      if (this.SystemSettingIdForLeadTimeFlag == 0) {
        $("#CreatedDate_" + i + ",#LeadTime_" + i).change(function () {
          var DueDate = moment($("#CreatedDate_" + i).val(), "DD-MM-YYYY HH:mm:ss").add($("#LeadTime_" + i).val(), "days");
          var momentVariable = moment(DueDate, "DD-MM-YYYY HH:mm:ss");
          $("#EstimatedDeliveryDate_" + i).val(moment(momentVariable).format("DD/MM/YYYY HH:mm:ss"));
          setTimeout(() => {
            BookingComponent.bookingComponent.RefreshvalidDate();
          }, 100);
        });
      } else {
        $("#CreatedDate_" + i + ",#LeadTime_" + i).change(function () {
          var DueDate = moment($("#CreatedDate_" + i).val(), "DD-MM-YYYY HH:mm:ss").add($("#LeadTime_" + i).val(), "hours");
          var momentVariable = moment(DueDate, "DD-MM-YYYY HH:mm:ss");
          $("#EstimatedDeliveryDate_" + i).val(moment(momentVariable).format("DD/MM/YYYY HH:mm:ss"));
          setTimeout(() => {
            BookingComponent.bookingComponent.RefreshvalidDate();
          }, 100);
        });
      }
    }
  }

  GetOrderRouteAndLoadPlan(BookingID) {
    this._appService
      .GetById("Booking", "GetOrderRouteAndPlan", BookingID)
      .subscribe(
        (response) => {
          var WayPointsres: any = [];
          var res: any = [];
          var PickUpPoints: any = [];
          WayPointsres.push(
            ...response.map((o) => {
              return {
                location: o.DeliveryAddress,
                stopover: true,
                Order: 0,
                RouteOrder: "A",
                OrderNo: o.OrderNo,
                PickUpContactPersonDetail: o.PickUpContactPersonDetail,
                DeliveryContactPersonDetail: o.DeliveryContactPersonDetail,
                OrderAddress: o.DeliveryAddress,
                weight: o.weight,
                Qty: o.Qty,
                cbm: o.cbm,
              };
            })
          );
          var objPickupLocation: any = {};
          (objPickupLocation.origin = response[0].PickupAddress),
            (objPickupLocation.destination =
              response[response.length - 1].DeliveryAddress),
            (objPickupLocation.TripNo = response[0].TripNo),
            (objPickupLocation.DispatchDate = response[0].DispatchDate),
            (objPickupLocation.Transporter = response[0].Transporter),
            (objPickupLocation.TransporterPhone = response[0].TransporterPhone),
            (objPickupLocation.Driver = response[0].Driver),
            (objPickupLocation.DriverPhone = response[0].DriverPhone),
            (objPickupLocation.Vehicle = response[0].Vehicle),
            (objPickupLocation.VehicleType = response[0].VehicleType);
          PickUpPoints.push(objPickupLocation);

          this.ChildWaypointsMapComponent.OrderInfoLatLong = [
            {
              origin: response[0].PickupAddressLatLong,
              destination: response[0].DeliveryAddressLatLong,
            },
          ];
          //add by maaria on 19-10-2023
          this.ChildWaypointsMapComponent.isAssign = false;
          //end
          this.ChildWaypointsMapComponent.OrderInfo = PickUpPoints;
          this.ChildWaypointsMapComponent.OrderDestinationLocation =
            WayPointsres;
          this.ChildWaypointsMapComponent.initMap();
          $("#ModalRouteOpt").modal("show");
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "error");
        }
      );
  }

  GetFormattedDate(Id, ScopeValue) {
    if (
      moment($("#" + Id).datepicker("getDate")).format("YYYY-MM-DD") !=
      "Invalid date"
    ) {
      ScopeValue = moment($("#" + Id).datepicker("getDate")).format(
        "YYYY-MM-DD"
      );
    } else {
      var date = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/;
      if (date.test(ScopeValue)) {
        var d = new Date(ScopeValue.split("/").reverse().join("-"));
        ScopeValue = this.datepipe.transform(d, "yyyy-MM-dd");
      }
    }
    return ScopeValue;
  }

  //add kevin 27/07/2021
  // GetLiveTrackListForBooking(bookingId: any, consignmentDetailId: any){
  //   this.LiveTrackingChild.bookingId = bookingId;
  //   this.LiveTrackingChild.consignmentDetailId = consignmentDetailId;
  //   this.LiveTrackingChild.GetLiveTrackListForBooking();
  // }
  //end

  GetPhotoforassign(drivercode) {
    this.OrderListForBooking = [];
    this._appService
      .GetById("DriverPhotofortrip", "GetDriverPhoto", drivercode)
      .subscribe(
        (response) => {
          this.OrderListForBooking = response;
          this.MarkAsAssignList;
          console.log("this.OrderListForBooking", this.OrderListForBooking);
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "error");
        }
      );
  }

  DownloadFile(FileContent) {
    var byteNumbers = new Array(FileContent.Content.length);
    for (var i = 0; i < FileContent.Content.length; i++) {
      byteNumbers[i] = FileContent.Content.charCodeAt(i);
    }
    var blob = this.commonService.b64toBlob(
      FileContent.Content,
      FileContent.ContentType
    );
    let url = window.URL.createObjectURL(blob);
    $("#DownLoadFileSalesReport").attr("href", url);
    $("#DownLoadFileSalesReport").attr("download", FileContent.FileName);
    let element: HTMLElement = document.getElementById(
      "DownLoadFileSalesReport"
    ) as HTMLElement;
    element.attributes;
    element.click();
  }

  //add vithujan 25-06-2022
  GetConsigmentNoteDetails() {
    setTimeout(() => {
      var divElements = document.getElementById("ModelViewCongNote");
      var $iframe = $("<iframe id='frame'>").appendTo("body");
      var printDiv =
        "<html><head><title> Consignment Note </title></head><body>" +
        divElements.innerHTML +
        "</body></html>";
      $iframe.contents().find("body").html(printDiv);
      var win = $iframe[0].contentWindow || $iframe[0];
      $(win.document).ready(function () {
        setTimeout(() => {
          win.window.print();
          setTimeout(() => {
            $iframe.remove();
          }, 500);
        });
      });
      $iframe.contents().find("body").html(printDiv);
    }, 1000);
  }

  fpp_getFuelPumpWiseBillSetingVal() {
    this._appService
      .GetById("Common", "GetSystemSettingByName", "FuelPumpWiseBill")
      .subscribe(
        (response) => {
          this.flag_FuelPumpWiseBill = response == "" ? 0 : response;
          if (this.flag_FuelPumpWiseBill == "1") {
            this.fpp_getFuelPumpList();
          }
        },
        (err) => {
          this.toastr.error("Error occured while fetching data !", "Error");
        }
      );
  }

  fpp_getFuelPumpList() {
    this._appService
      .GetByTwoId(
        "Booking",
        "fpp_getFuelPumpList_priceWise",
        this.CompanyId,
        this.UserId
      )
      .subscribe(
        (response) => {
          this.fuelPumpList = response;
          this.fuelPumpList.forEach((element) => {
            element.fuelPumpNameWithPrice =
              element.fuelPumpName +
              "( Today's Price: " +
              element.ToadyPrice +
              " )";
          });
        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching Status data !",
            "Error"
          );
        }
      );
  }

  se_fuelPumpChange(selectedVal, arrayIndex) {
    let fuelItem = this.fuelPumpList.find((i) => i.fuelPumpId == selectedVal);
    var laastFulePumpId: any = null;
    // if (fuelItem.ToadyPrice == 0) {
    //   this.MarkAsAssignList.forEach((element, index) => {
    //     if (index == arrayIndex) {
    //       element.isFuelPrice = false;
    //       element.fuelPumpName = fuelItem.fuelPumpName;
    //       element.FuelPumpId = fuelItem.fuelPumpId;
    //       element.todayFuelPrice = fuelItem.ToadyPrice;
    //     }
    //   });
    // }
    // else {
    this.MarkAsAssignList.forEach((element, index) => {
      if (index == arrayIndex) {
        laastFulePumpId = element.LastFuelPumpId;
        element.fuelPumpName = fuelItem.fuelPumpName;
        element.FuelPumpId = fuelItem.fuelPumpId;
        element.LastFuelPumpId = fuelItem.fuelPumpId;
        element.todayFuelPrice = fuelItem.ToadyPrice;
        if (fuelItem.ToadyPrice != 0) {
          element.isFuelPrice = true;
        } else {
          element.isFuelPrice = false;
        }

        var thcCharge: any = 0;
        thcCharge = element.TruckHireCharge;
        element.fuelChargeList.forEach((eleF) => {
          if (eleF.VendorId == laastFulePumpId) {
            eleF.VendorName = fuelItem.fuelPumpName;
            eleF.VendorId = fuelItem.fuelPumpId;
          }
          if (eleF.Unit == "FuelPrice") {
            eleF.Rate = element.todayFuelPrice;
            eleF.Amount = parseFloat((eleF.Qty * eleF.Rate).toFixed(2));
            thcCharge = thcCharge + parseFloat(eleF.Amount.toFixed(2));
            // thcCharge = thcCharge + parseFloat((element.todayFuelPrice * eleF.Amount).toFixed(2));
          }
        });
        element.TotalTruckHireCharge = thcCharge;
        element.Advance = thcCharge;
      }
    });
    // }
  }

  fpp_saveFuelPrice(fuelPumpId, arrayIndex) {
    if (
      $($("#in_todayFuelPrice_" + arrayIndex)).val() == "" ||
      $($("#in_todayFuelPrice_" + arrayIndex)).val() == "0" ||
      $($("#in_todayFuelPrice_" + arrayIndex)).val() == null
    ) {
      this.toastr.error("Please enter valid today's fuel price", "Error");
      return false;
    } else {
      Helpers.setLoading(true);
      $("#btn_saveFuelPrice_" + arrayIndex).prop("disabled", true);
      $("#SaveAssginVehicleData").prop("disabled", true);
      this._appService
        .GetByThreeId(
          "Booking",
          "fpp_saveFuelPumpTodayPrice",
          fuelPumpId,
          $($("#in_todayFuelPrice_" + arrayIndex)).val(),
          this.UserId
        )
        .subscribe(
          (response) => {
            this.toastr.success("Data save successfully !", "Success");
            this.fuelPumpList.forEach((element) => {
              if (element.fuelPumpId == fuelPumpId) {
                element.fuelPumpNameWithPrice =
                  element.fuelPumpName +
                  "( Today's Price: " +
                  $($("#in_todayFuelPrice_" + arrayIndex)).val() +
                  " )";
                element.ToadyPrice = $(
                  $("#in_todayFuelPrice_" + arrayIndex)
                ).val();
              }
            });
            this.MarkAsAssignList.forEach((element, index) => {
              if (arrayIndex == index) {
                element.isFuelPrice = true;
                element.todayFuelPrice = $(
                  $("#in_todayFuelPrice_" + arrayIndex)
                ).val();

                var thcCharge: any = 0;
                thcCharge = element.TruckHireCharge;
                element.fuelChargeList.forEach((eleF) => {
                  if (eleF.Unit == "FuelPrice") {
                    eleF.Rate = element.todayFuelPrice;
                    eleF.Amount = parseFloat((eleF.Qty * eleF.Rate).toFixed(2));
                    thcCharge = thcCharge + parseFloat(eleF.Amount.toFixed(2));
                    // thcCharge = thcCharge + parseFloat((element.todayFuelPrice * eleF.Amount).toFixed(2));
                  }
                });
                element.TotalTruckHireCharge = thcCharge;
                element.Advance = thcCharge;
              }
            });
            $("#btn_saveFuelPrice_" + arrayIndex).prop("disabled", false);
            $("#SaveAssginVehicleData").prop("disabled", false);
            setTimeout(() => {
              (<any>$(".se_fuelPump")).selectpicker("refresh");
            }, 100);
            Helpers.setLoading(false);
          },
          (err) => {
            this.toastr.error(
              "Error occurred while fetching Status data !",
              "Error"
            );
            $("#btn_saveFuelPrice_" + arrayIndex).prop("disabled", false);
            $("#SaveAssginVehicleData").prop("disabled", false);
            Helpers.setLoading(false);
          }
        );
    }
  }

  //added by vithujan 29-12-2022
  GetVehicleList() {
    this._appService.Get("VehicleMaster", "GetVehicleType").subscribe(
      (response) => {
        this.VehicleType = response;
        (<any>$("#VehicleType1")).selectpicker("refresh");
      },
      (err) => {
        this.toastr.error(
          "Error occurred while fetching Vehicle Type data !",
          "error"
        );
      }
    );
  }

  UpdateVehicleList() {
    BookingComponent.bookingComponent.MarkAsAssignList.forEach((element) => {
      BookingComponent.bookingComponent._appService
        .GetByTwoId(
          "Booking",
          "UpdateVehicleTypes",
          element.FCNumber,
          element.VehicleId
        )
        .subscribe(
          (response) => { },
          (err) => {
            BookingComponent.bookingComponent.toastr.error(
              "Error occurred while fetching Vehicle Type data !",
              "error"
            );
          }
        );
    });
  }

  //added by vithujan 09-01-2023
  disableContextMenu() {
    this.contextmenu = false;
  }

  onrightClick(event) {
    this.contextmenuX = event.clientX;
    this.contextmenuY = event.clientY;
    this.contextmenu = true;
  }

  redirectPage(name: any) {
    if (name == "tripDocumentPrint")
      this.router.navigate(["/tripDocumentPrint"]);
    // Pickup
    if (name == "mp_GateIn") this.router.navigate(["/mp_GateIn"]);
    if (name == "mp_PendingLR") this.router.navigate(["/mp_PendingLR"]);
    if (name == "mp_OriginGateOut") this.router.navigate(["/mp_OriginGateOut"]);
    // Origin
    if (name == "ECPickup") this.router.navigate(["/ECPickup"]);
    if (name == "AssignedVehicle") this.router.navigate(["/AssignedVehicle"]);
    if (name == "GateIn") this.router.navigate(["/GateIn"]);
    if (name == "ReadyToDispatch") this.router.navigate(["/ReadyToDispatch"]);
    if (name == "eWayBill") this.router.navigate(["/eWayBill"]);
    // Destination
    if (name == "PendingArrival") this.router.navigate(["/PendingArrival"]);
    if (name == "DestinationGateIn")
      this.router.navigate(["/DestinationGateIn"]);
    if (name == "GateOut") this.router.navigate(["/GateOut"]);
    if (name == "DeliveryConfirmed")
      this.router.navigate(["/DeliveryConfirmed"]);
    // added by vithujan 06-02-2023
    if (name == "ReturnTrips") this.router.navigate(["/ReturnTrips"]);
    //end
    if (name == "BookingCompleted") this.router.navigate(["/BookingCompleted"]);
  }
  //end

  thc_GetThcChargeList(bookingId, index) {
    $("#THCChargeList").modal("show");
    this.ChargeObj = {};
    this.ChargeObj.Amount = 0;
    this.ChargeObj.isEdit = "false";
    this.getChargeList();
    this.totalChargeAmount = 0;
    this.totalAdvance = 0;
    this.THCChargeRemark = this.MarkAsAssignList[index].THCChargeRemark;
    this.indexOFOrderForCharge = index;
    this.THCChargeList = this.MarkAsAssignList[index].fuelChargeList;
    this.THCChargeList.forEach((element) => {
      this.totalChargeAmount = this.totalChargeAmount + element.Amount;
      this.totalAdvance = this.totalAdvance + element.Advance;
    });
    setTimeout(() => {
      (<any>$("#BasedOn")).selectpicker("refresh");
      var vendorOption = '<option value="' + this.MarkAsAssignList[index].vendorId + '">' + this.MarkAsAssignList[index].vendorName + "</option>";
      $("#se2_Vendor").html(vendorOption);
      $("#se2_Vendor").val(this.MarkAsAssignList[index].vendorId).change();
    }, 200);
  }

  // thc_GetThcChargeList(bookingId) {
  //   $("#THCChargeList").modal("show");
  //   this.ChildTripExpenseComponent.THCChargeList = [];
  //   this.ChildTripExpenseComponent.ChargeObj = {};
  //   this.ChildTripExpenseComponent.ChargeObj.Amount = 0;
  //   this.ChildTripExpenseComponent.ChargeObj.isEdit = 'false';
  //   this.getChargeList();
  //   this.ChildTripExpenseComponent.totalChargeAmount = 0;
  //   this.ChildTripExpenseComponent.THCChargeList.forEach(element => {
  //     this.ChildTripExpenseComponent.totalChargeAmount = this.ChildTripExpenseComponent.totalChargeAmount + element.Amount;
  //   });
  //   this.ChildTripExpenseComponent.isHideFooter = true;
  //   this.ChildTripExpenseComponent.GSTType = 'Inter';
  //   this.ChildTripExpenseComponent.TransporterId = null;
  //   this.ChildTripExpenseComponent.THCId = null;
  //   setTimeout(() => {
  //     (<any>$("#BasedOn")).selectpicker("refresh");
  //   }, 200);
  // }

  PopChangeData() {
    if (
      this.ChargeObj.Discount == "undefined" ||
      this.ChargeObj.Discount == null
    ) {
      this.ChargeObj.Discount = 0;
    } else {
      this.ChargeObj.Discount = parseFloat(this.ChargeObj.Discount.toFixed(2));
    }
    if (this.ChargeObj.Rate == "undefined" || this.ChargeObj.Rate == null) {
      this.ChargeObj.Rate = 0;
    } else {
      this.ChargeObj.Rate = parseFloat(this.ChargeObj.Rate.toFixed(2));
    }
    if (
      this.ChargeObj.Quantity == "undefined" ||
      this.ChargeObj.Quantity == null
    ) {
      this.ChargeObj.Quantity = 0;
    } else {
      this.ChargeObj.Quantity = parseFloat(
        parseFloat(this.ChargeObj.Quantity).toFixed(2)
      );
    }
    this.ChargeObj.Amount =
      this.ChargeObj.Rate * this.ChargeObj.Quantity - this.ChargeObj.Discount;
    this.ChargeObj.Amount = parseFloat(this.ChargeObj.Amount.toFixed(2));

    if (this.IsAdvanceChargeCode) {
      this.ChargeObj.Advance = this.ChargeObj.Amount;
    }

    //add by maaria
    if (this.ChargeObj.Advance == "undefined" || this.ChargeObj.Advance == null) {
      this.ChargeObj.Advance = 0;
    } else {
      if (this.ChargeObj.Advance > this.ChargeObj.Amount) {
        this.isAdvance = true;
      }
      else {
        this.isAdvance = false;
        this.ChargeObj.Advance = parseFloat(this.ChargeObj.Advance.toFixed(2));
      }
    }
    //end
  }

  addChargeinAmount(isEdit) {
    if (
      !this.commonService.ValidateRequiredField2(
        $("#Charges"),
        $("#FieldSetCharge"),
        "Please Select Charge",
        "after",
        ""
      )
    ) {
      return false;
    }
    if (
      !this.commonService.ValidateRequiredField2(
        $("#Charges"),
        $("#FieldSetCharge"),
        "Please Select Charge",
        "after",
        ""
      )
    ) {
      return false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#BasedOn"),
        "Please Select Based On",
        "after",
        ""
      )
    ) {
      return false;
    }
    if (this.ChargeObj.Amount != 0) {
      if (isEdit == "true") {
        this.THCChargeList[this.ChargeObj.index].VendorId =
          $("#se2_Vendor").val();
        this.THCChargeList[this.ChargeObj.index].VendorName = $(
          "#se2_Vendor option:selected"
        )
          .text()
          .trim();
        this.THCChargeList[this.ChargeObj.index].ChargeCode = $(
          "#Charges option:selected"
        )
          .text()
          .trim();
        this.THCChargeList[this.ChargeObj.index].Unit = this.ChargeObj.BasedOn;
        this.THCChargeList[this.ChargeObj.index].Qty = this.ChargeObj.Quantity;
        this.THCChargeList[this.ChargeObj.index].Rate = this.ChargeObj.Rate;
        this.THCChargeList[this.ChargeObj.index].Amount = this.ChargeObj.Amount;
        //add by maaria
        this.THCChargeList[this.ChargeObj.index].Advance = this.ChargeObj.Advance;
      } else {
        var obj: any = {};
        obj.VendorId = $("#se2_Vendor").val();
        obj.VendorName = $("#se2_Vendor option:selected").text().trim();
        obj.ChargeCode = $("#Charges option:selected").text().trim();
        obj.Unit = this.ChargeObj.BasedOn;
        obj.Qty = this.ChargeObj.Quantity;
        obj.Rate = this.ChargeObj.Rate;
        obj.Amount = this.ChargeObj.Amount;
        //add by maaria
        obj.Advance = this.ChargeObj.Advance;
        obj.ContractAmount = 0;
        obj.IsContracted = "false";
        this.THCChargeList.push(obj);
      }
      this.IsAdvanceChargeCode = false;
      this.totalChargeAmount = 0;
      this.totalAdvance = 0;
      this.THCChargeList.forEach((element) => {
        this.totalChargeAmount = this.totalChargeAmount + element.Amount;
        this.totalAdvance = this.totalAdvance + element.Advance;
      });
      $("#BasedOn").val("");
      $("#se2_Vendor").val("");
      $("#se2_Vendor").select2("destroy");
      $("#Charges").val("");
      $("#Charges").select2("destroy");
      this.getChargeList();
      this.ChargeObj = {};
      this.ChargeObj.Amount = 0;
      this.ChargeObj.isEdit = "false";
      setTimeout(() => {
        (<any>$("#BasedOn")).selectpicker("refresh");
        var vendorOption = '<option value="' + this.MarkAsAssignList[this.indexOFOrderForCharge].vendorId + '">' + this.MarkAsAssignList[this.indexOFOrderForCharge].vendorName + "</option>";
        $("#se2_Vendor").html(vendorOption);
        $("#se2_Vendor").val(this.MarkAsAssignList[this.indexOFOrderForCharge].vendorId).change();
      }, 200);
    } else {
      this.toastr.error("Amount is zero !", "error");
    }
  }

  EditCharge(index) {
    var vendorOption =
      '<option value="' +
      this.THCChargeList[index].VendorId +
      '">' +
      this.THCChargeList[index].VendorName;
    +"</option>";
    $("#se2_Vendor").html(vendorOption);
    var chargeOption =
      '<option value="' +
      this.THCChargeList[index].ChargeCode +
      '">' +
      this.THCChargeList[index].ChargeCode;
    +"</option>";
    $("#Charges").html(chargeOption);
    this.ChargeObj.BasedOn = this.THCChargeList[index].Unit;
    this.ChargeObj.Quantity = this.THCChargeList[index].Qty;
    this.ChargeObj.Rate = this.THCChargeList[index].Rate;
    this.ChargeObj.Amount = this.THCChargeList[index].Amount;
    //add by maaria
    this.ChargeObj.Advance = this.THCChargeList[index].Advance;
    this.ChargeObj.isEdit = "true";
    this.ChargeObj.index = index;
    if (this.THCChargeList[index].ChargeCode == 'Trip Advance To Driver') {
      this.IsAdvanceChargeCode = true;
    } else {
      this.IsAdvanceChargeCode = false;
    }
    setTimeout(() => {
      (<any>$("#BasedOn")).selectpicker("refresh");
    }, 200);
  }

  DeleteCharge(index) {
    swal({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: !0,
      confirmButtonText: "Yes, delete it!",
    }).then(function (e) {
      BookingComponent.bookingComponent.THCChargeList.splice(index, 1);
      BookingComponent.bookingComponent.totalChargeAmount = 0;
      BookingComponent.bookingComponent.totalAdvance = 0;
      BookingComponent.bookingComponent.THCChargeList.forEach((element) => {
        BookingComponent.bookingComponent.totalChargeAmount =
          BookingComponent.bookingComponent.totalChargeAmount + element.Amount;
        BookingComponent.bookingComponent.totalAdvance =
          BookingComponent.bookingComponent.totalAdvance + element.Advance;
      });
    });
  }

  saveChargeiAmount() {
    this.MarkAsAssignList[this.indexOFOrderForCharge].TotalTruckHireCharge = 0;
    this.MarkAsAssignList[this.indexOFOrderForCharge].Advance = 0;
    this.THCChargeList.forEach((element) => {
      this.MarkAsAssignList[this.indexOFOrderForCharge].TotalTruckHireCharge = this.MarkAsAssignList[this.indexOFOrderForCharge].TotalTruckHireCharge + element.Amount;
      //add by maaria for advance pay total
      this.MarkAsAssignList[this.indexOFOrderForCharge].Advance = this.MarkAsAssignList[this.indexOFOrderForCharge].Advance + element.Advance;
      //end
    });
    this.MarkAsAssignList[this.indexOFOrderForCharge].fuelChargeList = this.THCChargeList;
    this.MarkAsAssignList[this.indexOFOrderForCharge].THCChargeRemark = this.THCChargeRemark;
    this.totalChargeAmount = 0;
    this.totalAdvance = 0;
    this.THCChargeList.forEach((element) => {
      this.totalChargeAmount = this.totalChargeAmount + element.Amount;
      this.totalAdvance = this.totalAdvance + element.Advance;
    });
    if (BookingComponent.bookingComponent.flag_FuelPumpWiseBill == "1" &&
      (this.MarkAsAssignList[this.indexOFOrderForCharge].TransporterType == "Self" ||
        BookingComponent.bookingComponent.hostURL == "https://jnp.ifreightbox.net/")
    ) {
      this.MarkAsAssignList[this.indexOFOrderForCharge].Advance = this.MarkAsAssignList[this.indexOFOrderForCharge].TotalTruckHireCharge;
    }
    $("#THCChargeList").modal("hide");
  }
  // saveChargeiAmount() {
  //   this.MarkAsAssignList[this.indexOFOrderForCharge].TotalTruckHireCharge = 0;
  //   this.ChildTripExpenseComponent.THCChargeList.forEach(element => {
  //     this.MarkAsAssignList[this.indexOFOrderForCharge].TotalTruckHireCharge = this.MarkAsAssignList[this.indexOFOrderForCharge].TotalTruckHireCharge + element.totalAmount;
  //   });
  //   this.MarkAsAssignList[this.indexOFOrderForCharge].fuelChargeList = this.ChildTripExpenseComponent.THCChargeList;
  //   this.ChildTripExpenseComponent.totalChargeAmount = 0;
  //   this.ChildTripExpenseComponent.THCChargeList.forEach(element => {
  //     this.ChildTripExpenseComponent.totalChargeAmount = this.ChildTripExpenseComponent.totalChargeAmount + element.totalAmount;
  //   });
  //   $("#THCChargeList").modal("hide");
  // }

  getChargeList() {
    $("#Charges").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Bills/GetChargeForAccouting",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            query: params.term,
            page: params.page || 1,
            ChargeType: "Charge",
            GSTType: "Inter",
            TransporterId: null,
            THCId: null,
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data.Results,
            pagination: {
              more: params.page * 30 < data.Total,
            },
          };
        },
      },
      tokenSeparators: [",", " "],
      placeholder: "Search for Charges",
    });

    $("#Charges").on("select2:select", function (e) {
      var data = e.params.data;
      if (data.text == 'Trip Advance To Driver') {
        BookingComponent.bookingComponent.IsAdvanceChargeCode = true;
      } else {
        BookingComponent.bookingComponent.IsAdvanceChargeCode = false;
      }
    });

    $("#se2_Vendor").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Booking/td_getTripExpenseVendor",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            Id: BookingComponent.bookingComponent.CompanyId,
            param1: params.term,
          };
        },
        processResults: function (data) {
          return {
            results: data,
          };
        },
      },
      tokenSeparators: [","],
      placeholder: "Search for Vendor",
    });

    $("#se2_Vendor").on("select2:select", function (e) {
      var data = e.params.data;
      // TripDocumentPrintComponent.tripDocumentPrintComponent.deliveryno = data.id;
    });
  }

  //added by vithujan 04-03-2023
  GetOderDeliveryDate(id: any, i: any) {
    var obj: any = {};
    obj.OrderNo = id;

    this._appService.Post("OrdersByVehicle", "GetDeliveryDate", obj).subscribe(
      (response) => {
        this.OrdersDeliveryDate = response;
        this.MarkAsAssignList[i].orderWeight = 0;
        this.MarkAsAssignList[i].orderWeight = response[0].orderWeight;
        var momentVariable = moment(new Date(this.OrdersDeliveryDate[0].DeliviryDate), "DD-MM-YYYY HH:mm:ss");
        $("#EstimatedDeliveryDate_" + i).val(moment(momentVariable).format("DD/MM/YYYY HH:mm:ss"));

        // var EstDeliveryDate = $("#EstimatedDeliveryDate_" + i).val();
        // var DepartureDate = $("#CreatedDate_" + i).val();

        // var dateOneObj: any = new Date(EstDeliveryDate);
        // var dateTwoObj: any = new Date(DepartureDate);
        // var milliseconds = Math.abs(dateOneObj.getTime() - dateTwoObj.getTime());
        // var hours: any = milliseconds / 360000;

        // $("#LeadTime_" + i).val(parseInt(hours));
        // alert(hours);
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }

  // CalcHrs() {
  //   for (let i = 0; i < this.MarkAsAssignList.length; i++) {
  //     $("#EstimatedDeliveryDate_" + i + "").change(function () {
  //       var EstDeliveryDate = $("#EstimatedDeliveryDate_" + i).val();
  //       var DepartureDate = $("#CreatedDate_" + i).val();

  //       var dateOneObj: any = new Date(EstDeliveryDate);
  //       var dateTwoObj: any = new Date(DepartureDate);
  //       var milliseconds = Math.abs(dateOneObj.getTime() - dateTwoObj.getTime());
  //       var hours: any = milliseconds / 360000;

  //       $("#LeadTime_" + i).val(parseInt(hours));
  //       alert(hours);

  //     });
  //   }

  // }

  //addded by vithujan 28-04-2023
  ClearValidationsForBankDetails() {
    BookingComponent.bookingComponent.commonService.ClearMessage(
      $("#AccountNoForCompany")
    );
    BookingComponent.bookingComponent.commonService.ClearMessage(
      $("#BankForCompany")
    );
    BookingComponent.bookingComponent.commonService.ClearMessage(
      $("#BranchForCompany")
    );
    BookingComponent.bookingComponent.commonService.ClearMessage(
      $("#IFSCCodeForCompany")
    );
  }

  NewBankAccount() {
    if (
      this.childNetworkComponent.Company.Id != null &&
      this.childNetworkComponent.Company.Id != undefined &&
      this.childNetworkComponent.Company.Id != ""
    ) {
      this.AccountDetail = {};
      $("#BankDetailsModal1").modal("show");
      this.ClearValidationsForBankDetails();
    } else {
      this.toastr.error(
        this.translate.instant("VEHICLEMASTER.FillBasicInfo"),
        "Required"
      );
    }
  }

  ValidateField() {
    var flag = true;
    if (
      !this.commonService.ValidateRequiredField(
        $("#AccountNoForCompany"),
        "Please Enter Account No",
        "after",
        ""
      )
    ) {
      flag = false;
    }

    if (
      !this.commonService.ValidateRequiredField(
        $("#BankForCompany"),
        "Please Enter Bank",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#BranchForCompany"),
        "Please Enter Branch",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#IFSCCodeForCompany"),
        "Please Enter IFSC Code",
        "after",
        ""
      )
    ) {
      flag = false;
    }

    return flag;
  }

  SaveAccount() {
    Helpers.setLoading(true);
    var flag = this.ValidateField();
    if (flag != false) {
      if (
        this.childNetworkComponent.Company.Id != "undefined" &&
        this.childNetworkComponent.Company.Id != null &&
        this.childNetworkComponent.Company.Id != ""
      ) {
        this.AccountDetail.CompanyId = this.childNetworkComponent.Company.Id;
        this._appService
          .Post("Network", "SaveCompanyAccountDetail", this.AccountDetail)
          .subscribe(
            (response) => {
              $("#BankDetailsModal1").modal("hide");
              $("#ModalOnflytransporter").modal("hide");
              // this.GetBankAccountList(this.Company.Id);

              this.toastr.success(
                "Bank details saved Successfully !",
                "Success"
              );
            },
            (err) => {
              this.toastr.error("Error occurred while saving data !", "error");
            }
          );
      }
    } else {
      const FillRequiredDetails = this.translate.instant(
        "ALERTMESSAGES.FillRequiredDetails"
      );
      this.toastr.error(FillRequiredDetails, "error");
    }

    Helpers.setLoading(false);
  }

  //added by vithujan 04-05-2023
  LoadValidateTHCADvanceAmount() {
    this._appService
      .GetById("Common", "GetSystemSettingByName", "ValidateTHCADvanceAmount")
      .subscribe(
        (response) => {
          if (response == "1") {
            this.ValidateTHCADvanceAmountFlag = true;
          } else {
            this.ValidateTHCADvanceAmountFlag = false;
          }
        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching Status data !",
            "error"
          );
        }
      );
  }
  //end

  change_productAllocateQty(mainIndex, productIndex) {
    this.MarkAsAssignList[mainIndex].BookingOrderProduct[productIndex].PendingQty = parseFloat((this.MarkAsAssignList[mainIndex].BookingOrderProduct[productIndex].TotalQty
      - this.MarkAsAssignList[mainIndex].BookingOrderProduct[productIndex].BookedQty
      - this.MarkAsAssignList[mainIndex].BookingOrderProduct[productIndex].AllocateQty).toFixed(2));
  }

  av_FindeVehicle(index, isRefresh) {
    this.FVModelListData = [];
    if (!isRefresh) {
      this.FVModelBasicData = { pickupLocation: '', pickupAddress: '', pickupLatitude: '0.0', pickupLongitude: '0.0', NearestKM: 50 };
    }
    var backupBasicData: any = {};
    backupBasicData = this.FVModelBasicData;
    if (isRefresh) {
      index = this.indexOFOrderForCharge;
    }
    this.indexOFOrderForCharge = index;
    this._appService.GetByFourId("Booking", "av_getFindeVehicleByLatLong", this.MarkAsAssignList[this.indexOFOrderForCharge].Id, this.FVModelBasicData.pickupLatitude, this.FVModelBasicData.pickupLongitude, this.FVModelBasicData.NearestKM).subscribe((response) => {
      this.FVModelBasicData = response.Table[0];
      if (response.Table1[0].transporterId != null) {
        this.FVModelListData = response.Table1;
      }
      this.FVModelBasicData.NearestKM = backupBasicData.NearestKM;
      if (!isRefresh) {
        $("#div_avFindVehicle").modal("show");
      } else {
        this.FVModelBasicData.pickupLatitude = backupBasicData.pickupLatitude;
        this.FVModelBasicData.pickupLongitude = backupBasicData.pickupLongitude;
      }
      this.initMapFindVEhicle();
    },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }

  initMapFindVEhicle() {
    const directionsService = new google.maps.DirectionsService();
    const directionsRenderer = new google.maps.DirectionsRenderer();
    this.FVBeachMarker = [];
    var image = "../../../assets/img/truck_active.png";
    this.FVMap = new google.maps.Map(document.getElementById("MapFindVehicle"), {
      zoom: 6,
      center: { lat: this.FVModelBasicData.pickupLatitude, lng: this.FVModelBasicData.pickupLongitude },
      mapTypeControl: true,
      mapTypeControlOptions: {
        position: google.maps.ControlPosition.TOP_RIGHT
      }
    });

    var bmMarkerMain = new google.maps.Marker({
      position: { lat: this.FVModelBasicData.pickupLatitude, lng: this.FVModelBasicData.pickupLongitude },
      map: this.FVMap,
      title: this.FVModelBasicData.pickupLocation,
    });
    const infoWindow = new google.maps.InfoWindow();
    bmMarkerMain.addListener("click", () => {
      infoWindow.close();
      infoWindow.setContent('<table style="table-layout: fixed;">' +
        '<tr>' +
        '<td style="font-weight: bold">Location:</td>' +
        '<td>' + this.FVModelBasicData.pickupLocation + '</td>' +
        '</tr>' +
        '<tr>' +
        '<td style="font-weight: bold">Address:</td>' +
        '<td>' + this.FVModelBasicData.pickupAddress + '</td>' +
        '</tr>' +
        //end
        '</table>');
      infoWindow.open(bmMarkerMain.getMap(), bmMarkerMain);
    });
    directionsRenderer.setMap(this.FVMap);
    this.FVBeachMarker.push(bmMarkerMain);

    this.FVModelListData.forEach(element => {
      var bmMarker = new google.maps.Marker({
        position: { lat: element.latilute, lng: element.longitute },
        map: this.FVMap,
        icon: image,
        title: element.vehicleNo,
      });
      const infoWindow = new google.maps.InfoWindow();
      bmMarker.addListener("click", () => {
        bmMarker.setAnimation(google.maps.Animation.BOUNCE);
        setTimeout(() => {
          bmMarker.setAnimation(null);
        }, 2000);
        infoWindow.close();
        infoWindow.setContent('<table style="table-layout: fixed;">' +
          '<tr>' +
          '<td style="font-weight: bold">Vehicle No:</td>' +
          '<td>' + element.vehicleNo + '</td>' +
          '</tr>' +
          '<tr>' +
          '<td style="font-weight: bold">Distance:</td>' +
          '<td>' + element.distance + '</td>' +
          '</tr>' +
          //end
          '</table>');
        infoWindow.open(bmMarker.getMap(), bmMarker);
      });
      directionsRenderer.setMap(this.FVMap);
      this.FVBeachMarker.push(bmMarker);
    });
  }

  clickFindVehicleOneVehicleClick(index) {
    this.FVBeachMarker.forEach(element => {
      element.setAnimation(null);
    });
    this.FVBeachMarker[index + 1].setAnimation(google.maps.Animation.BOUNCE);
  }

  fv_selectVehicle(index) {
    $("#div_avFindVehicle").modal("hide");

    let OptionsTran = '<option value="' + this.FVModelListData[index].transporterId + '">' + this.FVModelListData[index].trnasporterName + "</option>";
    $("#Transporter_" + this.indexOFOrderForCharge).html(OptionsTran);
    $("#Transporter_" + this.indexOFOrderForCharge).val(this.FVModelListData[index].transporterId).change();
    this.getVehicleChargesData(this.indexOFOrderForCharge, this.FVModelListData[index].transporterId, this.FVModelListData[index].trnasporterName, this.FVModelListData[index].transporterType);

    let OptionsVhi = '<option value="' + this.FVModelListData[index].vehicleNo + '">' + this.FVModelListData[index].vehicleNo + "</option>";
    $("#DriverVehicleNo_" + this.indexOFOrderForCharge).html(OptionsVhi);
    $("#DriverVehicleNo_" + this.indexOFOrderForCharge).val(this.FVModelListData[index].vehicleNo).change();

    if (this.FVModelListData[index].driverMobileName != null) {
      let OptionsDri = '<option value="' + this.FVModelListData[index].driverMobileName + '">' + this.FVModelListData[index].driverName + "</option>";
      $("#AssginDriver_" + this.indexOFOrderForCharge).html(OptionsDri);
      $("#AssginDriver_" + this.indexOFOrderForCharge).val(this.FVModelListData[index].driverMobileName).change();
      $("#DriverMobile_" + this.indexOFOrderForCharge).val(this.FVModelListData[index].driverMobileName);
    }

    this.FVModelBasicData = { pickupLocation: '', pickupAddress: '', pickupLatitude: '0.0', pickupLongitude: '0.0', NearestKM: 50 };
    this.FVModelListData = [];
  }

  validateAdvance() {

  }

  getThcApproveRejectData(bookingId) {
    this._appService.GetById("Booking", "av_getThcApproveRejectHistoryData", bookingId).subscribe((response) => {
      this.tar_THCApproveRejectData = response;
      $("#div_avThcApproveRejectHistoryData").modal("show");
    },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }

  OnTransporterChange() {

  }

  OnUploadClick(event) {


  }

  // added by vithujan 19-10-2023 - Siddarth
  SaveDeletedTransactionHistory(Id) {
    var obj: any = {};
    obj.TransactionId = Id;
    obj.TransactionType = 'Trips';
    obj.UserId = this.UserId;

    this._appService.Post("Common", "SaveDelTransactionHistory", obj).subscribe((response) => {
    },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }

  changeFindleVehicleListView(type) {

    this.FindVehicleListViewType = type;
    if (type == 'Calendar') {
      this.GetReport();
    }
  }

  SetCalenderForVehicle() {
    var defaultConfigurations: any = {
      eventClick: info => {
        $("#div_FindVehicleData").modal("show");
        BookingComponent.bookingComponent.FindVehicleDetailData = [];
        BookingComponent.bookingComponent.FindVehicleDetailData.push(info);
      },
      editable: false,
      eventLimit: true,
      titleFormat: "MMM D YYYY",
      header: {
        left: "prev,next today",
        center: "title",
        right: "month"
      },
      buttonText: {
        month: this.translate.instant("Calendar.Month")
      },
      views: {
        agenda: {
          eventLimit: 1
        }
      },
      allDaySlot: false,
      slotDuration: moment.duration("00:15:00"),
      slotLabelInterval: moment.duration("01:00:00"),
      firstDay: 1,
      selectable: true,
      selectHelper: true,
      height: 300,
      monthNames: [
        this.translate.instant("Calendar.January")
        , this.translate.instant("Calendar.February")
        , this.translate.instant("Calendar.March")
        , this.translate.instant("Calendar.April")
        , this.translate.instant("Calendar.May")
        , this.translate.instant("Calendar.June")
        , this.translate.instant("Calendar.July")
        , this.translate.instant("Calendar.August")
        , this.translate.instant("Calendar.September")
        , this.translate.instant("Calendar.October")
        , this.translate.instant("Calendar.November")
        , this.translate.instant("Calendar.December")
      ],
      monthNamesShort: [
        this.translate.instant("Calendar.January")
        , this.translate.instant("Calendar.Feb")
        , this.translate.instant("Calendar.Mar")
        , this.translate.instant("Calendar.Apr")
        , this.translate.instant("Calendar.May")
        , this.translate.instant("Calendar.Jun")
        , this.translate.instant("Calendar.Jul")
        , this.translate.instant("Calendar.Aug")
        , this.translate.instant("Calendar.Sep")
        , this.translate.instant("Calendar.Oct")
        , this.translate.instant("Calendar.Nov")
        , this.translate.instant("Calendar.Dec")
      ],
      dayNames: [
        this.translate.instant("Calendar.Sunday")
        , this.translate.instant("Calendar.Monday")
        , this.translate.instant("Calendar.Tuesday")
        , this.translate.instant("Calendar.Wednesday")
        , this.translate.instant("Calendar.Thursday")
        , this.translate.instant("Calendar.Friday")
        , this.translate.instant("Calendar.Saturday")
      ],
      dayNamesShort: [
        this.translate.instant("Calendar.Sun")
        , this.translate.instant("Calendar.Mon")
        , this.translate.instant("Calendar.Tue")
        , this.translate.instant("Calendar.Wed")
        , this.translate.instant("Calendar.Thu")
        , this.translate.instant("Calendar.Fri")
        , this.translate.instant("Calendar.Sat")
      ],
    };

    $("#full-calendar").fullCalendar(defaultConfigurations);

    var eventData: any = [];
    var obj: any = {};
    var index: any = 0;
    for (const item of this.FVModelListData) {
      obj = {};
      obj.title = item.vehicleNo;
      obj.desciption = item;
      obj.start = item.EstimatedDeliveryDateFormate;
      obj.end = item.EstimatedDeliveryDateFormate;
      obj.color = item.VehicleStatus == 'Allocated' ? '#fd7e14' : '#007bff';
      obj.index = index;
      obj.allDay = true;
      eventData.push(obj);
      index = index + 1;
    }
    console.log('eventData', eventData);
    $("#full-calendar").fullCalendar("removeEvents");
    $("#full-calendar").fullCalendar("addEventSource", eventData);
    $("#full-calendar").fullCalendar("refetchEvents");
  }
  GetReport() {
    Helpers.setLoading(true);

    // Check if the date input is not empty or undefined
    if ($("#FromDateForReceipt").val() != "" && $("#FromDateForReceipt").val() != undefined) {
      this.FromDate = this.GetFormattedDate("FromDateForReceipt", this.FromDate);
    } else {
      // If FromDate is null or undefined, set it to today's date
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, '0');
      const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
      const yyyy = today.getFullYear();

      this.FromDate = `${yyyy}-${mm}-${dd}`; // Adjust the format as needed
    }

    // Call the service with the determined FromDate
    this._appService.GetById("OperationalReport", "GetVehicleWiseMonthlyCalendar", this.FromDate).subscribe(response => {
      this.tyreData = response;
      let i = 0;
      this.tyreData.forEach(function (value, prop, obj) {
        if (i == 0) {
          BookingComponent.bookingComponent.BudgetHeader = Object.getOwnPropertyNames(value);
        }
        i++;
      });
      Helpers.setLoading(false);
    }, err => {
      // Handle error
      Helpers.setLoading(false);
    });
  }

  RefreshvalidDateCalendar() {
    setTimeout(() => {
      $(".datepickerforTripWiseincome").datepicker({
        todayHighlight: true,
        orientation: "auto",
        autoclose: true,
        format: "dd/mm/yyyy",
        setDate: new Date(),
        templates: {
          leftArrow: '<i class="la la-angle-left"></i>',
          rightArrow: '<i class="la la-angle-right"></i>',
        },
      }).on('changeDate', (e) => {
        this.GetReport();
      });
    }, 200);
  }
  handleClick(value) {

    let h1TextMatch = value.match(/<h1[^>]*>(.*?)<\/h1>/);
    let h1Text = h1TextMatch ? h1TextMatch[1].trim() : null;

    if (h1Text) {
      this._appService.GetbyOneId("OperationalReport", "GetVehicleWiseMonthlyCalendarbyTrip", h1Text).subscribe(response => {
        this.tripData = response;
        let i = 0;
        this.tripData.forEach(function (value, prop, obj) {
          if (i === 0) {
            BookingComponent.bookingComponent.TripHeader = Object.getOwnPropertyNames(value);
          }
          i++;
        });
        $("#ModalTripData").modal("show");
        Helpers.setLoading(false);
      }, err => {
        // Handle error here
        console.error('Error fetching data:', err);
      });
    } else {
      console.error('No <h1> tag found with text.');
    }
  }

  getValidate() {
    this._appService
      .GetByOneParam(
        "OrdersByVehicle",
        "GetDriverMobileValidation",
        "DriverMobileNoValidation"
      )
      .subscribe(
        (res) => {
          this.MobValidationDiscription = res.Table[0].Description
          if (res.Table[0].Value == "1") {
            this.MobValidationValue = true;
          } else {
            this.MobValidationValue = false;
          }
          console.log('Validate Response:', this.MobValidationValue);
        },
        (err) => {
          this.toastr.error("Error while Updatating Validation", "Error");
        }
      );
  }

  checkMobileLength(mobileNo: string) {
    const trimmedMobileNo = mobileNo ? mobileNo.trim() : '';

    const requiredLength = parseInt(this.MobValidationDiscription, 10);

    if (trimmedMobileNo.length < requiredLength) {
      this.toastr.warning(`Mobile number must be at least ${requiredLength} digits`, "Error");
    } else if (trimmedMobileNo.length > requiredLength) {
      this.toastr.warning(`Mobile number cannot be more than ${requiredLength} digits`, "Error");
    } else {
      console.log('Mobile number is valid');
    }
  }

}

function Selectbooking(Selectbooking: any, arg1: string) {
  throw new Error("Function not implemented.");
}
